(function () {
    var t,
        e = function (t, e) {
            return function () {
                return t.apply(e, arguments);
            };
        },
        i = function (t, e) {
            function i() {
                this.constructor = t;
            }
            for (var r in e) o.call(e, r) && (t[r] = e[r]);
            return (i.prototype = e.prototype), (t.prototype = new i()), (t.__super__ = e.prototype), t;
        },
        o = {}.hasOwnProperty;
    (theme.classes.FrameworkArticle = (function () {
        function t(t) {
            var i;
            (this.root = t),
                (this.initializeDisqus = e(this.initializeDisqus, this)),
                (this.hideTagInfo = e(this.hideTagInfo, this)),
                (this.load = e(this.load, this)),
                (i = this),
                (i.comments_enabled = i.root.data("comments-enabled")),
                (i.disqus_shortname = i.root.attr("data-disqus-shortname")),
                (i.enable_disqus = i.root.data("enable-disqus")),
                (i.no_tags_displayed = 0 === i.root.find(".article--tag").length),
                i.load();
        }
        return (
            (t.prototype.load = function () {
                var t;
                if (((t = this), t.no_tags_displayed && t.hideTagInfo(), t.enable_disqus && t.comments_enabled)) return t.initializeDisqus();
            }),
            (t.prototype.hideTagInfo = function () {
                var t;
                return (t = this), t.root.find(".article--tag-info").hide();
            }),
            (t.prototype.initializeDisqus = function () {
                var t;
                return (t = this), theme.utils.insertScript("https://" + t.disqus_shortname + ".disqus.com/embed.js");
            }),
            t
        );
    })()),
        (theme.classes.FrameworkBlog = (function () {
            function t(t) {
                var i;
                (this.root = t),
                    (this.initMasonry = e(this.initMasonry, this)),
                    (this.eventListeners = e(this.eventListeners, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.list = i.root.find(".blog--list")),
                    i.root.data("columns") > 1 && i.load();
            }
            return (
                (t.prototype.load = function () {
                    var t;
                    return (
                        (t = this),
                        theme.utils.insertScript(theme.assets.masonry, function () {
                            return "small" !== theme.utils.mqs.current_window && t.initMasonry(), t.eventListeners();
                        })
                    );
                }),
                (t.prototype.eventListeners = function () {
                    var t;
                    return (
                        (t = this),
                        window.addEventListener("theme:utils:mqs:updated", function () {
                            var e;
                            return (
                                (e = t.list.data("masonry-loaded")),
                                "small" === theme.utils.mqs.current_window || e ? ("small" === theme.utils.mqs.current_window && e ? (t.list.attr("data-masonry-loaded", !1), t.masonry.destroy()) : void 0) : t.initMasonry()
                            );
                        })
                    );
                }),
                (t.prototype.initMasonry = function () {
                    var t;
                    return (t = this), t.list.attr("data-masonry-loaded", !0), (t.masonry = new Masonry(t.list.el[0], { itemSelector: ".blog--list--item", percentPosition: !0, horizontalOrder: !0, columnWidth: ".blog--list--item" }));
                }),
                t
            );
        })()),
        (theme.classes.FrameworkCarousel = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.toggleFocusableEl = e(this.toggleFocusableEl, this)),
                    (this.toggleDraggable = e(this.toggleDraggable, this)),
                    (this.getAllFocusableEl = e(this.getAllFocusableEl, this)),
                    (i = this),
                    (i.container = i.root.find(".carousel--x-container")),
                    (i.dot_nav = i.root.find(".carousel--dot-nav")),
                    (i.dot_nav_wrapper = i.root.find(".carousel--dot-nav--wrapper")),
                    (i.dots = i.root.find(".carousel--dot")),
                    (i.height_container = i.root.find(".carousel--y-container")),
                    (i.links = i.container.find("a")),
                    (i.next = i.root.find(".carousel--next")),
                    (i.prev = i.root.find(".carousel--prev")),
                    (i.at_end = i.root.attr("data-at-end")),
                    (i.at_start = i.root.attr("data-at-start")),
                    (i.auto_rotate = i.root.data("auto-rotate")),
                    (i.blocks = i.root.find(".carousel--block")),
                    (i.blocks_per_slide_desktop = i.root.data("blocks-per-slide")),
                    (i.blocks_per_slide_mobile = i.root.data("blocks-per-slide--mobile")),
                    (i.dot_nav_enabled = i.root.attr("data-dot-nav")),
                    (i.rotate_frequency = i.root.attr("data-rotate-frequency")),
                    (i.section_id = i.root.closest("[data-section-id]").data("section-id")),
                    (i.total_blocks = i.blocks.length),
                    (i.transition_type = i.root.attr("data-transition-type")),
                    (i.view = i.root.data("view")),
                    (i.active_slide = 1),
                    (i.autoplay_focus_enabled = !1),
                    (i.slide_pause = !1),
                    (i.container_destination = "0px"),
                    (i.trailing_dot_index = 0),
                    (i.leading_dot_index = 0),
                    (i.dot_nav_offset = 0),
                    (i.draggable = !0),
                    (i.active_blocks = null),
                    (i.auto_slide_timer = null),
                    (i.blocks_per_slide = null),
                    (i.old_active_blocks = null),
                    (i.screen_size_loaded = null),
                    (i.slide_count = null),
                    (i.swipe_state = null),
                    (i.window_width = null),
                    (i.dot_change_type = null),
                    (theme.carousels[i.section_id] = this),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (
                        (t = this),
                        t.resizeListener(),
                        t.initNewScreenSize(),
                        t.getAllFocusableEl(),
                        t.updateActive(),
                        t.setSliderHeight(),
                        t.mouseDownListener(),
                        t.swipeListener(),
                        t.arrowNavListeners(),
                        t.blockListener(),
                        "slide" === t.transition_type && t.loadBlocks(),
                        t.auto_rotate && (t.autoSlide(), t.stopAutoSlideWhenInteracting()),
                        t.root.trigger("loaded")
                    );
                }),
                (i.prototype.initNewScreenSize = function () {
                    var t;
                    if (((t = this), "small" === theme.utils.mqs.current_window)) {
                        if ("small" === t.screen_size_loaded) return;
                        t.dot_nav.attr("data-loaded", "false"),
                            (t.screen_size_loaded = "small"),
                            (t.blocks_per_slide = t.blocks_per_slide_mobile),
                            (t.active_slide = Math.ceil((t.blocks_per_slide_desktop * (t.active_slide - 1) + 1) / t.blocks_per_slide_mobile));
                    } else {
                        if ("medium-large" === t.screen_size_loaded) return;
                        (t.screen_size_loaded = "medium-large"), (t.blocks_per_slide = t.blocks_per_slide_desktop), (t.active_slide = Math.ceil((t.blocks_per_slide_mobile * (t.active_slide - 1) + 1) / t.blocks_per_slide_desktop));
                    }
                    return (t.slide_count = Math.ceil(t.total_blocks / t.blocks_per_slide)), t.createDotNav(), t.dotNavListeners(), t.goToActiveSlide(), t.updateActiveDot();
                }),
                (i.prototype.getAllFocusableEl = function () {
                    var t;
                    return (t = this), (t.focusable_el = theme.utils.getFocusableEl(t.root));
                }),
                (i.prototype.loadBlocks = function () {
                    var e;
                    return (
                        (e = this),
                        e.blocks.each(function (e) {
                            return t(e).attr("data-loaded", "true"), t(e).attr("data-loaded--mobile", "true");
                        })
                    );
                }),
                (i.prototype.blockListener = function () {
                    var e;
                    return (
                        (e = this),
                        e.blocks.on("theme:block:select", function () {
                            return (e.active_slide = Math.ceil((t(this).index() + 1) / e.blocks_per_slide)), e.updateActive(), e.goToActiveSlide(!0), e.updateActiveDot(), e.setSliderHeight();
                        })
                    );
                }),
                (i.prototype.toggleDraggable = function (t) {
                    var e;
                    return null == t && (t = "opposite"), (e = this), "opposite" === t && (e.draggable = !e.draggable), !0 === t ? (e.draggable = !0) : !1 === t ? (e.draggable = !1) : void 0;
                }),
                (i.prototype.checkForActiveModel = function (e) {
                    var i;
                    return this, (i = t(e.closest("model-viewer"))), !(!i.length || i.hasClass("shopify-model-viewer-ui__disabled"));
                }),
                (i.prototype.mouseDownListener = function () {
                    var t;
                    return (
                        (t = this),
                        t.container.on(
                            "mousedown touchstart",
                            function (e) {
                                return (
                                    !(t.checkForActiveModel(e.target) || !t.draggable) &&
                                    ((t.swipe_state = "swipe-started"),
                                    t.reenableClickAfterSwiping(),
                                    t.mouseUpListener(),
                                    (t.slide_pause = !0),
                                    "slide" === t.transition_type
                                        ? ((t.drag_start = e.pageX),
                                          (t.container_x = t.container
                                              .css("transform")
                                              .replace(/[^0-9\-.,]/g, "")
                                              .split(",")[4]),
                                          t.container.attr("data-transition", ""),
                                          t.container.css("transform", "translateX(" + t.container_x + "px)"),
                                          t.dragBegin())
                                        : void 0)
                                );
                            },
                            !0
                        )
                    );
                }),
                (i.prototype.mouseUpListener = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "mouseup." + t.section_id + " touchend." + t.section_id,
                            function () {
                                if (((t.swipe_state = "swipe-ended"), t.removeMouseUpListener(), t.dragEnd(), !0 === t.slide_pause))
                                    return t.container.attr("data-transition", "forwards"), t.container.css("transform", "translateX(" + t.container_destination + ")");
                            },
                            !0
                        )
                    );
                }),
                (i.prototype.removeMouseUpListener = function () {
                    var t;
                    return (t = this), theme.window.off("mouseup." + t.section_id + " touchend." + t.section_id);
                }),
                (i.prototype.dragBegin = function () {
                    var t;
                    return (
                        (t = this),
                        t.root.attr("data-dragging", "true"),
                        theme.window.on(
                            "mousemove." + t.section_id + " touchmove." + t.section_id,
                            function (e) {
                                var i, o;
                                return (
                                    (i = t.container_x - t.drag_start + e.pageX),
                                    (o = t.window_width * (t.slide_count - 1)),
                                    i > 0
                                        ? t.container.css("transform", "translateX(" + i / 4 + "px)")
                                        : i < -1 * o
                                        ? ((i *= -1), (i = o + (i - o) / 4), t.container.css("transform", "translateX(-" + i + "px)"))
                                        : t.container.css("transform", "translateX(" + i + "px)")
                                );
                            },
                            !0
                        )
                    );
                }),
                (i.prototype.dragEnd = function () {
                    var t;
                    return (t = this), t.root.attr("data-dragging", "false"), theme.window.off("mousemove." + t.section_id + " touchmove." + t.section_id);
                }),
                (i.prototype.updateContainerDestination = function (t) {
                    var e;
                    return (e = this), (e.container_destination = ((e.active_slide - 1) / e.slide_count) * -100 + "%");
                }),
                (i.prototype.slideToNext = function (t) {
                    var e, i;
                    return (
                        null == t && (t = !1),
                        (e = this),
                        (e.dot_change_type = "iterate"),
                        e.active_slide !== e.slide_count
                            ? (e.updateActive("next"), (i = "forwards"))
                            : t && e.active_slide === e.slide_count
                            ? ((e.active_slide = 1), e.updateActive(), (i = "forwards"))
                            : e.active_slide === e.slide_count && (i = "backwards"),
                        "slide" === e.transition_type ? (e.updateContainerDestination(), e.container.css("transform", "translateX(" + e.container_destination + ")")) : "fade" === e.transition_type && e.fadeSlides(),
                        e.container.attr("data-transition", i)
                    );
                }),
                (i.prototype.slideToPrev = function () {
                    var t, e;
                    return (
                        (t = this),
                        (t.dot_change_type = "iterate"),
                        1 !== t.active_slide ? (t.updateActive("prev"), (e = "forwards")) : 1 === t.active_slide && (e = "backwards"),
                        "slide" === t.transition_type ? (t.updateContainerDestination(), t.container.css("transform", "translateX(" + t.container_destination + ")")) : "fade" === t.transition_type && t.fadeSlides(),
                        t.container.attr("data-transition", e)
                    );
                }),
                (i.prototype.goToActiveSlide = function (t) {
                    var e;
                    if (
                        (null == t && (t = !1),
                        (e = this),
                        (e.dot_change_type = "init"),
                        "slide" === e.transition_type ? (e.updateContainerDestination(), e.container.css("transform", "translateX(" + e.container_destination + ")")) : "fade" === e.transition_type && e.fadeSlides(),
                        t)
                    )
                        return e.container.attr("data-transition", "forwards");
                }),
                (i.prototype.checkStartEnd = function () {
                    var t;
                    return (
                        (t = this),
                        1 === t.active_slide ? ((t.at_start = !0), t.prev.attr("tabindex", "-1")) : ((t.at_start = !1), t.prev.attr("tabindex", "0")),
                        t.root.attr("data-at-start", t.at_start),
                        t.active_slide === t.slide_count ? ((t.at_end = !0), t.next.attr("tabindex", "-1")) : ((t.at_end = !1), t.next.attr("tabindex", "0")),
                        t.root.attr("data-at-end", t.at_end)
                    );
                }),
                (i.prototype.updateActive = function (e) {
                    var i, o, r;
                    return (
                        null == e && (e = !1),
                        (i = this),
                        "next" === e
                            ? ((i.active_slide += 1), (!1 === i.autoplay_focus_enabled && i.auto_rotate) || i.prev.focus(0))
                            : "prev" === e && ((i.active_slide -= 1), (!1 === i.autoplay_focus_enabled && i.auto_rotate) || i.next.focus(0)),
                        (r = (i.active_slide - 1) * i.blocks_per_slide),
                        (o = r + i.blocks_per_slide),
                        null !== i.active_blocks && (i.old_active_blocks = i.active_blocks),
                        (i.active_blocks = t(Array.from(i.blocks.el).slice(r, o))),
                        i.toggleFocusableEl(e),
                        i.checkStartEnd()
                    );
                }),
                (i.prototype.toggleFocusableEl = function (t) {
                    var e;
                    if (((e = this), e.disabled_el && e.disabled_el.attr("tabindex", "0"), (e.disabled_el = theme.utils.getFocusableEl(e.blocks.not(e.active_blocks))), e.disabled_el)) return e.disabled_el.attr("tabindex", "-1");
                }),
                (i.prototype.setSliderHeight = function () {
                    var e, i;
                    return (
                        (e = this),
                        (i = 0),
                        e.active_blocks.each(function (e) {
                            var o;
                            if ((o = t(e).outerHeight()) > i) return (i = o);
                        }),
                        e.height_container.css("height", i + "px")
                    );
                }),
                (i.prototype.swipeListener = function () {
                    var e;
                    return (
                        (e = this),
                        t(document).on("theme:swipe:left", function () {
                            if ("swipe-started" === e.swipe_state) return (e.slide_pause = !1), e.slideToNext(), e.setSliderHeight(), e.updateActiveDot(), e.preventClickWhenSwiping();
                        }),
                        t(document).on("theme:swipe:right", function () {
                            if ("swipe-started" === e.swipe_state) return (e.slide_pause = !1), e.slideToPrev(), e.setSliderHeight(), e.updateActiveDot(), e.preventClickWhenSwiping();
                        })
                    );
                }),
                (i.prototype.createDotNav = function () {
                    var t, e, i, o;
                    if (((t = this), t.dot_nav_enabled && 1 !== t.slide_count)) {
                        for (t.dot_nav.empty(), i = 1, o = t.slide_count; 1 <= o ? i <= o : i >= o; 1 <= o ? ++i : --i) (e = theme.utils.parseHtml('<div class="carousel--dot"></div>')), t.dot_nav.append(e);
                        return (t.dots = t.root.find(".carousel--dot")), "small" === theme.utils.mqs.current_window ? t.dots.attr("tabindex", "0") : void 0;
                    }
                }),
                (i.prototype.updateActiveDot = function () {
                    var t;
                    return (
                        (t = this), t.dots.attr("data-active", "false"), t.dots.eq(t.active_slide - 1).attr("data-active", "true"), t.dots.length > 5 ? t.updateTrailingLeadingDots() : (t.alignDots(), t.dot_nav.attr("data-loaded", "true"))
                    );
                }),
                (i.prototype.updateTrailingLeadingDots = function () {
                    var t, e, i;
                    return (
                        (t = this),
                        t.active_slide === t.leading_dot_index
                            ? (t.leading_dot_index++,
                              t.trailing_dot_index++,
                              (e = t.dots.eq(t.active_slide - 1)),
                              e.attr("data-position", ""),
                              (i = e.offset().left),
                              setTimeout(function () {
                                  if (
                                      (t.dots.eq(t.active_slide - 4).attr("data-position", "trailing-1"),
                                      t.dots.eq(t.active_slide - 5).attr("data-position", "trailing-2"),
                                      t.active_slide >= 5 && t.dots.filter(":nth-child(-n+" + (t.active_slide - 5) + ")").attr("data-position", "hidden"),
                                      t.dots.eq(t.active_slide).attr("data-position", "leading-1"),
                                      t.dots.eq(t.active_slide + 1).attr("data-position", "leading-2"),
                                      t.dots.filter(":nth-child(n+" + (t.active_slide + 3) + ")").attr("data-position", "hidden"),
                                      t.alignDots(i),
                                      "init" === t.dot_change_type)
                                  )
                                      return t.alignDots(), t.dot_nav.attr("data-loaded", "true");
                              }, 0),
                              setTimeout(function () {
                                  return t.dot_nav.attr("data-transition", "true"), t.alignDots();
                              }, 200))
                            : t.active_slide === t.trailing_dot_index
                            ? (t.leading_dot_index--,
                              t.trailing_dot_index--,
                              (e = t.dots.eq(t.active_slide - 1)),
                              e.attr("data-position", ""),
                              e.offset().left,
                              setTimeout(function () {
                                  if (
                                      (t.dots.eq(t.active_slide - 2).attr("data-position", "trailing-1"),
                                      t.dots.eq(t.active_slide - 3).attr("data-position", "trailing-2"),
                                      t.dots.eq(t.active_slide + 2).attr("data-position", "leading-1"),
                                      t.dots.eq(t.active_slide + 3).attr("data-position", "leading-2"),
                                      t.dots.filter(":nth-child(n+" + (t.active_slide + 5) + ")").attr("data-position", "hidden"),
                                      t.active_slide >= 4 && t.dots.filter(":nth-child(-n+" + (t.active_slide - 2) + ")").attr("data-position", "hidden"),
                                      t.alignDots(i),
                                      "init" === t.dot_change_type)
                                  )
                                      return t.alignDots(), t.dot_nav.attr("data-loaded", "true");
                              }, 0),
                              setTimeout(function () {
                                  return t.dot_nav.attr("data-transition", "true"), t.alignDots();
                              }, 200))
                            : "init" === t.dot_change_type
                            ? (t.dots.attr("data-position", ""),
                              t.slide_count - t.active_slide <= 2
                                  ? ((t.leading_dot_index = t.active_slide), (t.trailing_dot_index = t.active_slide - 3))
                                  : t.slide_count - t.active_slide > 2 && ((t.trailing_dot_index = t.active_slide), (t.leading_dot_index = t.active_slide + 3)),
                              t.updateTrailingLeadingDots())
                            : void 0
                    );
                }),
                (i.prototype.alignDots = function (t) {
                    var e, i, o;
                    return (
                        null == t && (t = !1),
                        (e = this),
                        o
                            ? ((o = t - active.offset().left), (i = e.dot_nav_offset + o + "px"), e.dot_nav.attr("data-transition", "false"), e.dot_nav.css("transform", "translateX(" + i + ")"))
                            : ((e.dot_nav_offset = (e.root.width() - e.dot_nav.width()) / 2), e.dot_nav.css("transform", "translateX(" + e.dot_nav_offset + "px)"))
                    );
                }),
                (i.prototype.dotNavListeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.dots.off("click." + e.section_id + " keydown." + e.section_id),
                        e.dots.on("click." + e.section_id + " keydown." + e.section_id, function () {
                            if ("keydown" !== event.type || "Enter" === event.key) return (e.active_slide = t(this).index() + 1), e.updateActive(), e.goToActiveSlide(!0), e.setSliderHeight(), e.updateActiveDot();
                        })
                    );
                }),
                (i.prototype.arrowNavListeners = function () {
                    var t;
                    return (
                        (t = this),
                        t.prev.on("click keydown", function (e) {
                            if ("keydown" !== e.type || "Enter" === e.key) return t.slideToPrev(), t.setSliderHeight(), t.updateActiveDot();
                        }),
                        t.next.on("click keydown", function (e) {
                            if ("keydown" !== e.type || "Enter" === e.key) return t.slideToNext(), t.setSliderHeight(), t.updateActiveDot();
                        })
                    );
                }),
                (i.prototype.resizeListener = function () {
                    var t;
                    return (
                        (t = this),
                        (t.window_width = document.documentElement.clientWidth),
                        theme.window.on(
                            "resize." + t.section_id,
                            theme.utils.debounce(100, function () {
                                return (
                                    (t.window_width = document.documentElement.clientWidth),
                                    t.initNewScreenSize(),
                                    t.updateActive(),
                                    t.setSliderHeight(),
                                    t.alignDots(),
                                    "small" === theme.utils.mqs.current_window ? t.dots.attr("tabindex", "0") : t.dots.removeAttr("tabindex")
                                );
                            })
                        )
                    );
                }),
                (i.prototype.reenableClickAfterSwiping = function () {
                    var t;
                    return (t = this), t.links.off("click." + t.section_id);
                }),
                (i.prototype.preventClickWhenSwiping = function () {
                    var t;
                    return (
                        (t = this),
                        t.links.on("click." + t.section_id, function (t) {
                            return t.preventDefault();
                        })
                    );
                }),
                (i.prototype.autoSlide = function () {
                    var t;
                    return (
                        (t = this),
                        (t.auto_slide_timer = setInterval(function () {
                            return t.slideToNext(!0), t.updateActiveDot(), t.setSliderHeight();
                        }, 1e3 * t.rotate_frequency))
                    );
                }),
                (i.prototype.stopAutoSlideWhenInteracting = function () {
                    var t;
                    return (
                        (t = this),
                        t.root.on(
                            "click touchstart",
                            function () {
                                return (t.autoplay_focus_enabled = !0), clearInterval(t.auto_slide_timer), t.root.off("click touchstart");
                            },
                            !0
                        ),
                        t.focusable_el.on(
                            "focus",
                            function () {
                                return (t.autoplay_focus_enabled = !0), clearInterval(t.auto_slide_timer), t.focusable_el.off("focus");
                            },
                            !0
                        )
                    );
                }),
                (i.prototype.fadeSlides = function () {
                    var e;
                    if (((e = this), null !== e.active_blocks && null !== e.old_active_blocks))
                        return (
                            e.blocks.attr("data-active", ""),
                            e.blocks.attr("data-loaded", "false"),
                            e.blocks.attr("data-loaded--mobile", "false"),
                            e.old_active_blocks.each(function (e) {
                                return t(e).attr("data-active", "old"), t(e).css("left", "0%");
                            }),
                            e.active_blocks.each(function (i, o) {
                                var r;
                                return (r = (100 / e.total_blocks) * o + "%"), t(i).attr("data-active", "new"), t(i).css("left", r);
                            })
                        );
                }),
                (i.prototype.updateThenGoToActiveSlide = function (t) {
                    var e;
                    return (e = this), (e.active_slide = t), e.goToActiveSlide(), e.setSliderHeight(), e.updateActiveDot();
                }),
                i
            );
        })()),
        (theme.classes.FrameworkCart = (function () {
            function i(i) {
                var o;
                (this.root = i),
                    (this.renderDynamicCheckoutButtons = e(this.renderDynamicCheckoutButtons, this)),
                    (this.updateTotals = e(this.updateTotals, this)),
                    (this.updateAllHasItems = e(this.updateAllHasItems, this)),
                    (this.addItem = e(this.addItem, this)),
                    (this.swapInImages = e(this.swapInImages, this)),
                    (this.getHtml = e(this.getHtml, this)),
                    (this.updateHtml = e(this.updateHtml, this)),
                    (this.htmlListener = e(this.htmlListener, this)),
                    (this.updateAllHtml = e(this.updateAllHtml, this)),
                    (this.updateNote = e(this.updateNote, this)),
                    (this.noteTypingListener = e(this.noteTypingListener, this)),
                    (this.updateQuantity = e(this.updateQuantity, this)),
                    (this.clearRequests = e(this.clearRequests, this)),
                    (this.toggleLoadingDisplay = e(this.toggleLoadingDisplay, this)),
                    (this.toggleLoadingOnSubmit = e(this.toggleLoadingOnSubmit, this)),
                    (this.appendErrorMessage = e(this.appendErrorMessage, this)),
                    (this.removeItem = e(this.removeItem, this)),
                    (this.removeButtonListener = e(this.removeButtonListener, this)),
                    (this.minusButtonListener = e(this.minusButtonListener, this)),
                    (this.plusButtonListener = e(this.plusButtonListener, this)),
                    (this.inputBoxListener = e(this.inputBoxListener, this)),
                    (this.eventListeners = e(this.eventListeners, this)),
                    (this.getOtherCarts = e(this.getOtherCarts, this)),
                    (o = this),
                    (o.is_drawer = o.root.data("is-drawer")),
                    (o.other_carts = o.getOtherCarts()),
                    (o.quantity_request = {}),
                    (o.quantity_timer = {}),
                    (o.total_item_count = t(".cart--external--total-items")),
                    (o.total_price = t(".cart--external--total-price")),
                    (o.view = o.root.attr("data-view")),
                    o.updateTotals(),
                    o.htmlListener(),
                    o.eventListeners(),
                    o.renderDynamicCheckoutButtons();
            }
            return (
                (i.prototype.getOtherCarts = function () {
                    var e;
                    return (e = this), t('[data-js-class="Cart"]').not(e.root);
                }),
                (i.prototype.eventListeners = function () {
                    var t;
                    return (t = this), t.inputBoxListener(), t.plusButtonListener(), t.minusButtonListener(), t.removeButtonListener(), t.toggleLoadingOnSubmit(), t.noteTypingListener();
                }),
                (i.prototype.inputBoxListener = function () {
                    var e, i;
                    return (
                        (e = this),
                        (i = e.root.find(".cart--quantity--input")),
                        i.on("keydown", function (t) {
                            if ((t.which < 48 || t.which > 57) && 8 !== t.which && 37 !== t.which && 39 !== t.which && 9 !== t.which) return t.preventDefault();
                        }),
                        i.on("focusout", function (i) {
                            var o, r;
                            return (
                                (o = t(this).closest(".cart--item").data("line-num")),
                                e.toggleLoadingDisplay(o),
                                e.clearRequests(o),
                                (r = isNaN(parseInt(t(this).val())) ? 1 : parseInt(t(this).val())),
                                0 === r
                                    ? e.removeItem(o)
                                    : e.updateQuantity(o, r, 0, function (t, i) {
                                          return t
                                              ? e.updateAllHtml(function () {})
                                              : e.updateAllHtml(function () {
                                                    return e.appendErrorMessage(o, i);
                                                });
                                      })
                            );
                        })
                    );
                }),
                (i.prototype.plusButtonListener = function () {
                    var e, i;
                    return (
                        (e = this),
                        (i = e.root.find(".cart--item--quantity .plus")),
                        i.on("click", function (i) {
                            var o, r, n;
                            return (
                                i.preventDefault(),
                                (o = t(this).prev("input")),
                                (r = t(this).closest(".cart--item").data("line-num")),
                                (n = isNaN(parseInt(o.val())) ? 1 : parseInt(o.val()) + 1),
                                o.val(n),
                                e.toggleLoadingDisplay(r),
                                e.clearRequests(r),
                                e.updateQuantity(r, n, 700, function (t, i) {
                                    return t
                                        ? e.updateAllHtml(function () {})
                                        : e.updateAllHtml(function () {
                                              return e.appendErrorMessage(r, i);
                                          });
                                }),
                                i.preventDefault(),
                                i.stopPropagation()
                            );
                        })
                    );
                }),
                (i.prototype.minusButtonListener = function () {
                    var e, i;
                    return (
                        (e = this),
                        (i = e.root.find(".cart--item--quantity .minus")),
                        i.on("click", function (i) {
                            var o, r, n;
                            return (
                                i.preventDefault(),
                                (o = t(this).siblings("input")),
                                (r = t(this).closest(".cart--item").data("line-num")),
                                (n = isNaN(parseInt(o.val())) ? 1 : parseInt(o.val()) - 1),
                                n < 1 && (n = 1),
                                o.val(n),
                                e.toggleLoadingDisplay(r),
                                e.clearRequests(r),
                                e.updateQuantity(r, n, 700, function (t) {
                                    if (t) return e.updateAllHtml(function () {});
                                }),
                                i.preventDefault(),
                                i.stopPropagation()
                            );
                        })
                    );
                }),
                (i.prototype.removeButtonListener = function () {
                    var e, i;
                    return (
                        (e = this),
                        (i = e.root.find(".cart--item--remove")),
                        i.on("click", function (i) {
                            var o;
                            return i.preventDefault(), (o = t(this).closest(".cart--item").data("line-num")), e.toggleLoadingDisplay(o), e.clearRequests(o), e.removeItem(o), i.preventDefault(), i.stopPropagation();
                        })
                    );
                }),
                (i.prototype.removeItem = function (t) {
                    var e;
                    return (
                        (e = this),
                        e.updateQuantity(t, 0, 0, function (t) {
                            if (t) return e.updateAllHtml(function () {});
                        })
                    );
                }),
                (i.prototype.appendErrorMessage = function (t, e) {
                    var i, o, r;
                    return (
                        (i = this),
                        (r = i.root.find(".cart--item[data-line-num='" + t + "']")),
                        (o = theme.utils.parseHtml("<div class='cart--error' data-item='small-text'> " + e + " </div>", ".cart--error")),
                        r.find(".cart--item--title").append(o)
                    );
                }),
                (i.prototype.toggleLoadingOnSubmit = function () {
                    var e;
                    return (
                        (e = this),
                        (e.checkout_button = e.root.find(".cart--checkout-button button")),
                        e.checkout_button.on("click", function () {
                            return t(this).attr("data-loading", !0);
                        })
                    );
                }),
                (i.prototype.toggleLoadingDisplay = function (t) {
                    var e, i;
                    return (
                        (e = this),
                        (i = e.root.find(".cart--item[data-line-num='" + t + "'] input")),
                        i.attr("data-loading", "true"),
                        e.checkout_button.attr("disabled", !0),
                        e.root.find(".cart--additional-buttons").css("visibility", "hidden")
                    );
                }),
                (i.prototype.clearRequests = function (t) {
                    var e;
                    if (((e = this), e.quantity_request.line_num && e.quantity_request.line_num.abort(), e.quantity_timer.line_num)) return clearTimeout(e.quantity_timer.line_num);
                }),
                (i.prototype.updateQuantity = function (t, e, i, o) {
                    var r, n;
                    return (
                        (r = this),
                        r.root.find(".cart--error").remove(),
                        (n = function () {
                            var i;
                            return (
                                (i = new XMLHttpRequest()),
                                (i.onload = function () {
                                    var n;
                                    if (i.status >= 200 && i.status < 300)
                                        return 0 === e ? (o(!0), void r.updateTotals()) : ((n = JSON.parse(i.response).items[t - 1].quantity), null === n || n >= e ? (o(!0), r.updateTotals()) : o(!1, theme.translations.all_items_added));
                                }),
                                (i.onerror = function () {
                                    return console.log(i.statusText + ": quantity update request failed!"), o(!1);
                                }),
                                i.open("POST", theme.urls.cart_change + ".js"),
                                i.setRequestHeader("Content-Type", "application/json"),
                                i.send(JSON.stringify({ line: t, quantity: e })),
                                (r.quantity_request.line_num = i)
                            );
                        }),
                        (r.quantity_timer.line_num = setTimeout(n, i))
                    );
                }),
                (i.prototype.noteTypingListener = function () {
                    var e, i;
                    return (
                        (e = this),
                        (i = e.root.find(".cart--notes--textarea")),
                        i.on("input", function () {
                            return e.note_request && e.note_request.abort(), e.note_timer && clearTimeout(e.note_timer), e.updateNote(t(this).val());
                        })
                    );
                }),
                (i.prototype.updateNote = function (t) {
                    var e, i;
                    return (
                        (e = this),
                        (i = function () {
                            var i;
                            return (
                                (i = new XMLHttpRequest()),
                                (i.onload = function () {
                                    if (i.status >= 200 && i.status < 300) return e.other_carts.trigger("update-html");
                                }),
                                (i.onerror = function () {
                                    return console.log(i.statusText + ": cart note update request failed!");
                                }),
                                i.open("POST", theme.urls.cart + "/update.js"),
                                i.setRequestHeader("Content-Type", "application/json"),
                                i.send(JSON.stringify({ note: t })),
                                (e.note_request = i)
                            );
                        }),
                        (e.note_timer = setTimeout(i, 350))
                    );
                }),
                (i.prototype.updateAllHtml = function (t) {
                    var e;
                    return (e = this), e.updateHtml(t), e.other_carts.trigger("update-html");
                }),
                (i.prototype.htmlListener = function () {
                    var t;
                    return (
                        (t = this),
                        t.root.on("update-html", function () {
                            return t.updateHtml(function () {});
                        })
                    );
                }),
                (i.prototype.updateHtml = function (t) {
                    var e;
                    return (
                        (e = this),
                        e.getHtml(e.view, function (i) {
                            var o, r, n;
                            return (
                                (n = e.root.find(".cart--form")),
                                (r = i.find(".cart--form")),
                                (r = e.swapInImages(n, r)),
                                n.replaceWith(r),
                                e.eventListeners(),
                                t(),
                                e.is_drawer && (theme.partials.OffCanvas.unload(), theme.partials.OffCanvas.load()),
                                (o = new Event("theme:cart:updated")),
                                window.dispatchEvent(o)
                            );
                        })
                    );
                }),
                (i.prototype.getHtml = function (t, e) {
                    var i, o, r;
                    return (
                        (i = this),
                        (r = theme.urls.cart + "?view=ajax--desktop"),
                        "mobile" === t && i.is_drawer ? (r = theme.urls.cart + "?view=ajax--drawer") : "mobile" === t && (r = theme.urls.cart + "?view=ajax--mobile"),
                        (o = new XMLHttpRequest()),
                        (o.onload = function () {
                            var t;
                            o.status >= 200 && o.status < 300 && ((t = theme.utils.parseHtml(o.response, ".cart--root")), e(t));
                        }),
                        (o.onerror = function () {
                            console.log(o.statusText + ": cart HTML update request failed!"), e(!1);
                        }),
                        o.open("GET", r),
                        o.send()
                    );
                }),
                (i.prototype.swapInImages = function (e, i) {
                    var o;
                    return (
                        this,
                        (o = i.find(".cart--item")),
                        o.each(function (o) {
                            var r, n, s, a, l;
                            if (
                                ((l = t(o).attr("data-variant-id")),
                                (r = t(o).find(".cart--item--image")),
                                (n = i.find("[data-variant-id='" + l + "'] .cart--item--image").index(r)),
                                (a = e.find("[data-variant-id='" + l + "']").eq(n)),
                                a.el.length)
                            )
                                return (s = a.find(".cart--item--image")), r.replaceWith(s);
                        }),
                        i
                    );
                }),
(i.prototype.addItem = function (form, callback) {
    var self = this;
    var xhr = new XMLHttpRequest();

    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
            callback(true);
            self.updateAllHasItems(1, true);
            self.updateTotals();
        } else {
            callback(false, xhr.statusText);
        }
    };

    xhr.onerror = function () {
        console.log(xhr.statusText + ": cart add item request failed!");
        callback(false, xhr.statusText);
    };

    xhr.open("POST", theme.urls.cart_add + ".js");

    // DO NOT set Content-Type manually
    var formData = new FormData(form.el[0]);

    xhr.send(formData);
}),
                (i.prototype.updateAllHasItems = function (t, e) {
                    var i, o;
                    return null == e && (e = !1), (i = this), (o = !1), (t > 0 || e) && (o = !0), i.root.attr("data-has-items", o), i.other_carts.attr("data-has-items", o);
                }),
                (i.prototype.updateTotals = function () {
                    var t, e;
                    return (
                        (t = this),
                        (e = new XMLHttpRequest()),
                        (e.onload = function () {
                            var i, o, r;
                            if (e.status >= 200 && e.status < 300)
                                return (o = JSON.parse(e.response)), (r = theme.utils.formatMoney(o.total_price)), (i = o.item_count), t.updateAllHasItems(i), t.total_price.html(r), t.total_item_count.text(i), t.updateTotalsComplete(i);
                        }),
                        (e.onerror = function () {
                            return console.log(e.statusText + ": error updating cart totals!");
                        }),
                        e.open("GET", theme.urls.cart + ".js"),
                        e.send()
                    );
                }),
                (i.prototype.renderDynamicCheckoutButtons = function () {
                    if ((this, window.location.pathname === theme.urls.cart && (t(".off-canvas--right-sidebar .cart--additional-buttons").remove(), "small" === theme.utils.mqs.current_window)))
                        return t('[data-view="desktop"] .cart--additional-buttons').remove();
                }),
                i
            );
        })()),
        (theme.classes.FrameworkCollection = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.clearTagFilter = e(this.clearTagFilter, this)),
                    (this.clearSortByFilter = e(this.clearSortByFilter, this)),
                    (this.clearActiveOptionsListener = e(this.clearActiveOptionsListener, this)),
                    (this.activeSortByListener = e(this.activeSortByListener, this)),
                    (this.activeTagListeners = e(this.activeTagListeners, this)),
                    (this.formatProducts = e(this.formatProducts, this)),
                    (this.renderGridHtml = e(this.renderGridHtml, this)),
                    (this.getGridHtml = e(this.getGridHtml, this)),
                    (this.toggleActiveOptionContainer = e(this.toggleActiveOptionContainer, this)),
                    (this.getAjaxUrl = e(this.getAjaxUrl, this)),
                    (this.renderActiveTags = e(this.renderActiveTags, this)),
                    (this.renderActiveSortBy = e(this.renderActiveSortBy, this)),
                    (this.showLoadingView = e(this.showLoadingView, this)),
                    (this.checkActiveOptions = e(this.checkActiveOptions, this)),
                    (this.refineLinkListener = e(this.refineLinkListener, this)),
                    (this.sortByLinkListener = e(this.sortByLinkListener, this)),
                    (this.collectionListListener = e(this.collectionListListener, this)),
                    (this.resetListener = e(this.resetListener, this)),
                    (this.menuToggleListeners = e(this.menuToggleListeners, this)),
                    (this.moveFilterOffCanvas = e(this.moveFilterOffCanvas, this)),
                    (this.matchImageHeights = e(this.matchImageHeights, this)),
                    (this.layoutListener = e(this.layoutListener, this)),
                    (this.setLayout = e(this.setLayout, this)),
                    (this.initLayout = e(this.initLayout, this)),
                    (this.hoverImagesLoaded = e(this.hoverImagesLoaded, this)),
                    (this.resizeListeners = e(this.resizeListeners, this)),
                    (this.sectionListeners = e(this.sectionListeners, this)),
                    (this.initFilter = e(this.initFilter, this)),
                    (this.initNavigation = e(this.initNavigation, this)),
                    (this.initGrid = e(this.initGrid, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (t = this), t.initGrid(), t.initNavigation(), t.initFilter(), t.sectionListeners(), t.resizeListeners();
                }),
                (i.prototype.initGrid = function () {
                    var t;
                    if (
                        ((t = this),
                        (t.body = t.root.find(".collection--body--root")),
                        (t.grid_container = t.body.find(".collection--body--grid")),
                        (t.max_columns = t.body.data("max-columns")),
                        (t.num_columns = t.grid_container.data("columns")),
                        (t.pagination_link = t.body.find('[href="#collection-pagination"]')),
                        (t.spinner = t.body.find(".collection--body--spinner")),
                        (t.pagination = t.body.find(".collection--body--pagination")),
                        (t.url = t.body.attr("data-url")),
                        theme.settings.hover_image_enabled)
                    )
                        return t.hoverImagesLoaded();
                }),
                (i.prototype.initNavigation = function () {
                    var t;
                    return (
                        (t = this),
                        (t.navigation = t.root.find(".collection--navigation--root")),
                        (t.active_options_container = t.navigation.find(".collection--navigation--options-container")),
                        (t.active_sort_by_container = t.navigation.find(".collection--navigation--active-sort-by")),
                        (t.active_tags_wrapper = t.navigation.find(".collection--navigation--active-options")),
                        (t.clear_tags_button = t.navigation.find(".collection--navigation--options-clear")),
                        (t.layout_buttons = t.navigation.find(".collection--navigation--layout > *")),
                        (t.small_layout_button = t.navigation.find(".collection--navigation--layout-small")),
                        (t.tag_template = t.navigation.find(".collection--navigation--active-tag")),
                        (t.tag_template_html = t.tag_template.outerHtml()),
                        t.layout_buttons.length && t.max_columns > 2 ? (t.initLayout(), t.setLayout(), t.layoutListener()) : (t.layout_buttons.hide(), t.matchImageHeights())
                    );
                }),
                (i.prototype.initFilter = function () {
                    var t;
                    if (((t = this), (t.filter = t.root.find(".collection--filter--root")), t.filter.length))
                        return (
                            (t.browse_links = t.filter.find(".collection--filter--browse-link")),
                            (t.menu_toggles = t.filter.find("[aria-expanded]")),
                            (t.refine_links = t.filter.find(".collection--filter--refine-link")),
                            (t.sort_by_links = t.filter.find(".collection--filter--sort-by-link")),
                            (t.reset_button = t.filter.find(".collection--filter--reset")),
                            t.moveFilterOffCanvas(),
                            t.menuToggleListeners(),
                            t.resetListener(),
                            t.browse_links.length && t.collectionListListener(),
                            t.sort_by_links.length && t.sortByLinkListener(),
                            t.refine_links.length && t.refineLinkListener(),
                            t.sort_by_links.length || t.refine_links.length ? (t.checkActiveOptions(), t.activeSortByListener(), t.clearActiveOptionsListener()) : void 0
                        );
                }),
                (i.prototype.sectionListeners = function () {
                    var t;
                    return (
                        (t = this),
                        t.root.on("shopify:section:load", function () {
                            return theme.partials.OffCanvas.unload(), theme.partials.OffCanvas.load(), t.initGrid(), t.initNavigation(), t.initFilter(), theme.partials.FrameworkSearch.searchLinks();
                        })
                    );
                }),
                (i.prototype.resizeListeners = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "resize.Collection",
                            theme.utils.debounce(100, function () {
                                return t.matchImageHeights();
                            })
                        )
                    );
                }),
                (i.prototype.hoverImagesLoaded = function () {
                    var e;
                    return (
                        (e = this),
                        e.body.find(".product--hover-image").each(function (e) {
                            var i;
                            return (
                                (i = t(e)),
                                theme.utils.imagesLoaded(i, function () {
                                    var t;
                                    return (t = i.closest('[data-hover-image="true"]')), t.attr("data-hover-image", "loaded");
                                })
                            );
                        })
                    );
                }),
                (i.prototype.initLayout = function () {
                    var t;
                    return (t = this), t.layout_buttons.removeAttr("style"), t.small_layout_button.attr("data-column-size", t.max_columns);
                }),
                (i.prototype.setLayout = function () {
                    var t, e;
                    return (
                        (t = this),
                        (e = parseInt(localStorage.getItem(theme.local_storage.collection_view))),
                        (!e || (2 !== e && e !== t.num_columns)) && ((e = t.num_columns), localStorage.setItem(theme.local_storage.collection_view, e)),
                        t.grid_container.attr("data-columns", e),
                        t.layout_buttons.attr("data-active", !1),
                        t.layout_buttons.filter("[data-column-size='" + e + "']").attr("data-active", !0),
                        t.matchImageHeights()
                    );
                }),
                (i.prototype.layoutListener = function () {
                    var e;
                    return (
                        (e = this),
                        e.layout_buttons.off("click keydown"),
                        e.layout_buttons.on("click keydown", function (i) {
                            if ("keydown" !== i.type || "Enter" === i.key) return localStorage.setItem(theme.local_storage.collection_view, t(this).data("column-size")), e.setLayout();
                        })
                    );
                }),
                (i.prototype.matchImageHeights = function () {
                    var t;
                    return (t = this), theme.utils.matchImageHeights(t.grid_container, t.body.find(".product--root"), ".product--image-wrapper", t.body.find(".featured-content--root"));
                }),
                (i.prototype.moveFilterOffCanvas = function () {
                    var e;
                    return (e = this), t('[data-view="collection-filter"]').empty().append(e.filter);
                }),
                (i.prototype.menuToggleListeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.menu_toggles.on("click keydown", function (i) {
                            var o, r, n;
                            if ("keydown" !== i.type || "Enter" === i.key)
                                return (
                                    (r = e.menu_toggles.not(t(this))),
                                    r.attr("aria-expanded", !1),
                                    r.siblings('[class*="menu"]').attr("data-transition", "fade-out"),
                                    (o = "true" !== t(this).attr("aria-expanded")),
                                    t(this).attr("aria-expanded", o),
                                    (n = t(this).siblings('[class*="menu"]')),
                                    o
                                        ? setTimeout(function () {
                                              return n.attr("data-transition", "fade-in");
                                          }, 0)
                                        : n.attr("data-transition", "fade-out")
                                );
                        })
                    );
                }),
                (i.prototype.resetListener = function () {
                    var e;
                    return (
                        (e = this),
                        e.reset_button.on("click keydown", function (i) {
                            if ("keydown" !== i.type || "Enter" === i.key)
                                return (
                                    e.clearSortByFilter(),
                                    e.current_active_tags
                                        ? e.current_active_tags.each(function (i) {
                                              return e.clearTagFilter(t(i).attr("data-handle"));
                                          })
                                        : void 0
                                );
                        })
                    );
                }),
                (i.prototype.collectionListListener = function () {
                    var e;
                    return (
                        (e = this),
                        e.browse_links.on("click keydown", function (i) {
                            var o, r;
                            if ("keydown" !== i.type || "Enter" === i.key)
                                return (
                                    (r = "true" === t(this).attr("data-active")),
                                    e.browse_links.attr("data-active", !1),
                                    r ? (o = theme.urls.all_products_collection) : ((o = t(this).data("value")), t(this).attr("data-active", !0)),
                                    (location.href = "" + location.origin + o),
                                    setTimeout(function () {
                                        return theme.partials.OffCanvas.closeRight();
                                    }, 300)
                                );
                        })
                    );
                }),
                (i.prototype.sortByLinkListener = function () {
                    var e;
                    return (
                        (e = this),
                        e.sort_by_links.on("click keydown", function (i) {
                            var o;
                            if ("keydown" !== i.type || "Enter" === i.key)
                                return (
                                    e.showLoadingView(),
                                    (o = "true" === t(this).attr("data-active")),
                                    e.sort_by_links.attr("data-active", !1),
                                    t(this).attr("data-active", !o),
                                    o ? ((e.sort_by_param = ""), e.active_sort_by_container.hide()) : e.renderActiveSortBy(t(this)),
                                    e.getAjaxUrl()
                                );
                        })
                    );
                }),
                (i.prototype.refineLinkListener = function () {
                    var e;
                    return (
                        (e = this),
                        e.refine_links.on("click keydown", function (i) {
                            var o;
                            if ("keydown" !== i.type || "Enter" === i.key)
                                return (
                                    e.showLoadingView(),
                                    e.active_tags_wrapper.find(".collection--navigation--active-tag").remove(),
                                    (o = "true" === t(this).attr("data-active")),
                                    t(this).attr("data-active", !o),
                                    e.renderActiveTags(),
                                    e.getAjaxUrl()
                                );
                        })
                    );
                }),
                (i.prototype.checkActiveOptions = function () {
                    var t, e;
                    return (t = this), t.tag_template.hide(), (e = t.sort_by_links.filter('[data-active="true"]')), e.length ? t.renderActiveSortBy(e) : (t.sort_by_param = ""), t.renderActiveTags(), t.toggleActiveOptionContainer();
                }),
                (i.prototype.showLoadingView = function () {
                    var t;
                    return (t = this), t.grid_container.empty(), t.grid_container.hide(), t.pagination.hide(), t.spinner.css("display", "flex");
                }),
                (i.prototype.renderActiveSortBy = function (t) {
                    var e;
                    return (
                        (e = this),
                        (e.sort_by_param = "?sort_by=" + t.attr("data-value")),
                        e.active_sort_by_container.find("span").text(t.data("name")),
                        e.active_sort_by_container.attr("data-value", t.attr("data-value")),
                        e.active_sort_by_container.show()
                    );
                }),
                (i.prototype.renderActiveTags = function () {
                    var e, i, o, r;
                    if (
                        ((e = this),
                        (e.active_tag_names = []),
                        (e.active_tag_handles = []),
                        e.refine_links.filter('[data-active="true"]').each(function (i) {
                            return e.active_tag_names.push(t(i).text().trim()), e.active_tag_handles.push(t(i).attr("data-handle"));
                        }),
                        e.active_tag_names.length > 0)
                    ) {
                        for (i = 0; i < e.active_tag_names.length; )
                            (r = e.tag_template_html.replace("<span></span>", e.active_tag_names[i]).replace('data-handle="template"', "data-handle='" + e.active_tag_handles[i] + "'")),
                                (o = theme.utils.parseHtml(r, ".collection--navigation--active-tag")),
                                e.active_tags_wrapper.prepend(o),
                                i++;
                        return e.activeTagListeners();
                    }
                }),
                (i.prototype.getAjaxUrl = function () {
                    var t;
                    return (t = this), (t.ajax_url = t.url + "/" + t.active_tag_handles.join("+") + t.sort_by_param), history.replaceState({}, "", t.ajax_url), t.getGridHtml(), t.toggleActiveOptionContainer();
                }),
                (i.prototype.toggleActiveOptionContainer = function () {
                    var t;
                    return (t = this), t.active_tag_names.length > 0 || "" !== t.sort_by_param ? t.active_options_container.show() : t.active_options_container.hide();
                }),
                (i.prototype.getGridHtml = function () {
                    var t;
                    return (
                        (t = this),
                        t.request && t.request.abort(),
                        (t.request = new XMLHttpRequest()),
                        (t.request.onload = function () {
                            var e;
                            if (
                                t.request.status >= 200 &&
                                t.request.status < 300 &&
                                ((e = theme.utils.parseHtml(t.request.response, ".collection--body--root")),
                                t.renderGridHtml(e),
                                t.spinner.hide(),
                                t.grid_container.removeAttr("style"),
                                theme.classes.Product.clearQuickAddForms("collection"),
                                e.find(".product--root").length > 0)
                            )
                                return t.formatProducts();
                        }),
                        (t.request.onerror = function () {
                            return console.log(t.request.statusText + ": collection filter request failed!");
                        }),
                        t.request.open("GET", t.ajax_url),
                        t.request.send()
                    );
                }),
                (i.prototype.renderGridHtml = function (t) {
                    var e, i, o;
                    return (
                        (e = this),
                        (i = t.find(".collection--body--grid").html()),
                        e.grid_container.html(i),
                        (o = t.find(".collection--body--pagination")),
                        o.html() ? (e.pagination.html(o.html()), e.pagination.removeAttr("style"), e.pagination_link.show()) : e.pagination_link.hide()
                    );
                }),
                (i.prototype.formatProducts = function () {
                    var t;
                    if (((t = this), t.matchImageHeights(), theme.utils.loadJsClasses(t.grid_container), theme.settings.hover_image_enabled && t.hoverImagesLoaded(), theme.settings.quick_add))
                        return theme.partials.OffCanvas.unload(), theme.partials.OffCanvas.load();
                }),
                (i.prototype.activeTagListeners = function () {
                    var e;
                    return (
                        (e = this),
                        (e.current_active_tags = e.active_tags_wrapper.find(".collection--navigation--active-tag")),
                        e.clearActiveOptionsListener(),
                        e.current_active_tags.on("click keydown", function (i) {
                            if ("keydown" !== i.type || "Enter" === i.key) return e.clearTagFilter(t(this).attr("data-handle"));
                        })
                    );
                }),
                (i.prototype.activeSortByListener = function () {
                    var t;
                    return (
                        (t = this),
                        t.active_sort_by_container.on("click keydown", function (e) {
                            if ("keydown" !== e.type || "Enter" === e.key) return t.clearSortByFilter();
                        })
                    );
                }),
                (i.prototype.clearActiveOptionsListener = function () {
                    var e;
                    return (
                        (e = this),
                        e.clear_tags_button.off("click keydown"),
                        e.clear_tags_button.on("click keydown", function (i) {
                            if ("keydown" !== i.type || "Enter" === i.key)
                                return (
                                    e.clearSortByFilter(),
                                    e.current_active_tags
                                        ? e.current_active_tags.each(function (i) {
                                              return e.clearTagFilter(t(i).attr("data-handle"));
                                          })
                                        : void 0
                                );
                        })
                    );
                }),
                (i.prototype.clearSortByFilter = function () {
                    var t, e;
                    return (t = this), (e = t.sort_by_links.filter("[data-active='true']")), e.trigger("click");
                }),
                (i.prototype.clearTagFilter = function (t) {
                    var e, i;
                    return (e = this), (i = e.refine_links.filter("[data-handle='" + t + "'][data-active='true']")), i.trigger("click");
                }),
                (i.toggleFilterMenu = function (e) {
                    var o, r;
                    return i, (r = e.data("toggle-menu")), (o = t(".collection--filter--root")), o.find("[aria-controls='" + r + "'][aria-expanded='false']").trigger("click");
                }),
                i
            );
        })()),
        (theme.classes.FrameworkContentBlocks = (function () {
            function t(t) {
                this.root = t;
            }
            return t;
        })()),
        (theme.classes.FrameworkDisclosure = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.optionChangeCallback = e(this.optionChangeCallback, this)),
                    (this.updateFormPosition = e(this.updateFormPosition, this)),
                    (this.toggleFormDisplay = e(this.toggleFormDisplay, this)),
                    (this.setOptionOnClick = e(this.setOptionOnClick, this)),
                    (this.hideFormWhenFocusOut = e(this.hideFormWhenFocusOut, this)),
                    (this.showFormWhenClick = e(this.showFormWhenClick, this)),
                    (this.updateFormListeners = e(this.updateFormListeners, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.current_option = i.root.find(".disclosure--current-option")),
                    (i.form = i.root.find(".disclosure--form")),
                    (i.input = i.root.find('[data-item="disclosure"]')),
                    (i.links = i.root.find(".disclosure--option-link")),
                    (i.toggle = i.root.find(".disclosure--toggle")),
                    (i.type = i.root.attr("data-type")),
                    (i.toggle_and_form_gap = 8),
                    (i.window_and_form_gap = 32),
                    (i.form_space_needed = theme.utils.getHiddenElHeight(i.form, !1) + i.toggle_and_form_gap + i.window_and_form_gap),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    if (((t = this), t.updateFormListeners(), t.showFormWhenClick(), t.hideFormWhenFocusOut(), t.setOptionOnClick(), t.updateFormPosition(), "url-redirect" === t.type || "localization" === t.type))
                        return t.optionChangeCallback();
                }),
                (i.prototype.updateFormListeners = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "resize.Disclosure",
                            theme.utils.debounce(100, function () {
                                return t.updateFormPosition();
                            })
                        ),
                        t.root.on("update_form_position", function () {
                            return t.updateFormPosition();
                        })
                    );
                }),
                (i.prototype.showFormWhenClick = function () {
                    var e;
                    return (
                        (e = this),
                        e.toggle.on("click keydown", function (i) {
                            var o;
                            if ("keydown" !== i.type || "Enter" === i.key) return (o = "true" === t(this).attr("aria-expanded")), e.toggleFormDisplay(!o);
                        })
                    );
                }),
                (i.prototype.hideFormWhenFocusOut = function () {
                    var e;
                    return (
                        (e = this),
                        e.toggle.on("focusout", function (t) {
                            if (!e.root.has(t.relatedTarget)) return e.toggleFormDisplay(!1);
                        }),
                        e.form.on("focusout", function (i) {
                            var o;
                            if (((o = t(this).has(i.relatedTarget)), "true" === e.toggle.attr("aria-expanded") && !o)) return e.toggleFormDisplay(!1);
                        }),
                        e.root.on("keydown", function (t) {
                            if ("Escape" === t.key) return e.toggleFormDisplay(!1), e.toggle.focus();
                        })
                    );
                }),
                (i.prototype.setOptionOnClick = function () {
                    var e;
                    return (
                        (e = this),
                        e.links.on("click keydown", function (i) {
                            var o, r;
                            if ("Enter" === i.key) e.toggle.focus();
                            else if ("keydown" === i.type) return;
                            return (
                                (r = t(this).attr("data-value")),
                                (o = t(this).html()),
                                e.toggleFormDisplay(!1),
                                e.current_option.html(o),
                                e.links.attr("aria-current", !1),
                                t(this).attr("aria-current", !0),
                                e.input.val(r),
                                e.input.trigger("change")
                            );
                        })
                    );
                }),
                (i.prototype.toggleFormDisplay = function (t) {
                    var e;
                    return (e = this), e.toggle.attr("aria-expanded", t);
                }),
                (i.prototype.updateFormPosition = function () {
                    var t, e, i, o, r, n, s, a, l, u;
                    return (
                        (t = this),
                        (l = t.toggle.outerHeight()),
                        (e = l + t.toggle_and_form_gap),
                        (a = t.root.closest("[class^=off-canvas]").height()),
                        (n = t.root.offset().top),
                        (r = a - n - l),
                        (i = t.form_space_needed > r && r < n),
                        (o = t.form_space_needed > n && r > n),
                        (u = window.innerHeight - e - t.window_and_form_gap),
                        i ? (u -= r) : o && (u -= n),
                        t.form.css("max-height", u + "px"),
                        i ? ((s = theme.utils.getHiddenElHeight(t.form, !1) + t.toggle_and_form_gap), t.form.css("top", "-" + s + "px")) : t.form.css("top", e + "px")
                    );
                }),
                (i.prototype.optionChangeCallback = function () {
                    var e;
                    return (
                        (e = this),
                        e.input.on("change", function () {
                            return "url-redirect" === e.type ? (window.location.href = t(this).val()) : "localization" === e.type ? t(this).closest("form").submit() : void 0;
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkDomElement = (function () {
            function i(t, i) {
                var o;
                (this.selector = t),
                    (this.container = null != i ? i : document),
                    (this.wrapInner = e(this.wrapInner, this)),
                    (this.wrapAll = e(this.wrapAll, this)),
                    (this.width = e(this.width, this)),
                    (this.val = e(this.val, this)),
                    (this.trigger = e(this.trigger, this)),
                    (this.text = e(this.text, this)),
                    (this.submit = e(this.submit, this)),
                    (this.siblings = e(this.siblings, this)),
                    (this.show = e(this.show, this)),
                    (this.setAttribute = e(this.setAttribute, this)),
                    (this.scrollTop = e(this.scrollTop, this)),
                    (this.replaceWith = e(this.replaceWith, this)),
                    (this.removeClass = e(this.removeClass, this)),
                    (this.removeAttr = e(this.removeAttr, this)),
                    (this.remove = e(this.remove, this)),
                    (this.prev = e(this.prev, this)),
                    (this.prepend = e(this.prepend, this)),
                    (this.parent = e(this.parent, this)),
                    (this.outerWidth = e(this.outerWidth, this)),
                    (this.outerHtml = e(this.outerHtml, this)),
                    (this.outerHeight = e(this.outerHeight, this)),
                    (this.on = e(this.on, this)),
                    (this.offset = e(this.offset, this)),
                    (this.off = e(this.off, this)),
                    (this.not = e(this.not, this)),
                    (this.next = e(this.next, this)),
                    (this.last = e(this.last, this)),
                    (this.isEmpty = e(this.isEmpty, this)),
                    (this.isVisible = e(this.isVisible, this)),
                    (this.is = e(this.is, this)),
                    (this.insertBefore = e(this.insertBefore, this)),
                    (this.index = e(this.index, this)),
                    (this.html = e(this.html, this)),
                    (this.hide = e(this.hide, this)),
                    (this.height = e(this.height, this)),
                    (this.hasClass = e(this.hasClass, this)),
                    (this.has = e(this.has, this)),
                    (this.getAttribute = e(this.getAttribute, this)),
                    (this.focus = e(this.focus, this)),
                    (this.first = e(this.first, this)),
                    (this.find = e(this.find, this)),
                    (this.filter = e(this.filter, this)),
                    (this.eq = e(this.eq, this)),
                    (this.empty = e(this.empty, this)),
                    (this.each = e(this.each, this)),
                    (this.data = e(this.data, this)),
                    (this.css = e(this.css, this)),
                    (this.closest = e(this.closest, this)),
                    (this.clone = e(this.clone, this)),
                    (this.children = e(this.children, this)),
                    (this.attr = e(this.attr, this)),
                    (this.append = e(this.append, this)),
                    (this.addClass = e(this.addClass, this)),
                    (this.add = e(this.add, this)),
                    "string" == typeof this.selector
                        ? (this.el = this.container.querySelectorAll(this.selector))
                        : Array.isArray(this.selector)
                        ? (this.el = this.selector)
                        : "object" == typeof this.selector
                        ? (this.el = new Array(this.selector))
                        : (this.el = []),
                    null !== this.el[0] ? (this.length = this.el.length) : (this.length = 0),
                    (o = []),
                    this.el.forEach(function (t) {
                        return o.push({});
                    }),
                    (this.event_function_map = o);
            }
            return (
                (i.prototype.add = function (e) {
                    var i;
                    return (
                        (i = "string" == typeof e ? Array.from(document.querySelectorAll(e.selector)) : Array.from(e.el)),
                        this.el.forEach(function (t) {
                            return i.push(t);
                        }),
                        t(i)
                    );
                }),
                (i.prototype.addClass = function (t) {
                    return (
                        !!t &&
                        (this.el.forEach(function (e) {
                            return e.classList.add(t);
                        }),
                        this)
                    );
                }),
                (i.prototype.append = function (t) {
                    return (
                        "object" == typeof t &&
                            this.length &&
                            t.length &&
                            this.el.forEach(function (e) {
                                return t.el.forEach(function (t) {
                                    return e.appendChild(t);
                                });
                            }),
                        this
                    );
                }),
                (i.prototype.attr = function (t, e) {
                    if ((null == e && (e = null), t))
                        return null !== e && this.length
                            ? (this.el.forEach(function (i) {
                                  return i.setAttribute(t, e);
                              }),
                              this)
                            : this.length
                            ? this.el[0].getAttribute(t)
                            : void 0;
                }),
                (i.prototype.children = function (e) {
                    return e || (e = "*"), t(":scope > " + e, this.el[0]);
                }),
                (i.prototype.clone = function () {
                    if (0 !== this.length) return t(this.el[0].cloneNode(!0));
                }),
                (i.prototype.closest = function (e) {
                    return !(!e || !this.length) && t(this.el[0].closest(e));
                }),
                (i.prototype.css = function (t, e) {
                    return (
                        !(!t && !e) &&
                        (void 0 === e && this.length
                            ? window.getComputedStyle(this.el[0])[t]
                            : (this.el.forEach(function (i) {
                                  return (i.style[t] = e);
                              }),
                              this))
                    );
                }),
                (i.prototype.data = function (t) {
                    var e;
                    return (
                        !(!t || !this.length) &&
                        (t.indexOf("-") > -1 || (t = (t.match(/[A-Za-z][a-z]*/g) || {}).join("-")), "true" === (e = this.el[0].getAttribute("data-" + t)) || ("false" !== e && (isNaN(parseFloat(e)) ? e : parseFloat(e))))
                    );
                }),
                (i.prototype.each = function (t) {
                    return this.el.forEach(function (e, i) {
                        return t(e, i);
                    });
                }),
                (i.prototype.empty = function () {
                    return (
                        this.length &&
                            this.el.forEach(function (t) {
                                return (t.innerHTML = "");
                            }),
                        this
                    );
                }),
                (i.prototype.eq = function (e) {
                    return void 0 === e ? -1 : t(this.el[e]);
                }),
                (i.prototype.filter = function (e) {
                    var i, o;
                    return (
                        !!e &&
                        ((i = Array.from(this.container.querySelectorAll(e))),
                        (o = []),
                        this.el.forEach(function (t) {
                            if (i.includes(t)) return o.push(t);
                        }),
                        t(o))
                    );
                }),
                (i.prototype.find = function (e) {
                    var i;
                    return (
                        !!e &&
                        (">" === e.charAt(0) && (e = ":scope " + e),
                        1 === this.length
                            ? t(e, this.el[0])
                            : ((i = []),
                              this.el.forEach(function (t) {
                                  var o, r, n, s, a;
                                  for (r = t.querySelectorAll(e), a = [], n = 0, s = r.length; n < s; n++) (o = r[n]), a.push(i.push(o));
                                  return a;
                              }),
                              t(i)))
                    );
                }),
                (i.prototype.first = function () {
                    return t(this.el[0]);
                }),
                (i.prototype.focus = function (t) {
                    return t || (t = 0), this.length && this.el[t].focus(), this;
                }),
                (i.prototype.getAttribute = function (t) {
                    if (t && this.length) return this.el[0].getAttribute(t);
                }),
                (i.prototype.has = function (t) {
                    if ("object" == typeof t) return this.el[0].contains(t);
                }),
                (i.prototype.hasClass = function (t) {
                    if (t && this.length) return this.el[0].classList.contains(t);
                }),
                (i.prototype.height = function (t) {
                    if (0 !== this.length)
                        return t
                            ? this.el.forEach(function (e) {
                                  return (e.style.height = t + "px");
                              })
                            : this.el[0].offsetHeight;
                }),
                (i.prototype.hide = function () {
                    if (0 !== this.length)
                        return (
                            this.el.forEach(function (t) {
                                return (t.style.display = "none");
                            }),
                            this
                        );
                }),
                (i.prototype.html = function (t) {
                    return t ? (this.length && (this.el[0].innerHTML = t), this) : this.el[0].innerHTML;
                }),
                (i.prototype.index = function (t) {
                    var e;
                    return t
                        ? ((e = -1),
                          this.el.forEach(function (i, o) {
                              if (i === t.el[0]) return (e = o);
                          }),
                          e)
                        : Array.from(this.el[0].parentNode.children).indexOf(this.el[0]);
                }),
                (i.prototype.insertBefore = function (t) {
                    if (0 !== this.length)
                        return (
                            this.el.forEach(function (e) {
                                return e.parentNode.insertBefore(t.el[0], e);
                            }),
                            this
                        );
                }),
                (i.prototype.is = function (t) {
                    var e;
                    return !!t && ((e = "string" == typeof t ? Array.from(document.querySelectorAll(t)) : Array.from(t.el)), e.includes(this.el[0]));
                }),
                (i.prototype.isVisible = function () {
                    var t;
                    if (0 !== this.length)
                        return (
                            (t = !1),
                            this.el.forEach(function (e) {
                                var i;
                                if (((i = window.getComputedStyle(e)), "none" !== i.display)) return (t = !0);
                            }),
                            t
                        );
                }),
                (i.prototype.isEmpty = function () {
                    var t;
                    if (0 !== this.length)
                        return (
                            (t = !0),
                            this.el.forEach(function (e) {
                                e.hasChildNodes() && (t = !1);
                            }),
                            t
                        );
                }),
                (i.prototype.last = function () {
                    if (0 !== this.length) return t(this.el[this.el.length - 1], this.container);
                }),
                (i.prototype.next = function () {
                    if (0 !== this.length) return t(this.el[0].nextElementSibling);
                }),
                (i.prototype.not = function (e) {
                    var i, o;
                    return (
                        (i = "string" == typeof e ? Array.from(document.querySelectorAll(e)) : Array.from(e.el)),
                        (o = []),
                        this.el.forEach(function (t) {
                            if (!i.includes(t) && !o.includes(t)) return o.push(t);
                        }),
                        t(o)
                    );
                }),
                (i.prototype.off = function (t) {
                    var e;
                    if (0 !== this.length)
                        return (
                            (e = this.event_function_map),
                            this.el.forEach(function (i, o) {
                                return t.split(" ").forEach(function (t) {
                                    if (e[o][t]) return i.removeEventListener(t.split(".")[0], e[o][t]), delete e[o][t];
                                });
                            }),
                            (this.event_function_map = e),
                            !0
                        );
                }),
                (i.prototype.offset = function () {
                    var t;
                    if (0 !== this.length) return (t = this.el[0].getBoundingClientRect()), { top: t.top + window.pageYOffset, left: t.left + window.pageXOffset };
                }),
                (i.prototype.on = function (t, e, i) {
                    var o;
                    if ((null == i && (i = !1), 0 !== this.length))
                        return (
                            (o = this.event_function_map),
                            this.el.forEach(function (r, n) {
                                return t.split(" ").forEach(function (t) {
                                    return (o[n][t] = e), r.addEventListener(t.split(".")[0], e, { passive: i });
                                });
                            }),
                            (this.event_function_map = o),
                            !0
                        );
                }),
                (i.prototype.outerHeight = function () {
                    if (this.length) return this.el[0].offsetHeight;
                }),
                (i.prototype.outerHtml = function () {
                    if (this.length) return this.el[0].outerHTML;
                }),
                (i.prototype.outerWidth = function () {
                    if (this.length) return this.el[0].offsetWidth;
                }),
                (i.prototype.parent = function () {
                    var e;
                    return this.length
                        ? ((e = []),
                          this.el.forEach(function (t) {
                              return e.push(t.parentNode);
                          }),
                          t(e))
                        : this;
                }),
                (i.prototype.prepend = function (t) {
                    return (
                        "object" == typeof t &&
                            this.length &&
                            t.length &&
                            this.el.forEach(function (e) {
                                return t.el.forEach(function (t) {
                                    return e.prepend(t);
                                });
                            }),
                        this
                    );
                }),
                (i.prototype.prev = function () {
                    if (0 !== this.length) return t(this.el[0].previousElementSibling);
                }),
                (i.prototype.remove = function () {
                    return (
                        this.el.forEach(function (t) {
                            return t.parentNode.removeChild(t);
                        }),
                        true
                    );
                }),
                (i.prototype.removeAttr = function (t) {
                    if (t)
                        return (
                            this.length &&
                                this.el.forEach(function (e) {
                                    return e.removeAttribute(t);
                                }),
                            this
                        );
                }),
                (i.prototype.removeClass = function (t) {
                    if (t && this.length)
                        return (
                            this.el.forEach(function (e) {
                                return t.split(" ").forEach(function (t) {
                                    return e.classList.remove(t);
                                });
                            }),
                            this
                        );
                }),
                (i.prototype.replaceWith = function (t) {
                    return this.length && this.el[0].replaceWith(t.el[0]), this;
                }),
                (i.prototype.scrollTop = function (t) {
                    if (0 !== this.length) return t ? (this.el[0].scrollTop = t) : this.el[0].scrollTop;
                }),
                (i.prototype.setAttribute = function (t, e) {
                    if (t || e)
                        return this.length
                            ? (this.el.forEach(function (i) {
                                  return i.setAttribute(t, e);
                              }),
                              this)
                            : void 0;
                }),
                (i.prototype.show = function () {
                    if (0 !== this.length)
                        return (
                            this.el.forEach(function (t) {
                                return (t.style.display = "block");
                            }),
                            this
                        );
                }),
                (i.prototype.siblings = function (e) {
                    if (0 !== this.length) return t(e, this.el[0].parentNode);
                }),
                (i.prototype.submit = function () {
                    if (0 !== this.length) return this.el[0].submit();
                }),
                (i.prototype.text = function (t) {
                    return 0 === this.length ? this : t ? ((this.el[0].textContent = t), this) : this.el[0].textContent;
                }),
                (i.prototype.trigger = function (t) {
                    var e;
                    if (t)
                        return (
                            (e = this.el),
                            t.split(" ").forEach(function (t) {
                                var i;
                                return (
                                    (i = new Event(t.split(".")[0], { bubbles: !0 })),
                                    e.forEach(function (t) {
                                        return t.dispatchEvent(i);
                                    })
                                );
                            }),
                            this
                        );
                }),
                (i.prototype.val = function (t) {
                    if (0 !== this.length) return t ? ((this.el[0].value = t), this) : this.el[0].value;
                }),
                (i.prototype.width = function (t) {
                    if (0 !== this.length)
                        return t
                            ? this.el.forEach(function (e) {
                                  return (e.style.width = t + "px");
                              })
                            : this.el[0].offsetWidth;
                }),
                (i.prototype.wrapAll = function (t, e) {
                    if (0 !== this.length)
                        return (
                            this.el.forEach(function (i) {
                                var o, r;
                                return (r = i.outerHTML), (o = t + r + e), (i.outerHTML = o);
                            }),
                            this
                        );
                }),
                (i.prototype.wrapInner = function (t, e) {
                    if (0 !== this.length)
                        return (
                            this.el.forEach(function (i) {
                                var o, r;
                                return (r = i.innerHTML), (o = t + r + e), (i.innerHTML = o);
                            }),
                            this
                        );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkFeaturedBlog = (function () {
            function t(t) {
                var i;
                (this.root = t),
                    (this.resizeListeners = e(this.resizeListeners, this)),
                    (this.matchImageHeights = e(this.matchImageHeights, this)),
                    (i = this),
                    (i.item_container = i.root.find(".featured-blog--body")),
                    (i.items = i.root.find(".featured-blog--item")),
                    i.matchImageHeights(),
                    i.resizeListeners();
            }
            return (
                (t.prototype.matchImageHeights = function () {
                    var t;
                    return (t = this), theme.utils.matchImageHeights(t.item_container, t.items, ".featured-blog--item--image");
                }),
                (t.prototype.resizeListeners = function () {
                    var t;
                    return (
                        (t = this),
                        $(window).on(
                            "resize.FeaturedGrid",
                            theme.utils.debounce(100, function () {
                                return t.matchImageHeights();
                            })
                        )
                    );
                }),
                t
            );
        })()),
        (theme.classes.FrameworkFeaturedCollection = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.hoverImagesLoaded = e(this.hoverImagesLoaded, this)),
                    (this.setGreatestHeight = e(this.setGreatestHeight, this)),
                    (this.sectionListeners = e(this.sectionListeners, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.display_type = i.root.data("display-type")),
                    (i.section_id = i.root.data("section-id")),
                    (i.items = i.root.find(".product--root")),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (
                        (t = this),
                        t.sectionListeners(),
                        t.setGreatestHeight(),
                        theme.settings.hover_image_enabled && t.hoverImagesLoaded(),
                        theme.window.on(
                            "resize." + t.section_id,
                            theme.utils.debounce(100, function () {
                                return t.setGreatestHeight();
                            })
                        )
                    );
                }),
                (i.prototype.sectionListeners = function () {
                    var t;
                    return (
                        (t = this),
                        t.root.on("theme:section:unload", function () {
                            return theme.window.off("resize." + t.section_id);
                        })
                    );
                }),
                (i.prototype.setGreatestHeight = function () {
                    var e, i;
                    return (
                        (e = this),
                        "grid" === e.display_type
                            ? theme.utils.matchImageHeights(e.root.find(".featured-collection--grid"), e.root.find(".product--root"), ".product--image-wrapper")
                            : ((i = 0),
                              e.items.each(function (e) {
                                  var o;
                                  if ((o = t(e).find(".image--root").length > 0 ? t(e).find(".product--image-wrapper .image--root").outerHeight() : t(e).find(".placeholder--root").outerHeight()) > i) return (i = o);
                              }),
                              e.items.find(".product--image-wrapper, .placeholder--root").height(i))
                    );
                }),
                (i.prototype.hoverImagesLoaded = function () {
                    var e;
                    return (
                        (e = this),
                        e.root.find(".product--hover-image").each(function (e) {
                            var i;
                            return (
                                (i = t(e)),
                                theme.utils.imagesLoaded(i, function () {
                                    var t;
                                    return (t = i.closest('[data-hover-image="true"]')), t.attr("data-hover-image", "loaded");
                                })
                            );
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkFeaturedCollections = (function () {
            function t(t) {
                var i;
                (this.root = t),
                    (this.resizeListeners = e(this.resizeListeners, this)),
                    (this.matchImageHeights = e(this.matchImageHeights, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.item_container = i.root.find(".featured-collections--body")),
                    (i.items = i.root.find(".featured-collections--item")),
                    i.load();
            }
            return (
                (t.prototype.load = function () {
                    var t;
                    return (t = this), t.matchImageHeights(), t.resizeListeners();
                }),
                (t.prototype.matchImageHeights = function () {
                    var t;
                    return (t = this), theme.utils.matchImageHeights(t.item_container, t.items, ".featured-collections--image");
                }),
                (t.prototype.resizeListeners = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "resize.FeaturedCollections",
                            theme.utils.debounce(100, function () {
                                return t.matchImageHeights();
                            })
                        )
                    );
                }),
                t
            );
        })()),
        (theme.classes.FrameworkFeaturedGrid = (function () {
            function t(t) {
                var i;
                (this.root = t),
                    (this.resizeListeners = e(this.resizeListeners, this)),
                    (this.matchImageHeights = e(this.matchImageHeights, this)),
                    (i = this),
                    (i.item_container = i.root.find(".featured-grid--body--container")),
                    (i.items = i.root.find(".featured-grid--item")),
                    (i.text_position = i.root.attr("data-text-position")),
                    (i.mobile_overlay = i.root.data("mobile-overlay")),
                    i.matchImageHeights(),
                    i.resizeListeners();
            }
            return (
                (t.prototype.matchImageHeights = function () {
                    var t;
                    if (((t = this), "bottom" === t.text_position || ("small" === theme.utils.mqs.current_window && !t.mobile_overlay))) return theme.utils.matchImageHeights(t.item_container, t.items, ".featured-grid--item--image");
                }),
                (t.prototype.resizeListeners = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "resize.FeaturedGrid",
                            theme.utils.debounce(100, function () {
                                return t.items.find(".featured-grid--item--image, .placeholder--root").css("height", "100%"), t.matchImageHeights();
                            })
                        )
                    );
                }),
                t
            );
        })()),
        (theme.classes.FrameworkFeaturedVideo = (function () {
            function t(t) {
                var i;
                (this.root = t),
                    (this.hideThumbnail = e(this.hideThumbnail, this)),
                    (this.playButtonListener = e(this.playButtonListener, this)),
                    (this.disablePlayerFocus = e(this.disablePlayerFocus, this)),
                    (this.vimeoEvents = e(this.vimeoEvents, this)),
                    (this.insertVimeoPlayer = e(this.insertVimeoPlayer, this)),
                    (this.youtubeEvents = e(this.youtubeEvents, this)),
                    (this.youtubeReady = e(this.youtubeReady, this)),
                    (this.insertYoutubePlayer = e(this.insertYoutubePlayer, this)),
                    (this.insertAPIScript = e(this.insertAPIScript, this)),
                    (this.playerInit = e(this.playerInit, this)),
                    (this.checkAPIScriptExists = e(this.checkAPIScriptExists, this)),
                    (i = this),
                    (i.play_buttons = i.root.find(".feature-video--play svg, .feature-video--play-mobile svg")),
                    (i.section_id = i.root.attr("data-section-id")),
                    (i.thumbnail = i.root.data("thumbnail")),
                    (i.video_type = i.root.data("video-type")),
                    (i.video_id = i.root.data("video-id")),
                    (i.vimeoVars = { id: i.video_id, autopause: 0, playsinline: 0, title: 0 }),
                    (i.youtubeVars = {}),
                    i.thumbnail ? i.playButtonListener() : i.checkAPIScriptExists();
            }
            return (
                (t.prototype.checkAPIScriptExists = function () {
                    var t;
                    return (t = this), "vimeo" === t.video_type ? (theme.utils.vimeo_script_added ? t.playerInit() : t.insertAPIScript()) : theme.utils.youtube_script_added ? t.playerInit() : t.insertAPIScript();
                }),
                (t.prototype.playerInit = function () {
                    var t;
                    return (
                        (t = this),
                        "vimeo" === t.video_type
                            ? t.thumbnail
                                ? t.insertVimeoPlayer()
                                : (window.addEventListener("load", function () {
                                      return t.insertVimeoPlayer();
                                  }),
                                  t.root.on("theme:section:load", function () {
                                      return t.insertVimeoPlayer();
                                  }))
                            : t.thumbnail
                            ? t.insertYoutubePlayer()
                            : (window.addEventListener("load", function () {
                                  return t.insertYoutubePlayer();
                              }),
                              t.root.on("theme:section:load", function () {
                                  return t.insertYoutubePlayer();
                              }))
                    );
                }),
                (t.prototype.insertAPIScript = function () {
                    var t;
                    return (
                        (t = this),
                        "vimeo" === t.video_type
                            ? ((theme.utils.vimeo_script_added = !0),
                              theme.utils.insertScript("https://player.vimeo.com/api/player.js", function () {
                                  return t.insertVimeoPlayer();
                              }))
                            : ((theme.utils.youtube_script_added = !0),
                              theme.utils.insertScript("https://www.youtube.com/iframe_api"),
                              window.addEventListener("theme:utils:youtubeAPIReady", function () {
                                  return t.insertYoutubePlayer();
                              }))
                    );
                }),
                (t.prototype.insertYoutubePlayer = function () {
                    var t;
                    if (
                        ((t = this),
                        t.thumbnail ||
                            ((t.youtubeVars.enablejsapi = 1), (t.youtubeVars.origin = window.location.href), (t.youtubeVars.playsinline = 1), (t.youtubeVars.fs = 0), (t.youtubeVars.loop = 1), (t.youtubeVars.playlist = t.video_id)),
                        "undefined" != typeof YT)
                    )
                        return (t.player = new YT.Player("player-" + t.section_id, { videoId: t.video_id, playerVars: t.youtubeVars, events: { onReady: t.youtubeReady, onStateChange: t.youtubeEvents } }));
                }),
                (t.prototype.youtubeReady = function () {
                    var t;
                    return (t = this), t.thumbnail || (t.player.mute(), t.disablePlayerFocus()), t.player.playVideo();
                }),
                (t.prototype.youtubeEvents = function (t) {
                    var e, i, o;
                    if (((i = this), (e = t.target), i.thumbnail)) {
                        if (0 === t.data) return e.seekTo(0), e.pauseVideo();
                    } else if (1 === t.data)
                        return (
                            (o = e.getDuration() - e.getCurrentTime()),
                            i.rewindTO && clearTimeout(i.rewindTO),
                            (i.rewindTO = setTimeout(function () {
                                e.seekTo(0);
                            }, 1e3 * (o - 0.1)))
                        );
                }),
                (t.prototype.insertVimeoPlayer = function () {
                    var t;
                    return (
                        (t = this),
                        t.thumbnail || ((t.vimeoVars.playsinline = 1), (t.vimeoVars.muted = 1), (t.vimeoVars.background = 1), (t.vimeoVars.loop = 1)),
                        (t.player = new Vimeo.Player("player-" + t.section_id, t.vimeoVars)),
                        t.thumbnail
                            ? t.vimeoEvents()
                            : t.player.ready().then(function () {
                                  return t.disablePlayerFocus();
                              }),
                        t.player.play()
                    );
                }),
                (t.prototype.vimeoEvents = function () {
                    var t;
                    return (
                        (t = this),
                        t.player.getDuration().then(function (e) {
                            return t.player.addCuePoint(e - 0.3, {});
                        }),
                        t.player.on("cuepoint", function () {
                            return t.player.setCurrentTime(0), t.player.pause();
                        })
                    );
                }),
                (t.prototype.disablePlayerFocus = function () {
                    var t;
                    return (t = this), t.root.find("iframe").attr("tabindex", "-1");
                }),
                (t.prototype.playButtonListener = function () {
                    var t;
                    return (
                        (t = this),
                        t.play_buttons.attr("tabindex", "0"),
                        t.play_buttons.on("click keydown", function (e) {
                            if ("keydown" !== e.type || "Enter" === e.key) return t.checkAPIScriptExists(), t.hideThumbnail();
                        })
                    );
                }),
                (t.prototype.hideThumbnail = function () {
                    var t;
                    return (
                        (t = this),
                        setTimeout(function () {
                            return t.root.find(".feature-video--header, .feature-video--thumbnail, .feature-video--play-mobile").hide();
                        }, 350)
                    );
                }),
                t
            );
        })()),
        (theme.classes.FrameworkFeedbackBar = (function () {
            function t(t) {
                var i;
                (this.root = t), (this.load = e(this.load, this)), (i = this), (i.messages = i.root.find(".feedback-bar--message > *")), i.load();
            }
            return (
                (t.prototype.load = function () {
                    var t, e, i, o;
                    if (((t = this), t.messages.hide(), (e = window.location.hash.substr(1)), (i = e.replace("feedback-bar--", "")), (o = t.messages.filter("[data-message='" + i + "']")), o.length))
                        return (
                            o.show(),
                            setTimeout(function () {
                                return t.root.attr("data-open", "true");
                            }, 200),
                            setTimeout(function () {
                                return t.root.attr("data-open", "false");
                            }, 3e3)
                        );
                }),
                t
            );
        })()),
        (theme.classes.FrameworkFooter = (function () {
            function i(i) {
                var o;
                (this.root = i),
                    (this.stickyFooter = e(this.stickyFooter, this)),
                    (this.addListeners = e(this.addListeners, this)),
                    (this.load = e(this.load, this)),
                    (o = this),
                    (o.header = t(".header--root")),
                    (o.main_content = t(".layout--main-content")),
                    o.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (t = this), t.addListeners(), t.stickyFooter();
                }),
                (i.prototype.addListeners = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on("resize theme:cart:updated", function () {
                            return t.stickyFooter();
                        }),
                        document.addEventListener("shopify:section:load", function () {
                            return t.stickyFooter();
                        })
                    );
                }),
                (i.prototype.stickyFooter = function () {
                    var e, i, o;
                    if (
                        ((e = this),
                        e.main_content.css("min-height", "unset"),
                        (o = e.header.outerHeight() + e.main_content.outerHeight() + e.root.outerHeight()),
                        t("body").data("border") && ("small" === theme.utils.mqs.current_window ? (o += 16) : (o += 24)),
                        t(".announcement--root").length > 0 && (o += t(".announcement--root").outerHeight()),
                        window.innerHeight > o)
                    )
                        return (i = o - e.main_content.outerHeight()), e.main_content.css("min-height", window.innerHeight - i + "px");
                }),
                i
            );
        })()),
        (theme.classes.FrameworkMap = (function () {
            function t(t) {
                var i;
                (this.root = t),
                    (this.buildStyles = e(this.buildStyles, this)),
                    (this.buildMap = e(this.buildMap, this)),
                    (this.geolocate = e(this.geolocate, this)),
                    (this.loadMapsApi = e(this.loadMapsApi, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.api_status = null),
                    (i.map_instance = null),
                    (i.key = i.root.data("api-key")),
                    (i.address = i.root.attr("data-address")),
                    (i.theme = i.root.data("theme")),
                    (i.styles = null),
                    (i.container = i.root.find(".map--google-maps")),
                    (i.center = null),
                    i.load();
            }
            return (
                (t.prototype.load = function () {
                    var t;
                    if (((t = this), t.container.length > 0)) return t.loadMapsApi();
                }),
                (t.prototype.loadMapsApi = function () {
                    var t, e;
                    return (
                        (t = this),
                        "loading" === theme.utils.google_maps_script_status
                            ? (e = setInterval(function () {
                                  if ("loaded" === theme.utils.google_maps_script_status) return t.geolocate(), clearInterval(e);
                              }, 100))
                            : void 0 === window.google
                            ? ((theme.utils.google_maps_script_status = "loading"),
                              theme.utils.insertScript("https://maps.googleapis.com/maps/api/js?key=" + t.key, function () {
                                  return t.geolocate(), (theme.utils.google_maps_script_status = "loaded");
                              }))
                            : t.geolocate()
                    );
                }),
                (t.prototype.geolocate = function () {
                    var t, e;
                    return (
                        (t = this),
                        (e = new google.maps.Geocoder()),
                        e.geocode({ address: t.address }, function (e, i) {
                            return "OK" === i ? ((t.center = e[0].geometry.location), t.buildStyles(), t.buildMap()) : console.log("couldn't convert address with geocoder");
                        })
                    );
                }),
                (t.prototype.buildMap = function () {
                    var t, e, i, o;
                    return (
                        (t = this),
                        (o = { zoom: 15, center: t.center, disableDefaultUI: !0, zoomControl: !0, scrollwheel: !1, styles: t.styles }),
                        (i = new google.maps.Map(t.container.el[0], o)),
                        (e = i.getCenter()),
                        new google.maps.Marker({ map: i, position: i.getCenter() }),
                        (t.map_instance = google.maps.event.addDomListener(
                            window,
                            "resize",
                            theme.utils.debounce(500, function () {
                                google.maps.event.trigger(i, "resize"), i.setCenter(e);
                            })
                        ))
                    );
                }),
                (t.prototype.buildStyles = function () {
                    var t;
                    return (
                        (t = this),
                        "grayscale" === t.theme
                            ? (t.styles = [
                                  { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
                                  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                                  { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                                  { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
                                  { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                                  { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                                  { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                                  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                                  { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                                  { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
                                  { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                                  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
                                  { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                                  { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                                  { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                                  { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                                  { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
                                  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                              ])
                            : "dark" === t.theme
                            ? (t.styles = [
                                  { elementType: "geometry", stylers: [{ color: "#212121" }] },
                                  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                                  { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                                  { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
                                  { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#757575" }] },
                                  { featureType: "administrative.country", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                                  { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
                                  { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                                  { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                                  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#181818" }] },
                                  { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                                  { featureType: "poi.park", elementType: "labels.text.stroke", stylers: [{ color: "#1b1b1b" }] },
                                  { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#2c2c2c" }] },
                                  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] },
                                  { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#373737" }] },
                                  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3c3c3c" }] },
                                  { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#4e4e4e" }] },
                                  { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                                  { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                                  { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }] },
                                  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d3d3d" }] },
                              ])
                            : void 0
                    );
                }),
                t
            );
        })()),
        (theme.classes.FrameworkMediaQueries = (function () {
            function t() {
                (this.screenSizeListener = e(this.screenSizeListener, this)),
                    (this.getScreenSize = e(this.getScreenSize, this)),
                    (this.medium_screen = 768),
                    (this.large_screen = 1024),
                    (this.current_window = null),
                    this.getScreenSize(),
                    this.screenSizeListener();
            }
            return (
                (t.prototype.getScreenSize = function () {
                    var t, e, i;
                    if (
                        ((t = this),
                        (i = t.current_window),
                        window.matchMedia("only screen and (min-width: " + t.large_screen + "px)").matches
                            ? "large" !== t.current_window && (t.current_window = "large")
                            : window.matchMedia("only screen and (min-width: " + t.medium_screen + "px)").matches
                            ? "medium" !== t.current_window && (t.current_window = "medium")
                            : "small" !== t.current_window && (t.current_window = "small"),
                        t.current_window !== i)
                    )
                        return (e = new Event("theme:utils:mqs:updated")), window.dispatchEvent(e);
                }),
                (t.prototype.screenSizeListener = function () {
                    var t;
                    return (
                        (t = this),
                        window.addEventListener("resize", function () {
                            return t.getScreenSize();
                        })
                    );
                }),
                t
            );
        })()),
        (theme.classes.FrameworkModal = (function () {
            function i(i) {
                var o;
                (this.root = i),
                    (this.transitionListeners = e(this.transitionListeners, this)),
                    (o = this),
                    (o.fullscreen = !!o.root.data("modal-fullscreen")),
                    o.root.data("modal-custom-close") ? (o.custom_close_button = o.root.data("modal-custom-close")) : (o.custom_close_button = ""),
                    (o.force_view = o.root.data("force-view")),
                    (o.view = o.root.data("modal-view")),
                    (o.viewport = t(".offcanvas--viewport")),
                    (o.nested_links = o.root.find(":scope .modal--root .modal--link")),
                    (o.nested_content = o.root.find(":scope .modal--root .modal--content")),
                    (o.links = o.root.find(".modal--link").not(o.nested_links)),
                    (o.content = o.root.find(".modal--content").not(o.nested_content)),
                    (o.window = t(".modal--window")),
                    (o.window_container = o.window.find(".modal--container")),
                    (o.mask = o.window.find(".modal--mask")),
                    (o.close_button = o.window.find(".modal--close")),
                    (o.next_button = o.window.find(".modal--next")),
                    (o.prev_button = o.window.find(".modal--prev")),
                    (o.slider = null),
                    (o.slides = null),
                    (o.main_content_window = t(".off-canvas--main-content")),
                    o.openListeners(),
                    o.transitionListeners(),
                    (o.modal_state = "closed"),
                    (o.nav_lock = !1);
            }
            return (
                (i.prototype.openListeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.links.on("keypress.FrameworkModal, click.FrameworkModal, quick-open", function (i) {
                            var o;
                            return (
                                ("keypress" !== i.type || !1 !== theme.utils.a11yClick(i)) &&
                                ((o = t(this)),
                                e.links.each(function (r, n) {
                                    if (t(r).is(o)) return "quick-open" === i.type ? e.open(n, !0) : e.open(n);
                                }),
                                i.preventDefault(),
                                i.stopPropagation())
                            );
                        })
                    );
                }),
                (i.prototype.open = function (e, i) {
                    var o, r;
                    if ((null == i && (i = !1), (o = this), "closed" === o.modal_state))
                        return (
                            (o.modal_state = "opened"),
                            t("body").attr("data-modal-open", !0),
                            theme.window.trigger("theme:modal:opened"),
                            o.window.attr("data-modal-fullscreen", o.fullscreen),
                            o.window.attr("data-modal-custom-close", o.custom_close_button),
                            o.window.attr("data-modal-view", o.view),
                            o.viewport.css("overflow", "hidden"),
                            o.closeListeners(),
                            o.positionListeners(),
                            (r = window.pageYOffset),
                            o.main_content_window.css("position", "fixed"),
                            o.main_content_window.css("top", "-" + r + "px"),
                            o.moveContentToWindow(),
                            o.slides.length > 1 && (o.next_button.show(), o.prev_button.show(), o.prevListeners(), o.nextListeners()),
                            o.window.css("visibility", "visible"),
                            o.window_container.show(),
                            o.renderVideo(o.slides.eq(e)),
                            i
                                ? (o.slides.eq(e).addClass("active"), o.position())
                                : (o.mask.attr("data-transition", "forwards"),
                                  o.loadModal(o.slides.eq(e), function () {
                                      return setTimeout(function () {
                                          return o.window_container.find('input[type="text"]').focus();
                                      }, 0);
                                  }))
                        );
                }),
                (i.prototype.moveContentToWindow = function () {
                    var t, e;
                    return (t = this), (e = t.root.find(".modal--content").not(t.nested_content)), t.window_container.append(e), (t.slides = t.window_container.find(".modal--content"));
                }),
                (i.prototype.renderVideo = function (t) {
                    var e, i, o, r, n, s;
                    if (((e = this), (s = t.find(".responsive-video").first()), s.length))
                        return (
                            (r = s.data("video")), (n = e.extractVideoType(r)), (i = e.extractVideoId(r, n)), (o = e.createIframe(n, i)), "vimeo" === n && s.addClass("vimeo"), "kickstarter" === n && s.addClass("kickstarter"), s.append(o)
                        );
                }),
                (i.prototype.extractVideoType = function (t) {
                    var e;
                    return (
                        this,
                        (e = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i),
                        e.exec(t) ? "youtube" : ((e = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/), e.exec(t) ? "vimeo" : ((e = /^.*(kickstarter)\.com/g), !!e.exec(t) && "kickstarter"))
                    );
                }),
                (i.prototype.extractVideoId = function (t, e) {
                    var i, o;
                    if ((this, "youtube" === e)) {
                        if (((o = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/), (i = t.match(o)) && 11 === i[2].length)) return i[2];
                    } else if ("vimeo" === e) {
                        if (((o = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/), (i = t.match(o)))) return i[2];
                    } else if ("kickstarter" === e && ((o = /(?:kickstarter\.com\/projects\/)(.*)(|\?)/), (i = t.match(o)))) return i[1];
                }),
                (i.prototype.createIframe = function (t, e) {
                    return (
                        this,
                        "youtube" === t
                            ? "<iframe src='//www.youtube.com/embed/" + e + "?autoplay=1' frameborder='0' allowfullwidth></iframe>"
                            : "vimeo" === t
                            ? "<iframe src='//player.vimeo.com/video/" + e + "?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?' frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
                            : "kickstarter" === t
                            ? "<iframe src='//www.kickstarter.com/projects/" + e + "/widget/video.html' frameborder='0' webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>"
                            : void 0
                    );
                }),
                (i.prototype.removeVideos = function () {
                    var e;
                    return (
                        (e = this),
                        e.slides.find(".responsive-video").each(function (e) {
                            if (t(e).data("video")) return t(e).find("iframe").remove();
                        })
                    );
                }),
                (i.prototype.loadModal = function (t, e) {
                    var i;
                    return (i = this), t.addClass("active"), i.position(), e && e(), (i.nav_lock = !1);
                }),
                (i.prototype.position = function () {
                    var t, e, i, o;
                    if (((t = this), null != t.window_container)) {
                        if (
                            ((e = t.content.filter(".active")),
                            t.window_container.removeAttr("style"),
                            t.window.removeClass("fixed"),
                            (o = e.outerHeight()),
                            e.outerWidth(),
                            (i = o + parseInt(t.window.css("padding-top")) + parseInt(t.window.css("padding-bottom"))),
                            t.fullscreen)
                        )
                            return;
                        return (
                            e.hasClass("type--image") && (i = o),
                            window.innerHeight >= i && "absolute" !== t.force_view
                                ? t.window.addClass("fixed")
                                : (document.querySelectorAll("html, body").forEach(function (t) {
                                      return t.scrollTo(0, 0);
                                  }),
                                  t.window.removeClass("fixed"))
                        );
                    }
                }),
                (i.prototype.positionListeners = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on("resize.FrameworkModal", function () {
                            return t.position();
                        })
                    );
                }),
                (i.prototype.nextListeners = function () {
                    var e;
                    return (
                        (e = this),
                        t(document).on("keydown.FrameworkModal", function (t) {
                            if (39 === t.keyCode) return e.next();
                        }),
                        e.next_button.on("click.FrameworkModal", function () {
                            return e.next();
                        })
                    );
                }),
                (i.prototype.next = function () {
                    var t, e, i;
                    if (((t = this), !t.nav_lock))
                        return (
                            (t.nav_lock = !0),
                            (i = t.slides.filter(".active").index()),
                            t.slides.removeClass("active"),
                            t.removeVideos(),
                            (e = i + 1 === t.slides.length ? t.slides.eq(0) : t.slides.eq(i + 1)),
                            t.renderVideo(e),
                            t.loadModal(e)
                        );
                }),
                (i.prototype.prevListeners = function () {
                    var e;
                    return (
                        (e = this),
                        t(document).on("keydown.FrameworkModal", function (t) {
                            if (37 === t.keyCode) return e.prev();
                        }),
                        e.prev_button.on("click.FrameworkModal", function () {
                            return e.prev();
                        })
                    );
                }),
                (i.prototype.prev = function () {
                    var t, e, i;
                    if (((t = this), !t.nav_lock))
                        return (
                            (t.nav_lock = !0),
                            (i = t.slides.filter(".active").index()),
                            t.slides.removeClass("active"),
                            t.removeVideos(),
                            (e = 0 === i ? t.slides.eq(t.slides.length - 1) : t.slides.eq(i - 1)),
                            t.renderVideo(e),
                            t.loadModal(e)
                        );
                }),
                (i.prototype.closeListeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.root.on("quick-close", function () {
                            return e.close(!0);
                        }),
                        t(document).on("keydown.FrameworkModal", function (t) {
                            if (27 === t.keyCode) return e.close();
                        }),
                        e.mask.on("click.FrameworkModal", function () {
                            return e.close();
                        }),
                        e.window_container.on("click.FrameworkModal", function () {
                            return e.close();
                        }),
                        e.content.on("click.FrameworkModal", function (t) {
                            return t.stopPropagation();
                        }),
                        e.close_button.on("click.FrameworkModal keydown.FrameworkModal", function () {
                            if ("keydown" !== event.type || "Enter" === event.key) return e.close();
                        })
                    );
                }),
                (i.prototype.close = function (e) {
                    var i, o;
                    return (
                        null == e && (e = !1),
                        (i = this),
                        (o = -1 * parseInt(i.main_content_window.css("top"))),
                        t("body").attr("data-modal-open", !1),
                        theme.window.trigger("theme:modal:closed"),
                        i.main_content_window.css("top", "0"),
                        i.main_content_window.css("position", "relative"),
                        i.viewport.css("overflow", "unset"),
                        window.scrollTo(0, o),
                        i.putBackContent(),
                        i.next_button.hide(),
                        i.prev_button.hide(),
                        i.window.css("visibility", "hidden"),
                        e ? (i.mask.hide(), i.window_container.empty(), (i.modal_state = "closed")) : i.mask.attr("data-transition", "backwards"),
                        i.removeListeners()
                    );
                }),
                (i.prototype.putBackContent = function () {
                    var t;
                    return (t = this), t.removeVideos(), t.root.append(t.slides.removeClass("active"));
                }),
                (i.prototype.removeListeners = function () {
                    var e;
                    return (
                        (e = this),
                        t(document).off("keydown.FrameworkModal"),
                        theme.window.off("resize.FrameworkModal"),
                        t("body,html").off("DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal"),
                        e.next_button.off("click.FrameworkModal"),
                        e.prev_button.off("click.FrameworkModal"),
                        e.close_button.off("click.FrameworkModal"),
                        e.close_button.off("keydown.FrameworkModal"),
                        e.mask.off("click.FrameworkModal"),
                        e.window_container.off("click.FrameworkModal")
                    );
                }),
                (i.prototype.transitionListeners = function () {
                    var t;
                    return (
                        (t = this),
                        t.mask.on("transition:at_start", function () {
                            return t.window_container.empty(), (t.modal_state = "closed");
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkOffCanvas = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.transitionListeners = e(this.transitionListeners, this)),
                    (this.touchListener = e(this.touchListener, this)),
                    (this.setFocus = e(this.setFocus, this)),
                    (this.closeRightComplete = e(this.closeRightComplete, this)),
                    (this.closeRight = e(this.closeRight, this)),
                    (this.closeLeftComplete = e(this.closeLeftComplete, this)),
                    (this.closeLeft = e(this.closeLeft, this)),
                    (this.openRightComplete = e(this.openRightComplete, this)),
                    (this.openRight = e(this.openRight, this)),
                    (this.openLeftComplete = e(this.openLeftComplete, this)),
                    (this.openLeft = e(this.openLeft, this)),
                    (this.toggle = e(this.toggle, this)),
                    (this.closeWithEscKey = e(this.closeWithEscKey, this)),
                    (this.closeWhenFocusOut = e(this.closeWhenFocusOut, this)),
                    (this.toggleListeners = e(this.toggleListeners, this)),
                    (this.viewPortHeightListener = e(this.viewPortHeightListener, this)),
                    (this.setViewPortHeight = e(this.setViewPortHeight, this)),
                    (this.setState = e(this.setState, this)),
                    (this.unload = e(this.unload, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.left_sidebar = i.root.find(".off-canvas--left-sidebar")),
                    (i.right_sidebar = i.root.find(".off-canvas--right-sidebar")),
                    (i.focus_triggers = i.root.find(".off-canvas--focus-trigger")),
                    (i.main_content = i.root.find(".off-canvas--main-content")),
                    (i.overlay = i.root.find(".off-canvas--overlay")),
                    (i.state = "closed"),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var e;
                    return (
                        (e = this),
                        (e.close = t("[data-off-canvas--close]")),
                        (e.triggers = t("[data-off-canvas--open]")),
                        e.setViewPortHeight(),
                        e.viewPortHeightListener(),
                        e.toggleListeners(),
                        e.touchListener(),
                        e.closeWhenFocusOut(),
                        e.closeWithEscKey(),
                        e.transitionListeners()
                    );
                }),
                (i.prototype.unload = function () {
                    var t;
                    return (t = this), t.triggers.off("click keydown"), t.overlay.add(t.close).off("click");
                }),
                (i.prototype.setState = function (t) {
                    var e;
                    if (
                        ((e = this),
                        (e.state = t),
                        e.root.attr("data-off-canvas--state", t),
                        "left--opening" === e.state && (e.left_sidebar.attr("data-transition", "forwards"), e.overlay.attr("data-transition", "forwards")),
                        "left--closing" === e.state && (e.left_sidebar.attr("data-transition", "backwards"), e.overlay.attr("data-transition", "backwards")),
                        "right--opening" === e.state && (e.right_sidebar.attr("data-transition", "forwards"), e.overlay.attr("data-transition", "forwards")),
                        "right--closing" === e.state)
                    )
                        return e.right_sidebar.attr("data-transition", "backwards"), e.overlay.attr("data-transition", "backwards");
                }),
                (i.prototype.setViewPortHeight = function () {
                    var t;
                    return (t = this), t.root.css("min-height", window.innerHeight + "px");
                }),
                (i.prototype.viewPortHeightListener = function () {
                    var t;
                    return (
                        (t = this),
                        window.addEventListener("resize", function () {
                            return t.setViewPortHeight();
                        })
                    );
                }),
                (i.prototype.toggleListeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.triggers.on("click keydown", function (i) {
                            if ("keydown" !== i.type || "Enter" === i.key) {
                                if (((e.last_trigger = t(this)), "left-sidebar" === t(this).data("off-canvas--open"))) e.toggle("left-sidebar");
                                else if ("right-sidebar" === t(this).data("off-canvas--open")) {
                                    if (((e.right_sidebar_view = t(this).data("off-canvas--view")), e.right_sidebar.attr("data-active", e.right_sidebar_view), "product-form" === e.right_sidebar_view))
                                        theme.classes.Product.initQuickAddForm(t(this));
                                    else if ("collection-filter" === e.right_sidebar_view) theme.classes.Collection.toggleFilterMenu(t(this));
                                    else if ("cart" === e.right_sidebar_view && t(this).data("product-id")) return i.preventDefault(), i.stopPropagation(), theme.classes.Product.quickAddToCart(t(this)), !1;
                                    e.toggle("right-sidebar");
                                }
                                return i.preventDefault(), i.stopPropagation();
                            }
                        }),
                        e.overlay.add(e.close).on("click keydown", function () {
                            if ("keydown" !== event.type || "Enter" === event.key) return "left--opened" === e.state ? e.toggle("left-sidebar") : "right--opened" === e.state ? e.toggle("right-sidebar") : void 0;
                        })
                    );
                }),
                (i.prototype.closeWhenFocusOut = function () {
                    var t;
                    return (
                        (t = this),
                        t.focus_triggers.on("focus", function () {
                            return "left--opened" === t.state ? t.closeLeft() : "right--opened" === t.state ? t.closeRight() : void 0;
                        })
                    );
                }),
                (i.prototype.closeWithEscKey = function () {
                    var t;
                    return (
                        (t = this),
                        window.addEventListener("keydown", function (e) {
                            if ("Escape" === e.key) return "left--opened" === t.state ? t.closeLeft() : "right--opened" === t.state ? t.closeRight() : void 0;
                        })
                    );
                }),
                (i.prototype.toggle = function (t) {
                    var e;
                    return (
                        (e = this),
                        "left-sidebar" === t && "closed" === e.state
                            ? e.openLeft()
                            : "left-sidebar" === t && "left--opened" === e.state
                            ? e.closeLeft()
                            : "right-sidebar" === t && "closed" === e.state
                            ? e.openRight()
                            : "right-sidebar" === t && "right--opened" === e.state
                            ? e.closeRight()
                            : void 0
                    );
                }),
                (i.prototype.openLeft = function () {
                    var t;
                    return (
                        (t = this),
                        t.root.css("overflow", "hidden"),
                        t.left_sidebar.css("display", "block"),
                        (t.window_offset = window.pageYOffset),
                        t.main_content.css("top", "-" + t.window_offset + "px"),
                        t.main_content.css("position", "fixed"),
                        t.setState("left--opening"),
              //         	$('.off-canvas--viewport div .icon--root.icon--cross path').css('color','white'),
          				// $('.off-canvas--viewport div .icon--root.icon--cross path').css('fill','white'),
                        window.scrollTo(0, 0)
                    );
                }),
                (i.prototype.openLeftComplete = function () {
                    var t;
                    return (t = this), t.setFocus("left-sidebar"), t.left_sidebar.find(".disclosure--root").trigger("update_form_position");
                }),
                (i.prototype.openRight = function () {
                    var t;
                    return (
                        (t = this),
                        t.root.css("overflow", "hidden"),
                        t.right_sidebar.css("display", "block"),
                        (t.window_offset = window.pageYOffset),
                        t.main_content.css("top", "-" + t.window_offset + "px"),
                        t.main_content.css("position", "fixed"),
                        t.setState("right--opening"),
              //         	$('.off-canvas--viewport div .icon--root.icon--cross path').css('color','#44572b'),
          				// $('.off-canvas--viewport div .icon--root.icon--cross path').css('fill','#44572b'),
                        window.scrollTo(0, 0)
                    );
                }),
                (i.prototype.openRightComplete = function () {
                    var t;
                    return (t = this), t.setFocus("right-sidebar"), t.right_sidebar.find(".disclosure--root").trigger("update_form_position");
                }),
                (i.prototype.closeLeft = function () {
                    var t;
                    return (t = this), t.setState("left--closing"), t.last_trigger.focus();
                }),
                (i.prototype.closeLeftComplete = function () {
                    var t;
                    return (t = this), t.root.css("overflow", "unset"), t.left_sidebar.css("display", "none"), t.main_content.css("position", "relative"), t.main_content.css("top", "initial"), window.scrollTo(0, t.window_offset);
                }),
                (i.prototype.closeRight = function () {
                    var t;
                    return (t = this), t.setState("right--closing"), t.last_trigger.focus();
                }),
                (i.prototype.closeRightComplete = function () {
                    var t;
                    return (t = this), t.root.css("overflow", "unset"), t.right_sidebar.css("display", "none"), t.main_content.css("position", "relative"), t.main_content.css("top", "initial"), window.scrollTo(0, t.window_offset);
                }),
                (i.prototype.setFocus = function (t) {
                    var e, i, o;
                    if (
                        ((e = this),
                        "right-sidebar" === t ? (i = e.right_sidebar.find("[data-view='" + e.right_sidebar_view + "']")) : (t = "left-sidebar") && (i = e.left_sidebar.find("[data-view='menu']")),
                        (o = theme.utils.getFocusableEl(i)))
                    )
                        return o.focus(0);
                }),
                (i.prototype.touchListener = function () {
                    var e;
                    if (((e = this), theme.utils.isTouchDevice()))
                        return (
                            t(document).on("theme:swipe:left", function () {
                                if ("left--opened" === e.state) return e.closeLeft();
                            }),
                            t(document).on("theme:swipe:right", function () {
                                if ("right--opened" === e.state) return e.closeRight();
                            })
                        );
                }),
                (i.prototype.transitionListeners = function () {
                    var t;
                    return (
                        (t = this),
                        t.overlay.on("transition:at_start", function () {
                            if (("left--closing" === t.state && (t.setState("closed"), t.closeLeftComplete()), "right--closing" === t.state)) return t.setState("closed"), t.closeRightComplete();
                        }),
                        t.overlay.on("transition:at_end", function () {
                            if (("left--opening" === t.state && (t.setState("left--opened"), t.openLeftComplete()), "right--opening" === t.state)) return t.setState("right--opened"), t.openRightComplete();
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkPasswordPage = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.cancelLoginListener = e(this.cancelLoginListener, this)),
                    (this.loginFormListener = e(this.loginFormListener, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.login_form = i.root.find(".password--login-form")),
                    (i.login_cancel = i.root.find(".password--cancel")),
                    (i.login_link = i.root.find(".password--login-link")),
                    (i.signup_form = i.root.find(".password--main > *")),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (t = this), t.loginFormListener(), t.cancelLoginListener();
                }),
                (i.prototype.loginFormListener = function () {
                    var e;
                    return (
                        (e = this),
                        e.login_link.on("click keydown", function (i) {
                            if ((i.preventDefault(), "keydown" !== i.type || "Enter" === i.key))
                                return t(this).css("visibility", "hidden"), e.signup_form.hide(), e.login_form.css("visibility", "visible"), e.login_form.find('input[type="password"]').focus();
                        })
                    );
                }),
                (i.prototype.cancelLoginListener = function () {
                    var t;
                    return (
                        (t = this),
                        t.login_cancel.on("click keydown", function (e) {
                            if ("keydown" !== e.type || "Enter" === e.key) return t.signup_form.show(), t.login_form.css("visibility", "hidden"), t.login_link.css("visibility", "visible");
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkProductModel = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.loadModel = e(this.loadModel, this)),
                    (this.loadAssets = e(this.loadAssets, this)),
                    (this.eventListeners = e(this.eventListeners, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.view = i.root.data("view")),
                    (i.key = i.root.closest("[data-id]").data("id")),
                    (i.cdn = "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui"),
                    (i.xr_cdn = "https://cdn.shopify.com/shopifycloud/shopify-xr-js/assets/v1.0/shopify-xr.en.js"),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    if (((t = this), t.eventListeners(), !theme.utils.modelAssetsAdded)) return (theme.utils.modelAssetsAdded = !0), t.loadAssets();
                }),
                (i.prototype.eventListeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.root.on("model-ready", function () {
                            return e.loadModel();
                        }),
                        e.root.on("theme:section:load", function () {
                            return e.loadModel();
                        }),
                        e.root.on("pause-media", function () {
                            if (e.model) return e.model.pause();
                        }),
                        e.root.on("play-media", function () {
                            if (e.model) return e.model.play();
                        }),
                        theme.window.on(
                            "resize.ProductModel",
                            theme.utils.debounce(250, function () {
                                return t(".product-model--root").trigger("pause-media"), t(".product-model--root").trigger("model-ready");
                            })
                        )
                    );
                }),
                (i.prototype.loadAssets = function () {
                    var e;
                    return (
                        (e = this),
                        theme.utils.insertStylesheet(e.cdn + ".css"),
                        theme.utils.insertScript(e.xr_cdn),
                        theme.utils.insertScript(e.cdn + ".en.js", function () {
                            return t(".product-model--root").trigger("model-ready");
                        })
                    );
                }),
                (i.prototype.loadModel = function () {
                    var t;
                    if (((t = this), !t.model && !(("small" === theme.utils.mqs.current_window && "desktop" === t.view) || ("small" !== theme.utils.mqs.current_window && "mobile" === t.view))))
                        return "undefined" != typeof Shopify ? (t.model = new Shopify.ModelViewerUI(t.root.find("model-viewer").el[0])) : void 0;
                }),
                i
            );
        })()),
        (theme.classes.FrameworkProductRecommendations = (function () {
            function i(t) {
                var i, o, r;
                (this.root = t),
                    (this.resizeListeners = e(this.resizeListeners, this)),
                    (this.loadHoverImages = e(this.loadHoverImages, this)),
                    (this.initProductItems = e(this.initProductItems, this)),
                    (this.matchImageHeights = e(this.matchImageHeights, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (r = i.root.attr("data-product-id")),
                    (o = i.root.attr("data-max-products")),
                    (i.request_url = theme.urls.product_recommendations + "?section_id=framework--product-recommendations&limit=" + o + "&product_id=" + r),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t, e;
                    return (
                        (t = this),
                        (e = new XMLHttpRequest()),
                        (e.onload = function () {
                            var i;
                            if (e.status >= 200 && e.status < 300)
                                return (
                                    (i = theme.utils.parseHtml(e.response, ".product-recommendations--container")),
                                    t.root.append(i),
                                    t.root.find(".product--root").length ? (t.matchImageHeights(), t.initProductItems(), t.loadHoverImages(), t.resizeListeners()) : void t.root.hide()
                                );
                        }),
                        (e.onerror = function () {
                            return console.log(e.statusText + ": recommendation HTML request failed!");
                        }),
                        e.open("GET", t.request_url),
                        e.send()
                    );
                }),
                (i.prototype.matchImageHeights = function () {
                    var t, e, i;
                    return (t = this), (e = t.root.find(".product-recommendations--body")), (i = t.root.find(".product--root")), theme.utils.matchImageHeights(e, i, ".product--image-wrapper");
                }),
                (i.prototype.initProductItems = function () {
                    var t;
                    return (t = this), theme.settings.quick_add && (theme.partials.OffCanvas.unload(), theme.partials.OffCanvas.load()), theme.utils.loadJsClasses(t.root);
                }),
                (i.prototype.loadHoverImages = function () {
                    var e;
                    return (
                        (e = this),
                        e.root.find(".product--hover-image").each(function (e) {
                            return (
                                (e = t(e)),
                                theme.utils.imagesLoaded(e, function () {
                                    var t;
                                    return (t = e.closest('[data-hover-image="true"]')), t.attr("data-hover-image", "loaded");
                                })
                            );
                        })
                    );
                }),
                (i.prototype.resizeListeners = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "resize.ProductRecommendations",
                            theme.utils.debounce(100, function () {
                                return t.matchImageHeights();
                            })
                        )
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkProductVideo = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.skipVideo = e(this.skipVideo, this)),
                    (this.loadYoutubeVideo = e(this.loadYoutubeVideo, this)),
                    (this.loadPlyrVideo = e(this.loadPlyrVideo, this)),
                    (this.loadYoutubeAsset = e(this.loadYoutubeAsset, this)),
                    (this.loadPlyrAssets = e(this.loadPlyrAssets, this)),
                    (this.resizeListener = e(this.resizeListener, this)),
                    (this.youtubeListeners = e(this.youtubeListeners, this)),
                    (this.plyrListeners = e(this.plyrListeners, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.view = i.root.data("view")),
                    (i.type = i.root.data("type")),
                    (i.loop_enabled = i.root.data("loop-enabled")),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (
                        (t = this),
                        t.resizeListener(),
                        "youtube" === t.type
                            ? ((t.id = t.root.find(".product-video").attr("id")), (t.video_id = t.root.data("video-id")), t.youtubeListeners(), t.loadYoutubeAsset())
                            : ((t.plyr_cdn = "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr"), t.plyrListeners(), t.loadPlyrAssets())
                    );
                }),
                (i.prototype.plyrListeners = function () {
                    var t;
                    return (
                        (t = this),
                        t.root.on("plyr-video-ready", function () {
                            return t.loadPlyrVideo();
                        }),
                        t.root.on("theme:section:load", function () {
                            return t.loadPlyrVideo();
                        }),
                        t.root.on("pause-media", function () {
                            if (t.video) return t.video.pause();
                        }),
                        t.root.on("play-media", function () {
                            if (t.video) return t.video.play();
                        })
                    );
                }),
                (i.prototype.youtubeListeners = function () {
                    var t;
                    return (
                        (t = this),
                        window.addEventListener("theme:utils:youtubeAPIReady", function () {
                            return t.loadYoutubeVideo();
                        }),
                        t.root.on("theme:section:load", function () {
                            return t.loadYoutubeVideo();
                        })
                    );
                }),
                (i.prototype.resizeListener = function () {
                    return (
                        this,
                        theme.window.on(
                            "resize.ProductVideo",
                            theme.utils.debounce(250, function () {
                                return t(".product-video--root").trigger("pause-media"), t(".product-video--root").trigger("plyr-video-ready"), t(".product-video--root").trigger("theme:utils:youtubeAPIReady");
                            })
                        )
                    );
                }),
                (i.prototype.loadPlyrAssets = function () {
                    var e;
                    if (((e = this), !theme.utils.plyrScriptAdded))
                        return (
                            (theme.utils.plyrScriptAdded = !0),
                            theme.utils.insertStylesheet(e.plyr_cdn + ".css"),
                            theme.utils.insertScript(e.plyr_cdn + ".en.js", function () {
                                return t(".product-video--root").trigger("plyr-video-ready");
                            })
                        );
                }),
                (i.prototype.loadYoutubeAsset = function () {
                    if ((this, !theme.utils.youtube_script_added)) return (theme.utils.youtube_script_added = !0), theme.utils.insertScript("https://www.youtube.com/iframe_api");
                }),
                (i.prototype.loadPlyrVideo = function () {
                    var t;
                    if (((t = this), !t.video && !t.skipVideo())) return "undefined" != typeof Shopify ? (t.video = new Shopify.Plyr(t.root.find("video").el[0], { iconUrl: t.plyr_cdn + ".svg", loop: { active: t.loop_enabled } })) : void 0;
                }),
                (i.prototype.loadYoutubeVideo = function () {
                    var e;
                    if (((e = this), !e.video && !e.skipVideo()))
                        return "undefined" != typeof YT
                            ? (e.video = new YT.Player(e.id, {
                                  videoId: e.video_id,
                                  events: {
                                      onReady: function (t) {
                                          return (
                                              e.root.on("pause-media", function () {
                                                  return t.target.pauseVideo();
                                              }),
                                              e.root.on("play-media", function () {
                                                  return t.target.playVideo();
                                              })
                                          );
                                      },
                                      onStateChange: function (i) {
                                          if ((0 === i.data && e.loop_enabled && i.target.seekTo(0), 1 === i.data)) return t(".product-media--featured > *").not(e.root).trigger("pause-media");
                                      },
                                  },
                              }))
                            : void 0;
                }),
                (i.prototype.skipVideo = function () {
                    var t;
                    return (t = this), ("small" === theme.utils.mqs.current_window && "desktop" === t.view) || ("small" !== theme.utils.mqs.current_window && "mobile" === t.view);
                }),
                i
            );
        })()),
        (theme.classes.FrameworkProduct = (function () {
            function i(i) {
                var o;
                (this.root = i),
                    (this.updateRecentList = e(this.updateRecentList, this)),
                    (this.thumbNavigation = e(this.thumbNavigation, this)),
                    (this.initZoomListener = e(this.initZoomListener, this)),
                    (this.getActiveImageId = e(this.getActiveImageId, this)),
                    (this.imageZoom = e(this.imageZoom, this)),
                    (this.updateVariantMedia = e(this.updateVariantMedia, this)),
                    (this.addProductComplete = e(this.addProductComplete, this)),
                    (this.addToCartListener = e(this.addToCartListener, this)),
                    (this.updatePrices = e(this.updatePrices, this)),
                    (this.enableStockForm = e(this.enableStockForm, this)),
                    (this.enableCartButtons = e(this.enableCartButtons, this)),
                    (this.variantSelected = e(this.variantSelected, this)),
                    (this.updateHistoryState = e(this.updateHistoryState, this)),
                    (this.updateVariant = e(this.updateVariant, this)),
                    (this.optionChangeListener = e(this.optionChangeListener, this)),
                    (this.updateLowInStock = e(this.updateLowInStock, this)),
                    (this.sizeChart = e(this.sizeChart, this)),
                    (this.updatePickup = e(this.updatePickup, this)),
                    (this.getProductJson = e(this.getProductJson, this)),
                    (this.load = e(this.load, this)),
                    (o = this),
                    (o.form_root = o.root.find(".product-form--root")),
                    (o.thumbs_root = o.root.find('.product-media--root[data-view="thumbs"]')),
                    (o.featured_root = o.root.find('.product-media--root[data-view="featured"]').not('[data-media-size="mobile"]')),
                    o.featured_root &&
                        ((o.magnify = o.featured_root.data("magnify")),
                        (o.main_media = o.featured_root.find(".product-media--featured")),
                        (o.media_container = o.featured_root.closest(".product-media--wrapper")),
                        (o.model_buttons = o.root.find("[data-shopify-xr]")),
                        (o.thumbs = o.thumbs_root.find(".product-media--thumb")),
                        (o.zoom_enabled = o.featured_root.data("zoom-enabled")),
                        (o.zoom_images = o.featured_root.find(".product-media--zoom-image"))),
                    (o.add_to_cart_button = o.form_root.find(".product-form--add-to-cart")),
                    (o.button_container = o.form_root.find(".product-form--button-container")),
                    (o.button_text_container = o.form_root.find(".product-form--text")),
                    (o.callback_enabled = o.form_root.data("callback-enabled")),
                    (o.compare_price = o.form_root.find(".product-form--compare-price")),
                    (o.form = o.form_root.find(".product-form--container")),
                    (o.handle = o.form_root.attr("data-handle")),
                    (o.is_only_variant = o.form_root.data("is-only-variant")),
                    (o.low_stock_container = o.form_root.find(".product-form--low-stock")),
                    (o.low_stock_threshold = o.form_root.data("low-stock-amount")),
                    (o.pickup_enabled = o.form_root.data("pickup-enabled")),
                    (o.pickup_drawer_container = t('.off-canvas--container[data-view="pickup"]')),
                    (o.pickup_form_container = o.root.find(".product-form--pickup")),
                    (o.pickup_form_spinner = o.root.find(".product-form--pickup--spinner")),
                    (o.price = o.form_root.find(".product-form--price")),
                    (o.price_container = o.form_root.find(".product-form--price-container")),
                    (o.product_title = o.form_root.attr("data-title")),
                    (o.reference_unit = o.form_root.find(".product-form--reference-unit")),
                    (o.reference_value = o.form_root.find(".product-form--reference-value")),
                    (o.show_low_in_stock = void 0 !== o.low_stock_threshold),
                    (o.size_chart_enabled = o.form_root.data("size-chart-enabled")),
                    (o.size_chart_option = o.form_root.attr("data-size-chart-option")),
                    (o.smart_payment_buttons = o.form_root.find(".product-form--smart-payment-buttons")),
                    (o.sold_out = o.form_root.data("sold-out")),
                    (o.unavailable_container = o.form_root.find(".product-form--unavailable")),
                    (o.unavailable_button = o.unavailable_container.find("button")),
                    (o.unit_price_container = o.form_root.find(".product-form--unit-price-container")),
                    (o.unit_price = o.form_root.find(".product-form--unit-price")),
                    (o.variant_container = o.form_root.find(".product-form--variants")),
                    (o.variant_listbox = o.form_root.find(".product-form--variant-select")),
                    (o.first_variant_available = o.variant_listbox.find("[selected]").data("available")),
                    (o.first_variant_id = parseInt(o.variant_listbox.find("[selected]").val())),
                    (o.first_variant_inventory = o.variant_listbox.find("[selected]").data("inventory")),
                    (o.option_inputs = o.variant_container.find('[data-item="disclosure"], [data-item="radio"]')),
                    o.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    if (
                        ((t = this),
                        t.sold_out ||
                            (t.handle && t.getProductJson(),
                            t.pickup_enabled && t.first_variant_inventory && t.first_variant_available && t.updatePickup(t.first_variant_id),
                            t.show_low_in_stock && t.updateLowInStock(t.first_variant_id),
                            "drawer" === theme.settings.cart_type && t.addToCartListener()),
                        t.zoom_enabled && t.initZoomListener(),
                        t.thumbs && t.thumbNavigation(),
                        t.handle)
                    )
                        return t.updateRecentList();
                }),
                (i.prototype.getProductJson = function () {
                    var t, e;
                    return (
                        (t = this),
                        (e = new XMLHttpRequest()),
                        (e.onload = function () {
                            var i;
                            if (e.status >= 200 && e.status < 300 && ((i = JSON.parse(e.response)), i.variants.length > 1 && (t.optionChangeListener(i.variants), t.size_chart_enabled))) return t.sizeChart(i.options);
                        }),
                        (e.onerror = function () {
                            return console.log(e.statusText + ": product.json request failed!");
                        }),
                        e.open("GET", theme.urls.root + "/products/" + t.handle + ".js"),
                        e.send()
                    );
                }),
                (i.prototype.updatePickup = function (t) {
                    var e, i;
                    return (
                        (e = this),
                        e.pickup_form_spinner.show(),
                        e.pickup_form_container.hide(),
                        (i = new XMLHttpRequest()),
                        (i.onload = function () {
                            var t, o;
                            if (i.status >= 200 && i.status < 300)
                                return (
                                    (o = theme.utils.parseHtml(i.response, ".pickup--form--container")),
                                    e.pickup_form_container.empty().append(o),
                                    e.pickup_form_spinner.hide(),
                                    e.pickup_form_container.show(),
                                    (t = theme.utils.parseHtml(i.response, ".pickup--drawer--container")),
                                    t.length && (t.find(".pickup--drawer--product-title").text(e.product_title), e.is_only_variant && t.find(".pickup--drawer--variant-title").hide(), e.pickup_drawer_container.empty().append(t)),
                                    theme.partials.OffCanvas.unload(),
                                    theme.partials.OffCanvas.load()
                                );
                        }),
                        (i.onerror = function () {
                            return console.log(i.statusText + ": product pickup request failed!");
                        }),
                        i.open("GET", theme.urls.root + "/variants/" + t + "/?section_id=framework--pickup"),
                        i.send()
                    );
                }),
                (i.prototype.sizeChart = function (e) {
                    var i;
                    return (
                        (i = this),
                        i.form_root.find(".disclosure--root, .radios--header").each(function (o, r) {
                            var n;
                            if (e[r].name.toLowerCase() === i.size_chart_option.toLowerCase())
                                return (
                                    (n = theme.utils.parseHtml(
                                        "<div class='product-form--modal-link' data-item='block-link'> <a class='modal--link' href='#'> " + theme.translations.size_chart_label + " </a> </div>",
                                        ".product-form--modal-link"
                                    )),
                                    t(o).append(n),
                                    !1
                                );
                        }),
                        new theme.classes.FrameworkModal(i.form_root.find('[data-js-class="FrameworkModal"]'))
                    );
                }),
                (i.prototype.updateLowInStock = function (t) {
                    var e, i, o;
                    return (
                        (e = this),
                        !(o = e.variant_listbox.find("[value='" + t + "']").data("inventory-quantity")) || o > e.low_stock_threshold
                            ? void e.low_stock_container.hide()
                            : (1 === o ? (i = theme.translations.low_in_stock.one) : o > 1 && ((i = theme.translations.low_in_stock.other), (i = i.replace(/\d+/, o))), e.low_stock_container.text(i).show())
                    );
                }),
                (i.prototype.optionChangeListener = function (e) {
                    var i;
                    return (
                        (i = this),
                        i.option_inputs.on("change", function () {
                            var o, r, n, s, a;
                            for (
                                o = i.variant_container.find('[data-item="disclosure"], [data-item="radio"]:checked'),
                                    s = [],
                                    o.each(function (e) {
                                        return s.push(t(e).val().trim());
                                    }),
                                    r = 0,
                                    n = e.length;
                                r < n;
                                r++
                            )
                                if (
                                    ((a = e[r]),
                                    a.options.every(function (t) {
                                        return s.includes(t);
                                    }))
                                )
                                    return void i.updateVariant(a);
                            return i.updateVariant(!1);
                        })
                    );
                }),
                (i.prototype.updateVariant = function (t) {
                    var e;
                    return (e = this), e.callback_enabled ? (e.updateHistoryState(t.id), selectCallback(t)) : e.variantSelected(t);
                }),
                (i.prototype.updateHistoryState = function (t) {
                    var e;
                    return this, (e = "" + location.origin + location.pathname), t && (e += "?variant=" + t), history.replaceState({ path: e }, "", e);
                }),
                (i.prototype.variantSelected = function (t) {
                    var e;
                    if (
                        ((e = this),
                        e.form.find(".product-form--error").remove(),
                        e.low_stock_container.hide(),
                        e.variant_listbox.find("option[selected]").removeAttr("selected"),
                        e.updatePrices(t),
                        t && t.available
                            ? (e.variant_listbox.find("option[value='" + t.id + "']").attr("selected", ""),
                              e.enableCartButtons(!0, !0),
                              e.enableStockForm(!1),
                              e.show_low_in_stock && e.updateLowInStock(t.id),
                              e.pickup_enabled && t.inventory_management && e.updatePickup(t.id))
                            : t && !t.available
                            ? (e.variant_listbox.find("option[value='" + t.id + "']").attr("selected", ""), e.enableCartButtons(!1, !0), e.enableStockForm(!0))
                            : (e.enableCartButtons(!1, !1), e.enableStockForm(!1)),
                        e.pickup_enabled && !t.available && e.pickup_form_container.hide(),
                        t.featured_media)
                    )
                        return e.updateVariantMedia(t.featured_media.id);
                }),
                (i.prototype.enableCartButtons = function (t, e) {
                    var i;
                    return (
                        (i = this),
                        t
                            ? (i.add_to_cart_button.removeAttr("disabled"), i.button_text_container.text(theme.translations.add_to_cart), i.smart_payment_buttons.removeAttr("style"))
                            : (i.add_to_cart_button.attr("disabled", !0), i.smart_payment_buttons.hide(), e ? i.button_text_container.text(theme.translations.out_of_stock) : i.button_text_container.text(theme.translations.unavailable))
                    );
                }),
                (i.prototype.enableStockForm = function (t) {
                    var e;
                    return (e = this), t ? (e.unavailable_button.removeAttr("disabled"), e.unavailable_container.show()) : (e.unavailable_button.attr("disabled", !0), e.unavailable_container.hide());
                }),
                (i.prototype.updatePrices = function (t) {
                    var e, i, o, r;
                    return (
                        (e = this),
                        t
                            ? (e.price_container.removeAttr("style"),
                              (r = theme.utils.formatMoney(t.price)),
                              e.price.html(r),
                              t.compare_at_price > t.price ? ((i = theme.utils.formatMoney(t.compare_at_price)), e.compare_price.html(i), e.compare_price.attr("style", "display:inline-block;")) : e.compare_price.hide(),
                              t.unit_price_measurement
                                  ? ((o = theme.utils.formatMoney(t.unit_price)),
                                    e.unit_price.html(o),
                                    e.reference_unit.html(t.unit_price_measurement.reference_unit),
                                    1 === t.unit_price_measurement.reference_value ? e.reference_value.hide() : (e.reference_value.html(t.unit_price_measurement.reference_value), e.reference_value.show()),
                                    e.unit_price_container.attr("style", "display:flex;"))
                                  : e.unit_price_container.hide())
                            : void e.price_container.hide()
                    );
                }),
                (i.prototype.addToCartListener = function () {
                    var e;
                    if (((e = this), e.form.length > 0 && "drawer" === theme.settings.cart_type))
                        return e.form.on("submit", function (i) {
                            return (
                                e.form.find(".product-form--error").remove(),
                                e.button_container.attr("data-loading", "true"),
                                theme.partials.Cart.addItem(t(this), function (t, i) {
                                    var o;
                                    return t
                                        ? theme.partials.Cart.updateAllHtml(function () {
                                              return e.addProductComplete();
                                          })
                                        : ((o = theme.utils.parseHtml("<div class='product-form--error' data-item='small-text'>" + i + "</div>", ".product-form--error")), e.button_container.insertBefore(o).attr("data-loading", "false"));
                                }),
                                i.preventDefault(),
                                i.stopPropagation()
                            );
                        });
                }),
                (i.prototype.addProductComplete = function () {
                    var e;
                    if (((e = this), e.button_container.attr("data-loading", "false"), t(".off-canvas--right-sidebar").attr("data-active", "cart"), "closed" === theme.partials.OffCanvas.state))
                        return (theme.partials.OffCanvas.right_sidebar_view = "cart"), theme.partials.OffCanvas.openRight(), (theme.partials.OffCanvas.last_trigger = e.add_to_cart_button);
                }),
                (i.prototype.updateVariantMedia = function (t) {
                    var e, i, o, r;
                    if (
                        ((e = this),
                        e.main_media.attr("data-active", "false"),
                        e.main_media.parent().hide(),
                        (o = e.main_media.filter("[data-id='" + t + "']")),
                        o.attr("data-active", "true"),
                        o.parent().show(),
                        e.thumbs.attr("data-active", "false"),
                        (r = e.thumbs.filter("[data-id='" + t + "']")),
                        r.attr("data-active", "true"),
                        e.model_buttons.attr("data-active", "false"),
                        (i = e.model_buttons.filter("[data-shopify-model3d-id='" + t + "']")),
                        i.attr("data-active", "true"),
                        e.zoom_enabled)
                    )
                        return e.imageZoom();
                }),
                (i.prototype.imageZoom = function () {
                    var t, e, i, o, r, n, s, a, l, u;
                    if (
                        ((t = this),
                        (e = t.zoom_images.filter("[data-id='" + t.getActiveImageId() + "']")),
                        e.css("display", "none"),
                        t.media_container.off("mouseenter.Product.ImageZoom mouseleave.Product.ImageZoom"),
                        !(t.main_media.length < 1 || "small" === theme.utils.mqs.current_window))
                    )
                        return e.length > 0
                            ? (t.media_container.attr("data-media-type", "image"),
                              (a = t.media_container.width()),
                              (s = t.media_container.height()),
                              (r = a * t.magnify),
                              (o = s * t.magnify),
                              (i = t.media_container.offset().left),
                              (n = t.media_container.offset().top),
                              e.css("width", r + "px"),
                              e.find(".image--root").css("width", r + "px"),
                              e.find("img").addClass("lazypreload"),
                              (l = (r - a) / a),
                              (u = (o - s) / s),
                              t.media_container.on("mouseenter.Product.ImageZoom", function () {
                                  return e.css("display", "block");
                              }),
                              t.media_container.on("mouseleave.Product.ImageZoom", function () {
                                  return e.css("display", "none");
                              }),
                              t.media_container.on("mousemove", function (t) {
                                  var o, r;
                                  return (o = t.pageX - i), (r = t.pageY - n), e.css("left", o * -l + "px"), e.css("top", r * -u + "px");
                              }))
                            : t.media_container.attr("data-media-type", "");
                }),
                (i.prototype.getActiveImageId = function () {
                    var t, e;
                    return (t = this), (e = t.main_media.filter('[data-active="true"]')), e.attr("data-id");
                }),
                (i.prototype.initZoomListener = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "resize.Product",
                            theme.utils.debounce(100, function () {
                                return t.imageZoom();
                            })
                        )
                    );
                }),
                (i.prototype.thumbNavigation = function () {
                    var e;
                    return (
                        (e = this),
                        e.thumbs.on("keypress click", function (i) {
                            var o, r, n;
                            if (
                                theme.utils.a11yClick(i) &&
                                ((n = e.root.find('.product-media--featured[data-active="true"] > *')),
                                n.trigger("pause-media"),
                                (o = t(this).attr("data-id")),
                                (r = e.root.find(".product-media--featured[data-id='" + o + "'] > *")),
                                e.updateVariantMedia(o),
                                "small" !== theme.utils.mqs.current_window && r.trigger("play-media"),
                                "image" !== r.parent().attr("data-media-type"))
                            )
                                return r.focus();
                        })
                    );
                }),
                (i.prototype.updateRecentList = function () {
                    var t, e, i, o, r, n, s;
                    if (
                        ((t = this),
                        (e = [t.handle]),
                        (s = localStorage.getItem(theme.local_storage.recent_products)),
                        (o = 4),
                        s ? ((n = JSON.parse(s)), -1 === n.indexOf(t.handle) && (r = !0)) : ((i = JSON.stringify(e)), localStorage.setItem(theme.local_storage.recent_products, i)),
                        r)
                    )
                        return n.length === o && (n = n.slice(1)), (i = JSON.stringify(n.concat(e))), localStorage.setItem(theme.local_storage.recent_products, i);
                }),
                (i.clearQuickAddForms = function (e) {
                    return (
                        null == e && (e = ""),
                        t(".off-canvas--right-sidebar")
                            .find(".product--form[data-product-id*='" + e + "']")
                            .remove()
                    );
                }),
                (i.initQuickAddForm = function (e) {
                    var i, o, r;
                    return (
                        t(".off-canvas--right-sidebar").find(".product--form").hide(),
                        (r = e.attr("data-product-id")),
                        (i = t(".off-canvas--right-sidebar").find("[data-product-id='" + r + "']")),
                        i.length > 0
                            ? (i.show(), theme.partials["Product-" + r].updateRecentList())
                            : ((o = e.closest(".product--root").find(".product--form")), (theme.partials["Product-" + r] = new theme.classes.Product(o)), t('[data-view="product-form"]').append(o))
                    );
                }),
                (i.quickAddToCart = function (t) {
                    var e;
                    return (
                        t.attr("data-loading", !0),
                        (e = t.closest(".product--root")),
                        e.find(".product--error").remove(),
                        theme.partials.Cart.addItem(e.find(".product-form--container"), function (i, o) {
                            var r;
                            return (
                                i
                                    ? theme.partials.Cart.updateAllHtml(function () {
                                          if ((t.attr("data-loading", !1), "closed" === theme.partials.OffCanvas.state)) return theme.partials.OffCanvas.openRight();
                                      })
                                    : ((r = theme.utils.parseHtml("<div class='product--error' data-item='small-text'> " + o + " </div>", ".product--error")), e.find(".product--details-container").append(r), t.attr("data-loading", !1)),
                                theme.window.trigger("resize")
                            );
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkRadios = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.setSwatchAppearance = e(this.setSwatchAppearance, this)),
                    (this.updateLabelOnChange = e(this.updateLabelOnChange, this)),
                    (this.preventFormSubmitOnEnter = e(this.preventFormSubmitOnEnter, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.current_value = i.root.find(".radios--option-current")),
                    (i.inputs = i.root.find('[data-item="radio"]')),
                    (i.is_swatches = i.root.data("is-swatches")),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    if (((t = this), t.preventFormSubmitOnEnter(), t.is_swatches)) return t.updateLabelOnChange(), t.setSwatchAppearance();
                }),
                (i.prototype.preventFormSubmitOnEnter = function () {
                    var t;
                    return (
                        (t = this),
                        t.inputs.on("keydown", function (t) {
                            if ("Enter" === t.key) return t.preventDefault();
                        })
                    );
                }),
                (i.prototype.updateLabelOnChange = function () {
                    var e;
                    return (
                        (e = this),
                        e.inputs.on("change", function () {
                            // return e.current_value.text(t(this).val());
                          var updatedValue = t(this).val().replace(/-/g, ', ');
                          return e.current_value.text(updatedValue);
                        })
                    );
                }),
                (i.prototype.setSwatchAppearance = function () {
                    var e;
                    return (
                        (e = this),
                        e.inputs.each(function (e) {
                            var i, o;
                            // return (
                            //     (i = t(e).siblings(".radios--swatch-button")),
                            //     (o = t(e).val().toLowerCase().replace(/\s+/g, "")),
                            //     void 0 === theme.swatches[o]
                            //         ? i.css("background-color", o)
                            //         : theme.swatches[o].indexOf("cdn.shopify.com") > -1
                            //         ? i.css("background-image", "url(" + theme.swatches[o] + ")")
                            //         : i.css("background-color", theme.swatches[o])
                            // );
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkRecentProducts = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.hoverImagesLoaded = e(this.hoverImagesLoaded, this)),
                    (this.matchImageHeights = e(this.matchImageHeights, this)),
                    (this.resizeListeners = e(this.resizeListeners, this)),
                    (this.formatProducts = e(this.formatProducts, this)),
                    (this.checkIfAllProductsLoaded = e(this.checkIfAllProductsLoaded, this)),
                    (this.renderProductItem = e(this.renderProductItem, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.main_grid = i.root.find(".collection--recent-products--grid")),
                    (i.num_errors = 0),
                    (i.num_loaded = 0),
                    (i.spinner = i.root.find(".collection--recent-products--spinner")),
                    (i.storage = JSON.parse(localStorage.getItem(theme.local_storage.recent_products))),
                    i.storage ? i.load() : i.root.hide();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (
                        (t = this),
                        t.storage.forEach(function (e) {
                            return t.renderProductItem(e);
                        })
                    );
                }),
                (i.prototype.renderProductItem = function (t) {
                    var e, i;
                    return (
                        (e = this),
                        (i = new XMLHttpRequest()),
                        (i.onload = function () {     
                            var t;
                            document.querySelectorAll('.collection--recent-products--grid .product--root').forEach(function(elem) {             
                                var price = elem.querySelector('.product--price')
                                 if(price.innerHTML.trim() == ''){
                                   elem.style.display = 'none';
                                 }else{
                                   elem.style.display = 'block';
                                 }
                            }); 
                            if (i.status >= 200 && i.status < 300) return (t = theme.utils.parseHtml(i.response, ".product--root")), e.main_grid.prepend(t), e.checkIfAllProductsLoaded();
                            
                        }),
                        (i.onerror = function () {
                            return e.num_errors++, e.num_errors === e.storage.length ? e.root.hide() : e.checkIfAllProductsLoaded();
                        }),
                        i.open("GET", theme.urls.search + "?view=ajax-recent-product&handle=" + t),
                        i.send()
                    );
                }),
                (i.prototype.checkIfAllProductsLoaded = function () {
                    var t;
                    if (((t = this), ++t.num_loaded === t.storage.length)) return t.main_grid.removeAttr("style"), t.spinner.hide(), t.formatProducts();
                }),
                (i.prototype.formatProducts = function () {
                    var t;
                    if (((t = this), t.resizeListeners(), t.matchImageHeights(), theme.utils.loadJsClasses(t.main_grid), theme.settings.hover_image_enabled && t.hoverImagesLoaded(), theme.settings.quick_add))
                        return theme.partials.OffCanvas.unload(), theme.partials.OffCanvas.load();
                }),
                (i.prototype.resizeListeners = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "resize.RecentProducts",
                            theme.utils.debounce(100, function () {
                                return t.matchImageHeights();
                            })
                        )
                    );
                }),
                (i.prototype.matchImageHeights = function () {
                    var t;
                    return (t = this), theme.utils.matchImageHeights(t.main_grid, t.root.find(".product--root"), ".product--image-wrapper");
                }),
                (i.prototype.hoverImagesLoaded = function () {
                    var e;
                    return (
                        (e = this),
                        e.main_grid.find(".product--hover-image").each(function (e) {
                            return (
                                (e = t(e)),
                                theme.utils.imagesLoaded(e, function () {
                                    var t;
                                    return (t = e.closest('[data-hover-image="true"]')), t.attr("data-hover-image", "loaded");
                                })
                            );
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkSearch = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.resizeListeners = e(this.resizeListeners, this)),
                    (this.matchImageHeights = e(this.matchImageHeights, this)),
                    (this.toggleView = e(this.toggleView, this)),
                    (this.getResults = e(this.getResults, this)),
                    (this.listenForKeyEntered = e(this.listenForKeyEntered, this)),
                    (this.searchLinks = e(this.searchLinks, this)),
                    (this.onOpen = e(this.onOpen, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.articles = i.root.find(".search--articles")),
                    (i.form = i.root.find("form")),
                    (i.icon = i.root.find(".search--icon")),
                    (i.loading = i.root.find(".search--loading")),
                    (i.products = i.root.find(".search--products")),
                    (i.results = i.root.find(".search--results")),
                    (i.text_box = i.root.find(".search--textbox")),
                    (i.toggle_link = i.root.find(".search--toggle")),
                    (i.show_articles = i.root.data("show-articles")),
                    (i.show_pages = i.root.data("show-pages")),
                    (i.view = i.root.data("view")),
                    (i.article_page_combination = ""),
                    (i.num_loaded_views = 0),
                    (i.num_pending_views = 0),
                    (i.offCanvas = theme.partials.OffCanvas),
                    (i.typing_timer = null),
                    i.show_articles && i.show_pages ? (i.article_page_combination = "article,page") : i.show_articles ? (i.article_page_combination = "article") : i.show_pages && (i.article_page_combination = "page"),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (t = this), "modal" === t.view && (t.searchLinks(), t.listenForKeyEntered()), t.resizeListeners(), t.matchImageHeights();
                }),
                (i.prototype.onOpen = function () {
                    var t, e;
                    return (t = this), window.scrollTo(0, 0), t.text_box.focus(), (e = t.text_box.val()), t.text_box.val(""), t.text_box.val(e), t.text_box.trigger("keyup");
                }),
                (i.prototype.searchLinks = function () {
                    var e;
                    return (
                        (e = this),
                        t(".off-canvas--main-content a[href='" + theme.urls.search + "']").off("click"),
                        t(".off-canvas--main-content a[href='" + theme.urls.search + "']").on("click", function (i) {
                            return t('[data-trigger="search-modal"]').trigger("click"), e.onOpen(), i.preventDefault(), i.stopPropagation();
                        }),
                        t(".off-canvas--right-sidebar a[href='" + theme.urls.search + "']").off("click"),
                        t(".off-canvas--right-sidebar a[href='" + theme.urls.search + "']").on("click", function (i) {
                            return (
                                e.offCanvas.closeRight(),
                                setTimeout(function () {
                                    return t('[data-trigger="search-modal"]').trigger("click"), e.onOpen();
                                }, 450),
                                i.preventDefault(),
                                i.stopPropagation()
                            );
                        }),
                        t(".off-canvas--left-sidebar a[href='" + theme.urls.search + "']").off("click"),
                        t(".off-canvas--left-sidebar a[href='" + theme.urls.search + "']").on("click", function (i) {
                            return (
                                e.offCanvas.closeLeft(),
                                setTimeout(function () {
                                    return t('[data-trigger="search-modal"]').trigger("click"), e.onOpen();
                                }, 450),
                                i.preventDefault(),
                                i.stopPropagation()
                            );
                        })
                    );
                }),
                (i.prototype.listenForKeyEntered = function () {
                    var e;
                    return (
                        (e = this),
                        e.text_box.attr("autocomplete", "off").on("keyup paste", function (i) {
                            var o;
                            return (
                                clearTimeout(e.typing_timer),
                                (o = t(this).val()),
                                o.length < 2 && "paste" !== i.type
                                    ? (e.toggleView(!1, !0), !1)
                                    : (e.toggleView(!0, !0),
                                      (e.typing_timer = setTimeout(function () {
                                          var t;
                                          return (
                                              clearTimeout(e.typing_timer),
                                              e.show_articles || e.show_pages
                                                  ? ((e.num_pending_views = 2), (t = theme.urls.search + "?view=ajax-article-page&type=" + e.article_page_combination + "&q=" + o + "*"), e.getResults(t, "article"))
                                                  : (e.num_pending_views = 1),
                                              (t = theme.urls.search + "?view=ajax-product&type=product&q=" + o + "*"),
                                              e.getResults(t, "product")
                                          );
                                      }, 750)))
                            );
                        })
                    );
                }),
                (i.prototype.getResults = function (e, i) {
                    var o, r;
                    return (
                        (o = this),
                        o.toggleView(!0, !1),
                        (r = new XMLHttpRequest()),
                        (r.onload = function () {
                            var e;
                            if (
                                r.status >= 200 &&
                                r.status < 300 &&
                                ((o.num_loaded_views += 1),
                                (e = theme.utils.parseHtml(r.response)),
                                "product" === i ? (o.products.empty().append(e), o.matchImageHeights(), theme.utils.loadJsClasses(t(".search--products-container"))) : "article" === i && o.articles.empty().append(e),
                                o.num_loaded_views === o.num_pending_views)
                            )
                                return o.toggleView(!1, !0), (o.num_loaded_views = 0);
                        }),
                        (r.onerror = function () {
                            return console.log(r.statusText + ": search.json request failed!");
                        }),
                        r.open("GET", e),
                        r.send()
                    );
                }),
                (i.prototype.toggleView = function (t, e) {
                    var i;
                    return (
                        (i = this),
                        t ? (i.loading.show(), i.icon.hide()) : (i.loading.hide(), i.icon.show()),
                        e ? (i.products.css("opacity", "1"), i.articles.css("opacity", "1")) : (i.products.css("opacity", "0"), i.articles.css("opacity", "0"))
                    );
                }),
                (i.prototype.matchImageHeights = function () {
                    var t;
                    return (t = this), theme.utils.matchImageHeights(t.products, t.products.find(".product--root"), ".product--image-wrapper");
                }),
                (i.prototype.resizeListeners = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "resize.Search",
                            theme.utils.debounce(100, function () {
                                return t.matchImageHeights();
                            })
                        )
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkSections = (function () {
            function i() {
                (this.deselectBlock = e(this.deselectBlock, this)),
                    (this.selectBlock = e(this.selectBlock, this)),
                    (this.deselectSection = e(this.deselectSection, this)),
                    (this.selectSection = e(this.selectSection, this)),
                    (this.unload = e(this.unload, this)),
                    (this.load = e(this.load, this)),
                    (this.getActiveBlock = e(this.getActiveBlock, this)),
                    (this.getActiveSection = e(this.getActiveSection, this)),
                    (this.listeners = e(this.listeners, this));
                var t;
                (t = this), t.listeners();
            }
            return (
                (i.prototype.listeners = function () {
                    var t;
                    return (t = this), t.load(), t.unload(), t.selectSection(), t.deselectSection(), t.selectBlock(), t.deselectBlock();
                }),
                (i.prototype.getActiveSection = function (e) {
                    return this, t(e.target).find("[data-section-id]");
                }),
                (i.prototype.getActiveBlock = function (e) {
                    return this, t(e.target);
                }),
                (i.prototype.load = function () {
                    var e;
                    return (
                        (e = this),
                        document.addEventListener("shopify:section:load", function (i) {
                            var o;
                            return (
                                theme.utils.loadJsClasses(),
                                (o = e.getActiveSection(i)),
                                o.trigger("theme:section:load"),
                                o.find("[data-js-class]").each(function (e) {
                                    return t(e).trigger("theme:section:load");
                                })
                            );
                        })
                    );
                }),
                (i.prototype.unload = function () {
                    var e;
                    return (
                        (e = this),
                        document.addEventListener("shopify:section:unload", function (i) {
                            var o;
                            return (
                                (o = e.getActiveSection(i)),
                                o.trigger("theme:section:unload"),
                                o.find('[data-js-loaded="true"]').each(function (e) {
                                    return t(e).trigger("theme:section:unload");
                                })
                            );
                        })
                    );
                }),
                (i.prototype.selectSection = function () {
                    var t;
                    return (
                        (t = this),
                        document.addEventListener("shopify:section:select", function (e) {
                            var i;
                            return (i = t.getActiveSection(e)), i.trigger("theme:section:select");
                        })
                    );
                }),
                (i.prototype.deselectSection = function () {
                    var t;
                    return (
                        (t = this),
                        document.addEventListener("shopify:section:deselect", function (e) {
                            var i;
                            return (i = t.getActiveSection(e)), i.trigger("theme:section:deselect");
                        })
                    );
                }),
                (i.prototype.selectBlock = function () {
                    var t;
                    return (
                        (t = this),
                        document.addEventListener("shopify:block:select", function (e) {
                            var i;
                            return (i = t.getActiveBlock(e)), i.trigger("theme:block:select");
                        })
                    );
                }),
                (i.prototype.deselectBlock = function () {
                    var t;
                    return (
                        (t = this),
                        document.addEventListener("shopify:block:deselect", function (e) {
                            var i;
                            return (i = t.getActiveBlock(e)), i.trigger("theme:block:deselect");
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkServiceList = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.balanceColumns = e(this.balanceColumns, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.block_list = i.root.find(".service-list--blocks")),
                    (i.blocks = i.root.find("li")),
                    (i.blocks_container = i.root.find(".service-list--container")),
                    (i.headers = i.root.find(".service-list--block-header")),
                    (i.single_column = i.root.find(".service-list--single-column")),
                    (i.left_column = i.root.find(".service-list--left-column")),
                    (i.right_column = i.root.find(".service-list--right-column")),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (t = this), t.balanceColumns();
                }),
                (i.prototype.balanceColumns = function () {
                    var e, i, o, r, n, s, a;
                    return (
                        (e = this),
                        (n = !0 === e.root.data("service-list--show-descriptions") ? 75 : 0),
                        (a = e.block_list.length > 1),
                        (o = function (t) {
                            return t.hasClass("service-list--block-header");
                        }),
                        (s = function () {
                            var t, i, o;
                            return (o = e.single_column.outerHeight()), (t = e.left_column.outerHeight()), (i = e.right_column.outerHeight()), t >= parseFloat(i + o - n);
                        }),
                        (i = function () {
                            var t;
                            return a ? (e.root.attr("data-service-list--has-headers", !0), e.block_list) : ((t = theme.utils.parseHtml('<ul class="service-list--blocks"></ul>')), e.left_column.append(t), e.blocks);
                        }),
                        (r = i()),
                        r.each(function (i, n) {
                            return s()
                                ? void e.right_column.append(e.single_column.find(".service-list--blocks"))
                                : (a ? e.left_column.append(t(i)) : o(t(i)) ? (e.blocks_container.prepend(t(i).find(".service-list--block-header--text")), t(i).remove()) : e.left_column.find(".service-list--blocks").append(t(i)),
                                  n === r.length - 1 && e.right_column.isEmpty() && e.headers.length > 1 ? e.right_column.append(e.left_column.find(".service-list--blocks").last()) : void 0);
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkStickyColumn = (function () {
            function t(t, i, o) {
                if (
                    ((this.container = t),
                    (this.column_a = i),
                    (this.column_b = o),
                    (this.Listeners = e(this.Listeners, this)),
                    (this.setColumnPosition = e(this.setColumnPosition, this)),
                    (this.getAlignment = e(this.getAlignment, this)),
                    (this.getState = e(this.getState, this)),
                    (this.resetLargerColumn = e(this.resetLargerColumn, this)),
                    (this.getSmallerColumn = e(this.getSmallerColumn, this)),
                    (this.heightsHaveChanged = e(this.heightsHaveChanged, this)),
                    (this.setHeights = e(this.setHeights, this)),
                    (this.loadColumns = e(this.loadColumns, this)),
                    theme.utils.isTouchDevice())
                )
                    return !1;
                (_this.current_state = "auto"), (_this.column_a_height = 0), (_this.column_b_height = 0), _this.loadColumns();
            }
            return (
                (t.prototype.loadColumns = function () {
                    var t;
                    return (
                        (t = this),
                        theme.utils.imagesLoaded(t.container, function () {
                            return t.Listeners(), t.setColumnPosition();
                        })
                    );
                }),
                (t.prototype.setHeights = function () {
                    return (_this.column_a_height = _this.column_a.outerHeight()), (_this.column_b_height = _this.column_b.outerHeight());
                }),
                (t.prototype.heightsHaveChanged = function () {
                    return _this.column_a.outerHeight() !== _this.column_a_height ? (_this.setHeights(), !0) : _this.column_b.outerHeight() !== _this.column_b_height && (_this.setHeights(), !0);
                }),
                (t.prototype.getSmallerColumn = function () {
                    return _this.column_a_height < _this.column_b_height ? _this.column_a : _this.column_b;
                }),
                (t.prototype.resetLargerColumn = function () {
                    return _this.column_a_height > _this.column_b_height
                        ? (_this.column_a.css("position", "relative"), _this.column_a.css("top", "auto"), _this.column_a.css("bottom", "auto"))
                        : (_this.column_b.css("position", "relative"), _this.column_b.css("top", "auto"), _this.column_b.css("bottom", "auto"));
                }),
                (t.prototype.getState = function (t, e, i) {
                    var o, r, n, s, a;
                    return (
                        (a = "auto"),
                        "small" === theme.utils.mqs.current_window
                            ? "auto"
                            : ((o = i.outerHeight()),
                              (r = _this.container.offset().top),
                              e > o && (s = !0),
                              t < r && (a = "auto"),
                              (n = s ? o : e),
                              t + n > r + _this.container.outerHeight() ? (a = "absolute-bottom") : t > r && s ? (a = "fixed-top") : e < o && t + e > r + i.outerHeight() && (a = "fixed-bottom"),
                              a)
                    );
                }),
                (t.prototype.getAlignment = function (t) {
                    return t.hasClass("column-a") ? "left" : t.hasClass("column-b") ? "right" : void 0;
                }),
                (t.prototype.setColumnPosition = function () {
                    var t, e, i, o;
                    if (
                        ((t = this),
                        t.setHeights(),
                        (i = t.getSmallerColumn()),
                        (o = t.getState(window.pageYOffset, window.innerHeight, i)),
                        (e = t.getAlignment(i)),
                        "auto" === o && "auto" !== t.current_state
                            ? ((t.current_state = "auto"), i.css("position", "relative"), i.css("top", "auto"), i.css("bottom", "auto"))
                            : "fixed-bottom" === o && "fixed-bottom" !== t.current_state
                            ? ((t.current_state = "fixed-bottom"), i.css("position", "fixed"), i.css("top", "auto"), i.css("bottom", 0))
                            : "fixed-top" === o && "fixed-top" !== t.current_state
                            ? ((t.current_state = "fixed-top"), i.css("position", "fixed"), i.css("top", 0), i.css("bottom", "auto"))
                            : "absolute-bottom" === o && "absolute-bottom" !== t.current_state && ((t.current_state = "absolute-bottom"), i.css("position", "absolute"), i.css("top", "auto"), i.css("bottom", 0)),
                        "right" === e)
                    )
                        return i.css("right", 0);
                }),
                (t.prototype.Listeners = function () {
                    var t;
                    return (
                        (t = this),
                        window.addEventListener("scroll", function () {
                            return t.setColumnPosition();
                        }),
                        setInterval(function () {
                            if (t.heightsHaveChanged()) return t.resetLargerColumn(), t.setColumnPosition();
                        }, 250),
                        window.addEventListener("resize", function () {
                            return t.resetLargerColumn(), t.setColumnPosition();
                        })
                    );
                }),
                t
            );
        })()),
        (theme.classes.FrameworkTabOrder = (function () {
            function i(t, i) {
                var o;
                (this.mobile_order = t),
                    (this.desktop_order = i),
                    (this.resizeListener = e(this.resizeListener, this)),
                    (this.disableFocus = e(this.disableFocus, this)),
                    (this.enableCustomFocus = e(this.enableCustomFocus, this)),
                    (this.updateOrderList = e(this.updateOrderList, this)),
                    (this.getElementList = e(this.getElementList, this)),
                    (this.load = e(this.load, this)),
                    (o = this),
                    (o.mobile_order_elements = o.getElementList(o.mobile_order)),
                    (o.desktop_order_elements = o.getElementList(o.desktop_order)),
                    o.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (t = this), t.updateOrderList(), t.enableCustomFocus(), t.resizeListener();
                }),
                (i.prototype.getElementList = function (e) {
                    var i;
                    return (
                        this,
                        !!e &&
                            ((i = []),
                            e.forEach(function (e) {
                                if (t(e).length) return i.push(t(e).first());
                            }),
                            i)
                    );
                }),
                (i.prototype.updateOrderList = function () {
                    var t;
                    return (
                        (t = this),
                        "small" === theme.utils.mqs.current_window
                            ? ((t.current_order_elements = t.mobile_order_elements), (t.previous_order_elements = t.desktop_order_elements))
                            : ((t.current_order_elements = t.desktop_order_elements), (t.previous_order_elements = t.mobile_order_elements))
                    );
                }),
                (i.prototype.enableCustomFocus = function () {
                    var e;
                    if (((e = this), e.current_order_elements))
                        return e.current_order_elements.forEach(function (i, o) {
                            return i.on("focusout", function (i) {
                                var r, n, s;
                                if (theme.utils.tabbing)
                                    if ((n = !t(this).has(i.relatedTarget) && "closed" === theme.partials.OffCanvas.state) && theme.utils.tab_forwards) {
                                        if (o + 1 < e.current_order_elements.length && ((s = e.current_order_elements[o + 1]), (r = theme.utils.getFocusableEl(s)))) return r.focus(0);
                                    } else if (n && o - 1 >= 0 && ((s = e.current_order_elements[o - 1]), (r = theme.utils.getFocusableEl(s)))) return r.focus(r.length - 1);
                            });
                        });
                }),
                (i.prototype.disableFocus = function () {
                    var e;
                    if (((e = this), e.previous_order_elements))
                        return e.previous_order_elements.forEach(function (e) {
                            return t(e).off("focusout");
                        });
                }),
                (i.prototype.resizeListener = function () {
                    var t;
                    return (
                        (t = this),
                        window.addEventListener("theme:utils:mqs:updated", function () {
                            return t.updateOrderList(), t.enableCustomFocus(), t.disableFocus();
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.Transition = (function () {
            function t(t) {
                var i;
                (this.root = t),
                    (this.transitionListeners = e(this.transitionListeners, this)),
                    (this.updateState = e(this.updateState, this)),
                    (this.setState = e(this.setState, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.state = "at_start"),
                    i.load();
            }
            return (
                (t.prototype.load = function () {
                    var t;
                    return (t = this), t.setState(t.state), t.transitionListeners();
                }),
                (t.prototype.setState = function (t) {
                    var e;
                    return (e = this), e.root.setAttribute("data-transition", t), (e.state = t);
                }),
                (t.prototype.updateState = function () {
                    var t;
                    return (t = this), (t.state = t.root.getAttribute("data-transition"));
                }),
                (t.prototype.transitionListeners = function () {
                    var t;
                    return (
                        (t = this),
                        t.root.on("transitionend", function () {
                            return t.updateState(), "forwards" === t.state ? (t.setState("at_end"), t.root.trigger("transition:at_end")) : "backwards" === t.state ? (t.setState("at_start"), t.root.trigger("transition:at_start")) : void 0;
                        })
                    );
                }),
                t
            );
        })()),
        (theme.classes.FrameworkUtils = (function () {
            function i() {
                (this.isTouchDevice = e(this.isTouchDevice, this)),
                    (this.loadJsClasses = e(this.loadJsClasses, this)),
                    (this.getHiddenElHeight = e(this.getHiddenElHeight, this)),
                    (this.detectTabDirection = e(this.detectTabDirection, this)),
                    (this.detectTabbing = e(this.detectTabbing, this));
                var t;
                (t = this), (t.carousel_script_status = null), (t.google_maps_script_status = null), (t.mqs = new theme.classes.FrameworkMediaQueries()), t.detectTabbing(), t.detectTabDirection();
            }
            return (
                (i.prototype.swipe = function () {
                    return (
                        this,
                        SwipeListener(document, {
                            preventScroll: function (t) {
                                var e, i;
                                return (e = Math.abs(t.detail.x[0] - t.detail.x[1])), (i = 2 * Math.abs(t.detail.y[0] - t.detail.y[1])), e > i;
                            },
                        }),
                        document.addEventListener("swipe", function (e) {
                            var i;
                            if (((i = e.detail.directions), i.left && t(this).trigger("theme:swipe:left"), i.right && t(this).trigger("theme:swipe:right"), i.top && t(this).trigger("theme:swipe:up"), i.bottom))
                                return t(this).trigger("theme:swipe:down");
                        })
                    );
                }),
                (i.prototype.a11yClick = function (t) {
                    var e;
                    return "click" === t.type || ("keypress" === t.type && ((e = t.charCode || t.keyCode), 32 === e && t.preventDefault(), 32 === e || 13 === e));
                }),
                (i.prototype.detectTabbing = function () {
                    var e;
                    return (
                        (e = this),
                        theme.window.on("click load", function () {
                            return (e.tabbing = !1), t("body").attr("data-tabbing", e.tabbing);
                        }),
                        window.addEventListener("keydown", function (i) {
                            if (9 === i.which || 37 === i.which || 38 === i.which || 39 === i.which || 40 === i.which || 27 === i.which) return (e.tabbing = !0), t("body").attr("data-tabbing", e.tabbing);
                        })
                    );
                }),
                (i.prototype.detectTabDirection = function () {
                    var e;
                    return (
                        (e = this),
                        (e.tab_forwards = null),
                        t(document).on("keydown.detectTabbing", function (t) {
                            return (e.tab_forwards = !0), 9 === t.which && t.shiftKey && (e.tab_forwards = !1), !0;
                        })
                    );
                }),
                (i.prototype.getFocusableEl = function (t) {
                    if (t.length) return t.find('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])').filter(":not([disabled])");
                }),
                (i.prototype.stylesheetLoaded = function () {
                    return new Promise(function (t) {
                        var e;
                        return (
                            (e = document.querySelector("link[href='" + theme.assets.stylesheet + "']")),
                            e.loaded && t(),
                            e.addEventListener("load", function () {
                                return setTimeout(t, 0);
                            })
                        );
                    });
                }),
                (i.prototype.parseHtml = function (e, i) {
                    var o, r;
                    return (o = document.createElement("div")), (o.innerHTML = e), i || (i = ":scope > *"), (r = t(i, o)), !!r.length && r;
                }),
                (i.prototype.getHiddenElHeight = function (e, i) {
                    var o, r, n, s;
                    return (
                        null == i && (i = !0),
                        (n = e.css("padding")),
                        (o = e.clone()),
                        o.css("visibility", "hidden"),
                        o.css("display", "block"),
                        o.css("position", "absolute"),
                        o.css("padding", n),
                        i && ((s = e.width()), o.css("width", s + "px")),
                        t("body").append(o),
                        (r = o.height()),
                        o.remove(),
                        r
                    );
                }),
                (i.prototype.debounce = function (t, e) {
                    var i;
                    return (
                        (i = void 0),
                        function () {
                            i && clearTimeout(i), (i = setTimeout(e.bind(this), t, arguments));
                        }
                    );
                }),
                (i.prototype.imagesLoaded = function (e, i) {
                    var o, r;
                    return (
                        (o = 0),
                        (r = e.find('img[data-sizes="auto"]').length),
                        r < 1
                            ? void i()
                            : e.on("lazybeforeunveil", function (e) {
                                  return t(e.target).on("load", function () {
                                      if (++o === r) return i();
                                  });
                              })
                    );
                }),
                (i.prototype.loadJsClasses = function (e) {
                    return (
                        null == e && (e = t("body")),
                        this,
                        e.find("[data-js-class]").each(function (e) {
                            var i, o;
                            if (((i = t(e).attr("data-js-class")), !t(e).data("js-loaded") && void 0 !== (o = theme.classes[i]))) return (theme.partials[i] = new o(t(e))), t(e).attr("data-js-loaded", "true");
                        })
                    );
                }),
                (i.prototype.matchImageHeights = function (e, i, o, r) {
                    var n, s, a, l, u, c, d, h;
                    if ((null == r && (r = !1), this, i.length && (i.find(o + ", .placeholder--root").css("height", "auto"), (c = i.find(o + " .image--root, .placeholder--root")), (d = Math.floor(e.width() / c.width())), !isNaN(d))))
                        return (
                            r &&
                                ((l = []),
                                (u = []),
                                (s = 0),
                                r.each(function (e) {
                                    var i, o;
                                    return (i = Math.floor((s + t(e).index()) / d) + 1), (o = Math.floor(t(e).width() / c.width())), (s += o - 1), l.includes(i) ? (u[l.indexOf(i)] += o) : (l.push(i), u.push(o));
                                })),
                            (h = t()),
                            (n = 1),
                            (a = 0),
                            i.each(function (e, s) {
                                var c, p, f;
                                if (
                                    ((f =
                                        t(e).find(".image--root").length > 0
                                            ? t(e)
                                                  .find(o + " .image--root")
                                                  .outerHeight()
                                            : t(e).find(".placeholder--root").outerHeight()),
                                    f > a && (a = f),
                                    (c = !1),
                                    (h = h.add(t(e))),
                                    s + 1 === i.length ? (c = !0) : r && l.includes(n) ? ((p = u[l.indexOf(n)]), p === d ? n++ : (c = h.length + p === d), 1 === p && 1 === d && (c = !0)) : h.length === d && (c = !0),
                                    c)
                                )
                                    return h.find(o + ", .placeholder--root").height(a), (h = t()), n++, (a = 0);
                            })
                        );
                }),
                (i.prototype.insertStylesheet = function (t) {
                    var e;
                    return this, (e = document.createElement("link")), (e.rel = "stylesheet"), (e.href = t), document.head.appendChild(e);
                }),
                (i.prototype.insertScript = function (t, e) {
                    var i;
                    return this, (i = document.createElement("script")), (i.src = t), e && (i.onload = e), document.body.appendChild(i);
                }),
                (i.prototype.formatMoney = function (t) {
                    var e, i, o, r;
                    switch (
                        (this,
                        (r = /\{\{\s*(\w+)\s*\}\}/),
                        (o = theme.shop.money_format.match(r)[1]),
                        (e = function (t, e, i) {
                            var o, r, n, s;
                            return (s = i ? "." : ","), (n = i ? "," : "."), (o = (t / 100).toFixed(e).split(".")), (r = o[1] ? n + o[1] : ""), o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) + r;
                        }),
                        o)
                    ) {
                        case "amount":
                            i = e(t, 2, !1);
                            break;
                        case "amount_no_decimals":
                            i = e(t, 0, !1);
                            break;
                        case "amount_with_comma_separator":
                            i = e(t, 2, !0);
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            i = e(t, 0, !0);
                    }
                    return theme.shop.money_format.replace(r, i);
                }),
                (i.prototype.isTouchDevice = function () {
                    return this, !!window.matchMedia("(pointer: coarse)").matches;
                }),
                i
            );
        })()),
        (theme.classes.FrameworkXMenu = (function () {
            function i(i) {
                var o;
                (this.root = i),
                    (this.transitionListeners = e(this.transitionListeners, this)),
                    (this.slideUp = e(this.slideUp, this)),
                    (this.slideDown = e(this.slideDown, this)),
                    (this.arrangeMegaNav = e(this.arrangeMegaNav, this)),
                    (this.resizeListeners = e(this.resizeListeners, this)),
                    (this.checkOverlap = e(this.checkOverlap, this)),
                    (this.listeners = e(this.listeners, this)),
                    (this.load = e(this.load, this)),
                    (o = this),
                    (o.debugging = !1),
                    (o.state = "closed"),
                    (o.parent_links = o.root.find(".x-menu--level-1--link > a")),
                    (o.sub_menu_links = o.root.find('.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a')),
                    (o.sub_menu_items = o.sub_menu_links.parent().find("ul a")),
                    (o.parents_with_sub_menu = o.sub_menu_links.parent()),
                    (o.overlap_parent = o.root.data("x-menu--overlap-parent")),
                    (o.header_root = t(".header--root")),
                    o.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (t = this), t.arrangeMegaNav(), t.listeners(), t.checkOverlap(), t.resizeListeners(), t.transitionListeners();
                }),
                (i.prototype.listeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.parents_with_sub_menu.on("mouseenter.XMenu", function () {
                            return e.slideDown(t(this).find("> a"));
                        }),
                        e.parents_with_sub_menu.on("mouseleave.XMenu", function () {
                            return e.slideUp();
                        }),
                        e.parent_links.on("focus", function () {
                            return e.slideUp();
                        }),
                        e.sub_menu_links.on("focus", function () {
                            return e.slideDown(t(this));
                        }),
                        e.sub_menu_links.on("touchstart.XMenu", function (i) {
                            return i.preventDefault(), t(this).parent().data("x-menu--open") ? e.slideUp() : e.slideDown(t(this));
                        }),
                        t(".x-menu--level-2--container")
                    );
                }),
                (i.prototype.checkOverlap = function () {
                    var t, e, i, o, r, n, s, a, l, u, c, d, h;
                    return (
                        (t = this),
                        theme.utils.isTouchDevice() && "large" !== theme.utils.mqs.current_window
                            ? (t.root.attr("data-x-menu--overlap", "true"), t.header_root.attr("data-x-menu--overlap", "true"), !1)
                            : (t.root.attr("data-x-menu--overlap", "false"),
                              t.header_root.attr("data-x-menu--overlap", "false"),
                              (i = t.root),
                              1 === t.overlap_parent ? (i = i.parent()) : 2 === t.overlap_parent && (i = i.parent().parent()),
                              (s = i.parent()),
                              (e = i.index()),
                              (c = !1),
                              e > 1 && (c = s.children().eq(e - 1)),
                              (d = !1),
                              e + 1 < s.children().length && (d = s.children().eq(e + 1)),
                              (a = s.width()),
                              (n = t.root.outerWidth()),
                              c && ((l = i.find("> :first-child")), (o = l.offset().left - 1), (a - n) / 2, left_edge >= o && (t.root.attr("data-x-menu--overlap", "true"), t.header_root.attr("data-x-menu--overlap", "true"))),
                              d && ((u = i.find("> :last-child")), (r = u.outerWidth() + u.offset().left + 1), (h = d.offset().left), r >= h)
                                  ? (t.root.attr("data-x-menu--overlap", "true"), t.header_root.attr("data-x-menu--overlap", "true"))
                                  : void 0)
                    );
                }),
                (i.prototype.resizeListeners = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "resize.XMenu",
                            theme.utils.debounce(100, function () {
                                return t.checkOverlap();
                            })
                        )
                    );
                }),
                (i.prototype.arrangeMegaNav = function () {
                    var e, i;
                    return (
                        (e = this),
                        0 !== e.parents_with_sub_menu.length &&
                            ((i = e.root.find('[data-x-menu--depth="3"] .x-menu--level-2--container')),
                            i.each(function (e) {
                                var i, o, r, n;
                                if (((i = t(e)), (r = i.find('[data-x-menu--single-parent="true"]')), r.length > 0))
                                    return (n = theme.utils.parseHtml('<div class="x-menu--single-parents"></div>')), i.prepend(n), (o = theme.utils.parseHtml("<ul>")), n.append(o).find("ul").append(r);
                            }))
                    );
                }),
                (i.prototype.slideDown = function (t, e) {
                    var i, o, r;
                    if ((null == e && (e = !1), (i = this), clearTimeout(i.timer), (o = t.parent()), o.data("x-menu--open") || "closing" === i.state)) return !1;
                    i.slideUp(!1),
                        e && "complete" !== e
                            ? (i.timer = setTimeout(function () {
                                  return i.slideDown(t, "complete");
                              }, e))
                            : (t.closest(".x-menu--level-1--link").find(".icon--chevron-up").css("display", "inline"),
                              t.closest(".x-menu--level-1--link").find(".icon--chevron-down").hide(),
                              t.closest(".x-menu--level-1--link").find(".icon--minus").show(),
                              t.closest(".x-menu--level-1--link").find(".icon--plus").hide(),
                              o.attr("data-x-menu--open", "true"),
                              t.attr("aria-expanded", "true"),
                              (r = t.closest(".x-menu--level-1--link").find(".x-menu--level-2--container")),
                              r.attr("data-transition", "forwards"),
                              r.css("height", "auto"),
                              (i.state = "open"));
                }),
                (i.prototype.slideUp = function (t) {
                    var e, i, o, r;
                    return (
                        null == t && (t = 300),
                        (e = this),
                        !e.debugging &&
                            ((o = e.parents_with_sub_menu.filter('[data-x-menu--open="true"]')),
                            (i = o.find("> a")),
                            !!o.data("x-menu--open") &&
                                (t
                                    ? (e.timer = setTimeout(function () {
                                          return e.slideUp(!1);
                                      }, t))
                                    : (i.closest(".x-menu--level-1--link").find(".icon--chevron-up").hide(),
                                      i.closest(".x-menu--level-1--link").find(".icon--chevron-down").css("display", "inline"),
                                      i.closest(".x-menu--level-1--link").find(".icon--minus").hide(),
                                      i.closest(".x-menu--level-1--link").find(".icon--plus").show(),
                                      (r = i.closest(".x-menu--level-1--link").find(".x-menu--level-2--container")),
                                      o.attr("data-x-menu--open", "false"),
                                      i.attr("aria-expanded", "false"),
                                      r.attr("data-transition", "backwards"))))
                    );
                }),
                (i.prototype.transitionListeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.sub_menu_links.each(function (e) {
                            var i;
                            if (void 0 !== t(e).parent())
                                return (
                                    (i = t(e).parent().find(".x-menu--level-2--container")),
                                    i.on("transition:at_start", function () {
                                        return t(this).css("height", 0);
                                    })
                                );
                        })
                    );
                }),
                i
            );
        })()),
        (theme.classes.FrameworkYMenu = (function () {
            function i(t) {
                var i;
                (this.root = t),
                    (this.slideRight = e(this.slideRight, this)),
                    (this.slideLeft = e(this.slideLeft, this)),
                    (this.adjustHeight = e(this.adjustHeight, this)),
                    (this.listeners = e(this.listeners, this)),
                    (this.load = e(this.load, this)),
                    (i = this),
                    (i.state = "closed"),
                    (i.sub_menu_links = i.root.find(".icon--plus").parent()),
                    (i.back_links = i.root.find(".y-menu--back-link a")),
                    (i.regular_links = i.root.find('.y-menu--level-1--link > a:not([data-submenu="true"]), .y-menu--level-2--link > a:not([data-submenu="true"]), .y-menu--level-3--link > a:not([data-submenu="true"])')),
                    (i.timer = null),
                    i.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    return (t = this), t.listeners();
                }),
                (i.prototype.listeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.regular_links.on("click", function () {
                            var e;
                            (e = t(this).attr("href")),
                                -1 !== e.indexOf("#") &&
                                    ("left--opened" === theme.partials.OffCanvas.state ? theme.partials.OffCanvas.closeLeft() : "right--opened" === theme.partials.OffCanvas.state && theme.partials.OffCanvas.closeRight(),
                                    setTimeout(function () {
                                        return (window.location.href = e);
                                    }, 450));
                        }),
                        e.sub_menu_links.on("click", function (i) {
                            return e.slideLeft(t(this)), i.preventDefault(), i.stopPropagation();
                        }),
                        e.back_links.on("click", function (i) {
                            return e.slideRight(t(this)), i.preventDefault(), i.stopPropagation();
                        })
                    );
                }),
                (i.prototype.adjustHeight = function (t) {
                    var e, i, o;
                    return (
                        (e = this),
                        (o = t.outerHeight()),
                        (i = e.root.outerHeight()),
                        e.root.height(i),
                        "absolute" === t.css("position") && (t.css("position", "relative"), (o = t.outerHeight()), t.css("position", "absolute")),
                        e.root.height(o)
                    );
                }),
                (i.prototype.slideLeft = function (t) {
                    var e, i;
                    return (e = this), (i = t.closest("li").find("ul").first()), i.css("display", "block"), e.adjustHeight(i), i.css("transform", "translateX(-100%)");
                }),
                (i.prototype.slideRight = function (t, e) {
                    var i, o, r;
                    return (i = this), (o = t.closest("ul")), (r = o.parent().closest("ul")), i.adjustHeight(r), o.css("transform", "translateX(0)");
                }),
                i
            );
        })()),
        (theme.classes.Article = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkArticle)),
        (theme.classes.Blog = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkBlog)),
        (theme.classes.Cart = (function (o) {
            function r() {
                return (this.updateTotalsComplete = e(this.updateTotalsComplete, this)), r.__super__.constructor.apply(this, arguments);
            }
            return (
                i(r, o),
                (r.prototype.updateTotalsComplete = function (e) {
                    return this, e > 0 ? t(".header--cart-link").attr("data-has-items", "true") : t(".header--cart-link").attr("data-has-items", "false");
                }),
                r
            );
        })(theme.classes.FrameworkCart)),
        (theme.classes.Collection = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkCollection)),
        (theme.classes.Disclosure = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkDisclosure)),
        (theme.classes.FeaturedCollection = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkFeaturedCollection)),
        (theme.classes.FeaturedVideo = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkFeaturedVideo)),
        (theme.classes.Footer = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkFooter)),
        (theme.classes.Header = (function () {
            function i(i) {
                var o;
                (this.root = i),
                    (this.detectAndLockHeader = e(this.detectAndLockHeader, this)),
                    (this.scrollListener = e(this.scrollListener, this)),
                    (this.sectionListeners = e(this.sectionListeners, this)),
                    (this.moveLocalizationForm = e(this.moveLocalizationForm, this)),
                    (this.moveSearchIcon = e(this.moveSearchIcon, this)),
                    (this.moveAccountIcon = e(this.moveAccountIcon, this)),
                    (this.moveYMenu = e(this.moveYMenu, this)),
                    (this.load = e(this.load, this)),
                    (o = this),
                    (o.container = o.root.find(".header--container")),
                    (o.fixed_enabled = o.root.data("fixed-enabled")),
                    (o.fixed_state = !1),
                    (o.header_offset = o.root.offset().top),
                    (o.logo_position = o.root.attr("data-logo-position")),
                    (o.off_canvas_main_content = t(".off-canvas--main-content")),
                    (o.localization_form = o.root.find(".header--localization-for-off-canvas > *")),
                    (o.mobile_nav_menu = t(".mobile-nav--menu")),
                    (o.mobile_nav_localization = t(".mobile-nav--localization")),
                    (o.mobile_nav_login = t(".mobile-nav--login")),
                    (o.mobile_nav_login_icon = o.root.find(".mobile-nav--login--for-off-canvas > *")),
                    (o.mobile_nav_search = t(".mobile-nav--search")),
                    (o.mobile_nav_search_icon = o.root.find(".mobile-nav--search--for-off-canvas > *")),
                    (o.y_menu = o.root.find(".y-menu")),
                    o.load();
            }
            return (
                (i.prototype.load = function () {
                    var t;
                    if (((t = this), t.moveYMenu(), t.moveAccountIcon(), t.moveSearchIcon(), t.moveLocalizationForm(), t.sectionListeners(), t.fixed_enabled)) return t.scrollListener();
                }),
                (i.prototype.moveYMenu = function () {
                    var t;
                    if (((t = this), t.mobile_nav_menu.empty(), t.mobile_nav_menu.length && t.y_menu.length)) return t.mobile_nav_menu.append(t.y_menu);
                }),
                (i.prototype.moveAccountIcon = function () {
                    var t;
                    if (((t = this), t.mobile_nav_login.empty(), t.mobile_nav_login.length && t.mobile_nav_login_icon.length)) return t.mobile_nav_login.append(t.mobile_nav_login_icon);
                }),
                (i.prototype.moveSearchIcon = function () {
                    var t;
                    if (((t = this), t.mobile_nav_search.empty(), t.mobile_nav_search.length && t.mobile_nav_search_icon.length)) return t.mobile_nav_search.append(t.mobile_nav_search_icon);
                }),
                (i.prototype.moveLocalizationForm = function () {
                    var t;
                    if (((t = this), t.mobile_nav_localization.empty(), t.localization_form.length)) return t.mobile_nav_localization.append(t.localization_form);
                }),
                (i.prototype.sectionListeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.root.on("theme:section:load", function () {
                            if (("block" === t(".modal--window").css("display") && t(".modal--close").trigger("click"), theme.partials.OffCanvas.unload(), theme.partials.OffCanvas.load(), e.mobile_nav_search_icon.length))
                                return theme.partials.FrameworkSearch.searchLinks();
                        })
                    );
                }),
                (i.prototype.scrollListener = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "DOMMouseScroll mousewheel touchmove",
                            function (e) {
                                return t.detectAndLockHeader();
                            },
                            !0
                        ),
                        window.addEventListener("scroll", function () {
                            return t.detectAndLockHeader();
                        })
                    );
                }),
                (i.prototype.detectAndLockHeader = function () {
                    var e, i, o, r;
                    if (((e = this), (o = t("body").data("modal-open")), !("closed" !== theme.partials.OffCanvas.state) && !o)) {
                        if ((r = window.pageYOffset) > e.header_offset && !e.fixed_state) (e.fixed_state = !0), e.root.attr("data-fixed", "" + e.fixed_state), (i = e.root.outerHeight() + "px");
                        else {
                            if (!(r <= e.header_offset && e.fixed_state)) return;
                            (e.fixed_state = !1), e.root.attr("data-fixed", "" + e.fixed_state), (i = 0);
                        }
                        return e.off_canvas_main_content.css("padding-top", i), e.root.trigger("state_updated");
                    }
                }),
                i
            );
        })()),
        (theme.classes.Map = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkMap)),
        (theme.classes.OffCanvas = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkOffCanvas)),
        (theme.classes.PasswordPage = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkPasswordPage)),
        (theme.classes.Popup = (function () {
            function e(e) {
                var i;
                (this.root = e),
                    (i = this),
                    (i.container = i.root.find(".popup--container")),
                    (i.close_link = i.root.find(".popup--close")),
                    (i.show_again_after = i.root.data("show-again-after")),
                    (i.mode = i.root.data("mode")),
                    (i.newsletter_form = i.root.find("#contact_form")),
                    (i.body = t("body")),
                    i.eventListeners(),
                    i.autoPopup();
            }
            return (
                (e.prototype.eventListeners = function () {
                    var e;
                    return (
                        (e = this),
                        e.close_link.on("keypress.Popup, click.Popup", function () {
                            return e.close(), !1;
                        }),
                        e.newsletter_form.on("submit", function (e) {
                            var i, o;
                            return (
                                e.preventDefault(),
                                (i = t(this)),
                                i.find(".error, .success").remove(),
                                i.find('input[type="email"], [type="submit"]').hide(),
                                (o = theme.utils.parseHtml("<p class='success'>" + theme.translations.mailing_list_success_message + "</p>")),
                                i.prepend(o).show(),
                                setTimeout(function () {
                                    return i.submit();
                                }, 500),
                                !1
                            );
                        })
                    );
                }),
                (e.prototype.open = function (e) {
                    var i, o;
                    return (
                        (i = this),
                        t(".template--index .banner").length && "auto" === e
                            ? (i.delayUntilValidScrollPosition(), !1)
                            : (i.container.attr("aria-hidden", !1), i.container.attr("data-transition", "forwards"), (o = i.container.outerHeight()), i.body.css("padding-bottom", o + "px"), i.body.attr("data-popup-open", !0))
                    );
                }),
                (e.prototype.delayUntilValidScrollPosition = function () {
                    var e;
                    return (
                        (e = this),
                        theme.window.on(
                            "DOMMouseScroll.Popup mousewheel.Popup touchmove.Popup scroll.Popup touchmove.Popup",
                            function () {
                                var i;
                                if (((i = t(".header--root").offset().top), window.pageYOffset > i)) return e.open(), theme.window.off("DOMMouseScroll.Popup mousewheel.Popup touchmove.Popup scroll.Popup touchmove.Popup");
                            },
                            !0
                        )
                    );
                }),
                (e.prototype.close = function () {
                    var t;
                    return (t = this), t.body.css("padding-bottom", 0), t.body.attr("data-popup-open", !1), t.container.attr("data-transition", "backwards"), t.container.attr("aria-hidden", !0);
                }),
                (e.prototype.autoPopup = function () {
                    var t;
                    if (((t = this), "manual" !== t.mode))
                        return window.localStorage && "test" !== t.mode
                            ? void 0 === localStorage[theme.local_storage.popup]
                                ? (t.setResetTime(),
                                  setTimeout(function () {
                                      return t.open("auto");
                                  }, 1e3))
                                : t.readyToReset()
                                ? (t.setResetTime(),
                                  setTimeout(function () {
                                      return t.open("auto");
                                  }, 1e3))
                                : void 0
                            : setTimeout(function () {
                                  return t.open("auto");
                              }, 1e3);
                }),
                (e.prototype.readyToReset = function () {
                    var t, e, i;
                    return (t = this), (e = JSON.parse(localStorage[theme.local_storage.popup]).popup_expires), (i = new Date().getTime()), parseFloat(e - i) <= 0 && (t.setResetTime(), !0);
                }),
                (e.prototype.setResetTime = function () {
                    var t, e, i, o, r;
                    return (t = this), (e = new Date()), (r = 864e5 * t.show_again_after), (i = e.setTime(e.getTime() + r)), (o = { popup_expires: i }), (localStorage[theme.local_storage.popup] = JSON.stringify(o)), t;
                }),
                e
            );
        })()),
        (theme.classes.ProductModel = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkProductModel)),
        (theme.classes.ProductRecommendations = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkProductRecommendations)),
        (theme.classes.ProductVideo = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkProductVideo)),
        (theme.classes.Product = (function (o) {
            function r(i) {
                var o;
                (this.root = i),
                    (this.gridImageZoom = e(this.gridImageZoom, this)),
                    (this.imageZoom = e(this.imageZoom, this)),
                    (this.onLoadZoomListener = e(this.onLoadZoomListener, this)),
                    (this.resizeListener = e(this.resizeListener, this)),
                    (this.layoutListener = e(this.layoutListener, this)),
                    (this.initMasonry = e(this.initMasonry, this)),
                    (this.loadMasonryScript = e(this.loadMasonryScript, this)),
                    (this.modalListeners = e(this.modalListeners, this)),
                    (this.goToSlide = e(this.goToSlide, this)),
                    (this.updateVariantMedia = e(this.updateVariantMedia, this)),
                    (this.goToSlideOnCarouselLoad = e(this.goToSlideOnCarouselLoad, this)),
                    (this.updateModelButton = e(this.updateModelButton, this)),
                    (this.onSlideListener = e(this.onSlideListener, this)),
                    (this.pauseOtherMedia = e(this.pauseOtherMedia, this)),
                    (this.updateTopPositions = e(this.updateTopPositions, this)),
                    (this.setRelativeSidebarPosition = e(this.setRelativeSidebarPosition, this)),
                    (this.setFixedSidebarPosition = e(this.setFixedSidebarPosition, this)),
                    (this.headerStateListener = e(this.headerStateListener, this)),
                    (this.load = e(this.load, this)),
                    (o = this),
                    (o.carousel = o.root.find(".carousel--root")),
                    (o.carousel_container = o.carousel.find(".carousel--x-container")),
                    (o.enable_masonry = "close-together" === o.root.attr("data-media-spacing")),
                    (o.first_media_id = o.root.find('.product-media--featured[data-active="true"]').data("id")),
                    (o.grid = o.root.find(".product-page--grid")),
                    (o.header = t(".header--root")),
                    (o.image_containers = o.root.find('.product-media--wrapper[data-media-type="image"]')),
                    (o.is_product_page = o.root.hasClass("product-page--root")),
                    (o.right_column = o.root.find(".product-page--right-column")),
                    (o.section_id = o.root.data("section-id")),
                    r.__super__.constructor.apply(this, arguments);
            }
            return (
                i(r, o),
                (r.prototype.load = function () {
                    var t;
                    if (
                        ((t = this),
                        r.__super__.load.apply(this, arguments),
                        t.enable_masonry && t.main_media.length > 1 && (t.loadMasonryScript(), t.resizeListener()),
                        t.is_product_page && (t.headerStateListener(), t.setFixedSidebarPosition(), t.pauseOtherMedia(), t.onSlideListener(), t.goToSlideOnCarouselLoad(), t.modalListeners()),
                        t.zoom_enabled)
                    )
                        return t.onLoadZoomListener();
                }),
                (r.prototype.headerStateListener = function () {
                    var t;
                    return (
                        (t = this),
                        t.header.on("state_updated", function () {
                            if ((t.setFixedSidebarPosition(), t.zoom_enabled)) return t.updateTopPositions();
                        })
                    );
                }),
                (r.prototype.setFixedSidebarPosition = function () {
                    var t;
                    if (((t = this), "closed" === theme.partials.OffCanvas.state)) return t.right_column.css("top", t.header.height() + "px");
                }),
                (r.prototype.setRelativeSidebarPosition = function () {
                    var t;
                    if (((t = this), "small" !== theme.utils.mqs.current_window)) return t.right_column.css("top", window.pageYOffset + "px");
                }),
                (r.prototype.updateTopPositions = function () {
                    var e;
                    return (
                        (e = this),
                        (e.top_positions = []),
                        e.image_containers.each(function (i) {
                            var o;
                            return (o = t(i).offset().top), e.top_positions.push(o);
                        })
                    );
                }),
                (r.prototype.pauseOtherMedia = function () {
                    var e;
                    return (
                        (e = this),
                        e.root.find(".product-media--featured > *").on("click", function () {
                            return e.root.find(".product-media--featured > *").not(t(this)).trigger("pause-media");
                        })
                    );
                }),
                (r.prototype.onSlideListener = function () {
                    var e;
                    return (
                        (e = this),
                        e.carousel_container.on("transition:at_end", function () {
                            var i, o, r;
                            return (r = t(this).find(".product-media--featured > *")), (i = theme.carousels[e.section_id].active_slide - 1), (o = r.eq(i)), r.not(o).trigger("pause-media"), e.updateModelButton(o.parent());
                        })
                    );
                }),
                (r.prototype.updateModelButton = function (t) {
                    var e, i, o;
                    return (e = this), (i = t.data("id")), e.model_buttons.attr("data-active", "false"), (o = e.model_buttons.filter("[data-shopify-model3d-id='" + i + "']")), o.attr("data-active", "true");
                }),
                (r.prototype.goToSlideOnCarouselLoad = function () {
                    var t;
                    return (
                        (t = this),
                        t.carousel.on("loaded", function () {
                            return t.goToSlide(t.first_media_id);
                        })
                    );
                }),
                (r.prototype.updateVariantMedia = function (t) {
                    var e;
                    return (e = this), e.is_product_page ? e.goToSlide(t) : r.__super__.updateVariantMedia.apply(this, arguments);
                }),
                (r.prototype.goToSlide = function (t) {
                    var e, i, o;
                    if (((e = this), (i = e.carousel.find(".product-media--featured[data-id='" + t + "']")), i.length))
                        return (o = i.closest(".carousel--block").index() + 1), theme.carousels[e.section_id].updateThenGoToActiveSlide(o), e.updateModelButton(i);
                }),
                (r.prototype.modalListeners = function () {
                    var t;
                    return (
                        (t = this),
                        window.addEventListener("theme:modal:closed", function () {
                            return t.setFixedSidebarPosition();
                        }),
                        window.addEventListener("theme:modal:opened", function () {
                            return t.setRelativeSidebarPosition();
                        })
                    );
                }),
                (r.prototype.loadMasonryScript = function () {
                    var t;
                    return (
                        (t = this),
                        theme.utils.insertScript(theme.assets.masonry, function () {
                            return "small" !== theme.utils.mqs.current_window && t.initMasonry(), t.layoutListener();
                        })
                    );
                }),
                (r.prototype.initMasonry = function () {
                    var t;
                    return (
                        (t = this),
                        t.grid.attr("data-masonry-loaded", !0),
                        (t.masonry = new Masonry(t.grid.el[0], { itemSelector: ".product-media--wrapper", percentPosition: !0, horizontalOrder: !0, columnWidth: ".product-media--wrapper" }))
                    );
                }),
                (r.prototype.layoutListener = function () {
                    var t;
                    return (
                        (t = this),
                        window.addEventListener("theme:utils:mqs:updated", function () {
                            var e;
                            return (
                                (e = t.grid.data("masonry-loaded")),
                                "small" === theme.utils.mqs.current_window || e ? ("small" === theme.utils.mqs.current_window && e ? (t.grid.attr("data-masonry-loaded", !1), t.masonry.destroy()) : void 0) : t.initMasonry()
                            );
                        })
                    );
                }),
                (r.prototype.resizeListener = function () {
                    var t;
                    return (
                        (t = this),
                        theme.window.on(
                            "resize.Product",
                            theme.utils.debounce(100, function () {
                                if (t.zoom_enabled && "small" !== theme.utils.mqs.current_window) return t.updateTopPositions();
                            })
                        )
                    );
                }),
                (r.prototype.onLoadZoomListener = function () {
                    var t;
                    return (
                        (t = this),
                        window.addEventListener("load", function () {
                            if ("small" !== theme.utils.mqs.current_window) return t.updateTopPositions(), t.imageZoom();
                        })
                    );
                }),
                (r.prototype.imageZoom = function () {
                    var t;
                    if (((t = this), t.image_containers.length && "small" !== theme.utils.mqs.current_window)) return t.gridImageZoom();
                }),
                (r.prototype.gridImageZoom = function () {
                    var e;
                    return (
                        (e = this),
                        e.image_containers.each(function (i, o) {
                            var r, n, s, a, l, u, c, d, h;
                            if (((n = t(i)), (r = e.zoom_images.eq(o)), r.css("display", "none"), n.off("mouseenter.Product.ImageZoom." + o + " mouseleave.Product.ImageZoom." + o + " .Product.ImageZoom." + o), r.length > 0))
                                return (
                                    (c = n.width()),
                                    (u = n.height()),
                                    (l = c * e.magnify),
                                    (a = u * e.magnify),
                                    (d = (l - c) / c),
                                    (h = (a - u) / u),
                                    (s = n.offset().left),
                                    r.css("width", l + "px"),
                                    r.find(".image--root").css("width", l + "px"),
                                    r.find("img").addClass("lazypreload"),
                                    n.on("mouseenter.Product.ImageZoom." + o, function () {
                                        return r.css("display", "block");
                                    }),
                                    n.on("mouseleave.Product.ImageZoom." + o, function () {
                                        return r.css("display", "none");
                                    }),
                                    n.on("mousemove.Product.ImageZoom." + o, function (t) {
                                        var i, n;
                                        return (i = t.pageX - s), (n = t.pageY - e.top_positions[o]), r.css("left", i * -d + "px"), r.css("top", n * -h + "px");
                                    })
                                );
                        })
                    );
                }),
                r
            );
        })(theme.classes.FrameworkProduct)),
        (theme.classes.Radios = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkRadios)),
        (theme.classes.RecentProducts = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkRecentProducts)),
        (theme.classes.Sections = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkSections)),
        (theme.classes.ServiceList = (function (t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return i(e, t), e;
        })(theme.classes.FrameworkServiceList)),
        (theme.classes.XMenu = (function (o) {
            function r(i) {
                var o;
                (this.root = i),
                    (this.getLongestDropDrown = e(this.getLongestDropDrown, this)),
                    (this.orientateDropDown = e(this.orientateDropDown, this)),
                    (this.load = e(this.load, this)),
                    (o = this),
                    (o.longest_drop_down = o.getLongestDropDrown()),
                    (o.bottom_position_for_sub_above = window.innerHeight - o.root.offset().top),
                    (o.banner_exists = t(".banner--container").length > 0),
                    r.__super__.constructor.apply(this, arguments);
            }
            return (
                i(r, o),
                (r.prototype.load = function () {
                    var t;
                    return (
                        (t = this),
                        r.__super__.load.apply(this, arguments),
                        theme.window.on("resize scroll", function () {
                            return t.orientateDropDown();
                        }),
                        t.orientateDropDown()
                    );
                }),
                (r.prototype.orientateDropDown = function () {
                    var e, i;
                    return (
                        (e = this),
                        (i = t(".banner--container").length > 0),
                        i && window.pageYOffset < 50 && e.longest_drop_down + 150 < window.innerHeight ? e.root.attr("data-x-menu--sub-above", "true") : e.root.attr("data-x-menu--sub-above", "false")
                    );
                }),
                (r.prototype.getLongestDropDrown = function () {
                    var e, i, o;
                    return (
                        (e = this),
                        (i = 0),
                        (o = e.root.find(".x-menu--level-2--container")),
                        o.each(function (e) {
                            if (t(e).outerHeight() > i) return (i = t(e).outerHeight());
                        }),
                        i
                    );
                }),
                r
            );
        })(theme.classes.FrameworkXMenu)),
        (t = function (t, e) {
            return null == e && (e = document), new theme.classes.FrameworkDomElement(t, e);
        }),
        new ((function () {
            function i() {
                (this.loadSwipeLibrary = e(this.loadSwipeLibrary, this)), (this.configureLinks = e(this.configureLinks, this)), (this.load = e(this.load, this));
                var t;
                (t = this), t.load();
            }
            return (
                (i.prototype.load = function () {
                    var e;
                    return (
                        (e = this),
                        (theme.window = t(window)),
                        (theme.sections = new theme.classes.Sections()),
                        (theme.utils = new theme.classes.FrameworkUtils()),
                        theme.utils.stylesheetLoaded().then(function () {
                            return theme.utils.loadJsClasses(), t("body").attr("data-assets-loaded", "true");
                        }),
                        e.configureLinks(),
                        e.loadSwipeLibrary()
                    );
                }),
                (i.prototype.configureLinks = function () {
                    return t('[data-item="hidden-text"] a').attr("tabindex", "-1");
                }),
                (i.prototype.loadSwipeLibrary = function () {
                    return theme.utils.insertScript(theme.assets.swipe, function () {
                        return theme.utils.swipe();
                    });
                }),
                i
            );
        })())();
}.call(this));




$(document).ready(function() {
    // Function to show the correct span based on the selected value
    function showSelectedVariant() {
        var selectedValue = $('#variantSelect').val();

        // Hide all sibling span elements inside .variant-suitability
        $('.variant-suitability span').hide();

        // Show the span with the matching data-id
        $('.variant-suitability span[data-id="' + selectedValue + '"]').show();
    }

    // Call the function on page load to display the correct span
    showSelectedVariant();

    // Add change event listener to radio buttons
    $('.radios--main input[type="radio"]').on('change', function() {
        setTimeout(function() {
            // Call the function to update the displayed span
            showSelectedVariant();
        }, 1000); // 1000 ms (1 second) delay
    });
  


    $('.product-shop-the-look-slider').flickity({
        contain: true,
        cellAlign: 'left',
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true
    });

    if(window.outerWidth < 991) {
      $('.featured-blog--grid.featured-blog-wrap').flickity({
          contain: true,
          cellAlign: 'left',
          freeScroll: false,
          contain: true,
          prevNextButtons: false,
          pageDots: true,
          wrapAround: true
      });
    }


    document.querySelector('.product-form--add-to-cart').addEventListener('click', function() {
    // Get values from the gift card form
    var giftCardName = document.getElementById('gift-card-name').value;
    var giftCardMessage = document.getElementById('gift-card-message').value;

    // Set the values to the hidden input fields
    document.querySelector('input[name="properties[Name]"]').value = giftCardName;
    document.querySelector('textarea[name="properties[Message]"]').value = giftCardMessage;
  });



  
});
